/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** The format of data uploaded by the operation that created this artifact */
export type UploadDataFormat = "Blocks";

/** Supported volume storage types */
export type StorageType =
  | "AD"
  | "EBS"
  | "EFS"
  | "GPD"
  | "Cinder"
  | "Generic"
  | "CSI"
  | "FCD"
  | "Portworx"
  | "ShareableVolume";

/** The type of selector */
export type SelectorType =
  | "label"
  | "app"
  | "protectedObject"
  | "artifact"
  | "namespace";

/** succeeded iff all associated jobs were successful */
export type RestorePointStatus = "failed" | "succeeded";

/** Type of protected object e.g. Kubernetes Deployment */
export type ProtectedObjectType =
  | "Deployment"
  | "DeploymentConfig"
  | "StatefulSet"
  | "Namespace"
  | "VirtualMachine";

/** Current state of an upgrade */
export type PolicyUpgradeState =
  | "Unavailable"
  | "Current"
  | "UpgradePending"
  | "UpgradeRequired";

/** Kinds of objects to be restored */
export type PartialRestorePart = "Data";

/** Supported object stores */
export type ObjectStoreType =
  | "GCS"
  | "S3"
  | "Azure"
  | "TmpDir"
  | "VeeamVault"
  | "VeeamVaultAWS"
  | "VeeamVaultAzure";

/** The status of the manifest */
export type ManifestStatus =
  | "Uninitialized"
  | "Running"
  | "Failed"
  | "Succeeded"
  | "Skipped"
  | "Cancelled";

/** The type of manifest entry */
export type ManifestEntryType =
  | "Artifact"
  | "ArtifactReference"
  | "ArtifactReferenceGroup";

/** Log level severities */
export type LogLevelType = "debug" | "info" | "warn" | "error";

/** The location type */
export type LocationType = "ImageRepo" | "FileStore" | "ObjectStore" | "VBR";

/** Provider of keyless auth in cluster */
export type KeylessAuthProviderType = "AzureManagedIdentity";

/** Status of Azure keyless auth in cluster */
export type KeylessAuthAZStatusType =
  | "Unknown"
  | "Unavailable"
  | "Disabled"
  | "Enabled";

/** The type of the kanister artifact object */
export type KanisterArtifactType =
  | "Snapshot"
  | "DataServiceSnapshot"
  | "KandoKopiaSnapshot"
  | "Export"
  | "VBRSpecSnapshot"
  | "AppConfigOnlySpecSnapshot";

/** k8s object type */
export type K8SObjectType =
  | "deployment"
  | "deploymentconfig"
  | "route"
  | "statefulset"
  | "persistentvolumeclaim"
  | "service"
  | "blueprint"
  | "blueprintbinding"
  | "profile"
  | "namespace"
  | "secret"
  | "configmap"
  | "ingress"
  | "networkpolicy"
  | "runaction"
  | "backupaction"
  | "restoreaction"
  | "importaction"
  | "exportaction"
  | "retireaction"
  | "reportaction"
  | "upgradeaction"
  | "batchrestoreaction"
  | "stageaction"
  | "validateaction"
  | "restorepoint"
  | "policy"
  | "policypreset"
  | "unstructured"
  | "storageclass"
  | "customresourcedefinition"
  | "clusterrole"
  | "pod"
  | "backupclusteraction"
  | "restoreclusteraction"
  | "rolebinding"
  | "clusterrolebinding"
  | "storagerepository"
  | "virtualmachine"
  | "virtualmachineinstance"
  | "serviceaccount"
  | "role"
  | "job"
  | "kastendrreview"
  | "kastendrrestore"
  | "virtualmachineclusterinstancetype"
  | "virtualmachineclusterpreference";

/** Current state of the Job */
export type JobStatus =
  | "pending"
  | "planned"
  | "running"
  | "attemptFailed"
  | "waiting"
  | "failed"
  | "succeeded"
  | "skipped"
  | "cancelled";

/** Current state of the Job phase */
export type JobPhaseStatus =
  | "pending"
  | "planned"
  | "running"
  | "failed"
  | "succeeded";

/** The type of filter */
export type FilterType =
  | "policy"
  | "app"
  | "subordinates"
  | "status"
  | "action";

/** The type of encryption key according to its intended usage */
export type EncryptionKeyIntent =
  | "masterKey"
  | "migrationKey"
  | "storeKey"
  | "standaloneStoreKey";

/** EBS Volume type */
export type EBSVolumeType = "standard" | "gp2" | "io1" | "sc1" | "st1";

/** Whether a manifest should be executed after planning */
export type DryRunType = "Run" | "DryRun";

/** Data Service type */
export type DataServiceType = "postgres";

/** Data Service manager type */
export type DataServiceManagerType = "googleCloudSql" | "awsrds" | "k10";

/**
 * Compliance state of the object this label was applied to.
 * Unmanaged: This object is not covered by any k10 policy
 * NonCompliant: System state is not in compliance with one or more policies
 *   covering this object
 * Compliant: System state is in compliance with all policies covering this
 *   object
 */
export type ComplianceState = "Unmanaged" | "NotCompliant" | "Compliant";

/** The type of object we've created */
export type ArtifactType =
  | "Volume"
  | "Snapshot"
  | "Kanister"
  | "Manifest"
  | "Spec"
  | "DataService"
  | "EncryptionKey"
  | "Repository"
  | "Intent"
  | "LinkedVbrServer"
  | "VMSnapshot";

/** The type of source object */
export type ArtifactSourceType = "ProtectedObject" | "Artifact";

/** Scheme used to group application components */
export type AppType = "namespace" | "virtualMachine" | "helm";

/** The action to be performed on a protected object when a task executes */
export type Action =
  | "backup"
  | "manualSnapshot"
  | "migrateReceive"
  | "migrateSend"
  | "restore"
  | "snapshot"
  | "retire"
  | "report"
  | "upgrade"
  | "batchRestore"
  | "stage"
  | "validate";

/** Access right flag for requested resource/permission */
export type AccessRightResponse = UserPermissionFlag;

/** Response to browser request for action details */
export type ActionDetailsResponse = K10Action;

/** Response for K10 actions summary request */
export type ActionsSummaryResponse = ActionsListSummary;

/** Response for list of app-policies */
export type AppPoliciesResponse = AppPolicies;

/** Response to requesting application details */
export type ApplicationDetailsResponse = Application;

/** Response for listArtifacts requests */
export type ArtifactListResponse = ArtifactList;

/** Response for listArtifacts requests with a continuation token */
export type ArtifactListWithContinuationResponse = ArtifactListWithContinuation;

/** Response for artifact requests */
export type ArtifactResponse = Artifact;

/** Response for streamArtifacts requests */
export type ArtifactStreamResponse = ArtifactEventList;

/** Response for listing all the assigned Veeam Vaults for the cluster */
export type AssignedVeeamVaultsResponse = Array<AssignedVeeamVault>;

/**
 * Public keys for auth token
 * @format binary
 */
export type AuthCertsResponse = Blob;

/** Token status check successful */
export type AuthStatusResponse = any;

/** Response for getAuthType requests */
export type AuthTypeResponse = string;

/** Response for authUser requests */
export type AuthUserResponse = AuthUser;

/** BackupAction response */
export type BackupActionResponse = BackupActionP;

/** BackupClusterAction response */
export type BackupClusterActionResponse = BackupClusterActionP;

/** err.Error() returned directly */
export type BasicError = string;

/** BatchRestoreAction response */
export type BatchRestoreActionResponse = BatchRestoreActionP;

/** BlueprintBinding list response */
export type BlueprintBindingListResponse = BlueprintBindingList;

/** Response for BlueprintBinding requests */
export type BlueprintBindingResponse = BlueprintBinding;

/** Response, after blueprint is created */
export type BlueprintCreateResponse = BlueprintCreate;

/** Blueprint list response */
export type BlueprintListResponse = BlueprintList;

/** Bootstrap info response */
export type BootstrapInfoResponse = BootstrapInfoList;

/** Bootstrap list response */
export type BootstrapListResponse = BootstrapList;

/** Bootstrap operation response */
export type BootstrapResponse = Bootstrap;

/** GetBucketProperties response */
export type BucketPropertiesResponse = BucketProperties;

/** CancelAction response */
export type CancelActionResponse = CancelActionP;

/** Catalog size */
export type CatalogFileSizeResponse = CatalogFileSize;

/** Response for listClusters requests */
export type ClusterListResponse = ClusterList;

/** List cluster-scope resources details response */
export type ClusterResourcesDetailsResponse = K8SObjectListWithContinuation;

/** ClusterRestorePoint API details response */
export type ClusterRestorePointDetailsResponse = ClusterRestorePointAPI;

/** ClusterRestorePointObject list response */
export type ClusterRestorePointObjectListResponse =
  ClusterRestorePointObjectList;

/** ClusterRoleBinding list response */
export type ClusterRoleBindingListResponse = ClusterRoleBindingList;

/** ClusterRoleBinding operation response */
export type ClusterRoleBindingResponse = ClusterRoleBinding;

/** ClusterRole list response */
export type ClusterRoleCRListResponse = ClusterRoleCRList;

/** ClusterRole list response */
export type ClusterRoleListResponse = ClusterRoleList;

/** ClusterRole operation response */
export type ClusterRoleResponse = ClusterRole;

/** General response for compliance requests */
export type ComplianceResponse = Compliance;

/** ConfigMap K8s API response */
export type ConfigMapResponse = ConfigMap;

/** Response for a create K10 DR passphrase secret request */
export type CreateDRSecretResponse = K8SObject;

/** Response to creating a namespace */
export type CreateNamespaceResponse = NamespaceInfo;

/** Response for K10 DR restore status */
export type DRRestoreResponse = DRRestoreStatus;

/** Response for available K10 DR snapshots after validating the repository */
export type DRValidationResponse = DRValidationStatus;

/** Response to browswer request for actions */
export type DashboardActionsResponse = DashboardActionList;

/** Response to BFF request for UI compliance data */
export type DashboardComplianceResponse = DashboardComplianceData;

/** Response to browser request for subordinate actions */
export type DashboardSubordinateActionsResponse = DashboardActionList;

/** Decrypt data response */
export type DecryptDataResponse = DecryptedData;

/** Delete license response */
export type DeleteLicenseResponse = DeleteLicense;

/** Response from a derive key request */
export type DeriveKeyResponse = DerivedKey;

/** Detailed Error */
export type DetailedError = Error;

/** Distribution list response */
export type DistributionListResponse = DistributionList;

/** Distribution operation response */
export type DistributionResponse = Distribution;

/** Reponse containing EULA text */
export type EULAResponse = EULAText;

/** Encrypt data response */
export type EncryptDataResponse = EncryptedData;

/** Encrypt data with random purpose response */
export type EncryptDataWithRandomPurposeResponse = EncryptedDataWithKeyDetails;

/** Passkey list response */
export type EncryptionKeyListResponse = EncryptionKeyList;

/** Response for an encryption key request */
export type EncryptionKeyResponse = EncryptionKey;

/** Event list response */
export type EventListResponse = EventList;

/** General response for event requests */
export type EventResponse = EventGroup;

/** ExportAction response */
export type ExportActionResponse = ExportActionP;

/** General Error */
export type GeneralError = ErrorDetail;

/** Response for a get K10 DR passphrase secret request */
export type GetDRSecretResponse = K8SObject;

/** Response of get license */
export type GetLicenseRepsonse = License;

/** GetLimiterTokens response */
export type GetLimiterTokensResponse = LimiterResponse;

/** Response for a health check request */
export type HealthResponse = ServiceInfo;

/** Response for hold requests */
export type HoldResponse = HoldInfo;

/** Response for import details request */
export type ImportDetailsResponse = string;

/** Response containing a list of IndexValueList with a continuation token */
export type IndexValueWithContinuationResponse = IndexValueListWithContinuation;

/** Job list response */
export type JobListResponse = JobList;

/** General response for job requests */
export type JobResponse = Job;

/** Response contains joinToken */
export type JoinTokenResponse = JoinTokenInfo;

/** Response contains list of joinTokens */
export type JoinTokensListResponse = JoinTokenList;

/** K10ClusterRoleBinding list response */
export type K10ClusterRoleBindingListResponse = K10ClusterRoleBindingList;

/** K10ClusterRoleBinding operation response */
export type K10ClusterRoleBindingResponse = K10ClusterRoleBinding;

/** K10ClusterRole list response */
export type K10ClusterRoleListResponse = K10ClusterRoleList;

/** K10ClusterRole operation response */
export type K10ClusterRoleResponse = K10ClusterRole;

/** Response for a K10 health check request */
export type K10HealthCheckResponse = K10HealthCheck;

/** General response for K8s object create requests */
export type K8SObjectCreateResponse = K8SObject;

/** Keyless auth get response */
export type KeylessAuthResponse = KeylessAuth;

/** Last used value of ResourceVersion */
export interface LastResourceVersionResponse {
  /** @format int64 */
  resourceVersion: number;
}

/** Response for create license request */
export type LicenseCreatedResponse = LicenseResponse;

/** Response to licensing status requests */
export type LicenseStatusResponse = LicenseStatus;

/** Response for update license request */
export type LicenseUpdatedResponse = LicenseResponse;

/** Namespace list response for fetching the names of all namespaces in the system */
export type ListAllNamespacesResponse = NamespaceInfoList;

/** Response for all the licenses */
export type ListLicensesResponse = ListLicenses;

/** GetPolicyUpgradeStatus response */
export type ListPolicyUpgradeStatusResponse = Array<PolicyUpgradeStatus>;

/** Login Successful */
export type LoginResponse = any;

/** Logout Successful */
export type LogoutResponse = any;

/** Health of the multi-cluster messaging connection */
export type MCConnectionHealthResponse = K10HealthCheckEntry;

/** Last active time of the multi-cluster messaging connection */
export type MCConnectionLastActiveResponse = TimeStamp;

/** Response contains join status and cluster info */
export type MCInfoResponse = MCInfo;

/** Response to multi-cluster license usage requests */
export type MCLicenseUsageResponse = MCLicenseUsage;

/** Multi-cluster metrics */
export type MCMetricsResponse = MCMetrics;

/** General response for manifest requests */
export type ManifestResponse = ReferenceId;

/** Response for a metering stats request */
export type MeteringStatsResponse = MeteringStats;

/** Monitoring summary response */
export type MonitoringSummaryResponse = MonitoringSummary;

/** Namespace list response for fetching namespaces that can be managed by K10 */
export type NamespaceListResponse = NamespaceListResponseData;

/** Count of excluded nodes with a workload PVC mounted */
export type NodeExcludedViolationResponse = number;

/** Highest number of nodes seen per month */
export type NodeUsageHistoryResponse = NodeUsageHistory;

/** OIDC login successful */
export type OIDCRedirectResponse = any;

/** Passkey list response */
export type PasskeyListResponse = PasskeyList;

/** Response for a passkey request */
export type PasskeyResponse = PasskeyP;

/** Policies' details response */
export type PoliciesDetailsResponse = PoliciesDetailsList;

/** Response to request for all the policies that select an application */
export type PoliciesSelectingAnAppResponse = Array<PolicySelectingAnApp>;

/** Policy list response */
export type PolicyCRListResponse = PolicyCRList;

/** General response for policy requests */
export type PolicyCRResponse = PolicyCR;

/** PolicyPreset list response */
export type PolicyPresetListResponse = PolicyPresetList;

/** Response for PolicyPreset requests */
export type PolicyPresetResponse = PolicyPreset;

/** Profile list response */
export type ProfileCRListResponse = ProfileCRList;

/** Response for profile requests */
export type ProfileCRResponse = ProfileCR;

/** List of Prometheus scrape targets */
export type PrometheusScrapeTargetsResponse = PrometheusScrapeTargets;

/** General response containing a list of ProtectedObject items */
export type ProtectedObjectListResponse = ProtectedObjectList;

/** General response for ProtectedObject requests */
export type ProtectedObjectResponse = ProtectedObject;

/** List of raw metrics pushed into PushAggregator */
export type PushedMetricsResponse = Array<PushedMetricFamily>;

/** General response for job queue requests */
export type QueuedJobResponse = QueuedJob;

/** Redirect with temporary token successful */
export type RedirectResponse = any;

/** Response containing a reference to a K8s object */
export type ReferenceResponse = ReferenceP;

/** Region list */
export type RegionListResponse = Array<string>;

/** ReportAction response */
export type ReportActionResponse = ReportActionP;

/** A list of Reports. */
export type ReportListResponse = Array<Report>;

/** A single Report. */
export type ReportResponse = Report;

/** Usage in object store repos */
export type ReposUsageResponse = ReposUsage;

/**
 * URL to go to with temporary authentication
 * @format string
 */
export type RequestRedirectResponse = string;

/** List resources response */
export type ResourcesResponse = GroupVersionResourceList;

/** Response for restore action dry run */
export type RestoreActionDryRunResponse = RestorePointContentAPI;

/** RestoreClusterAction response */
export type RestoreClusterActionResponse = RestoreClusterActionP;

/** RestorePointContent API details response */
export type RestorePointContentDetailsResponse = RestorePointContentAPI & {
  /** Warning message about potential restore point issues. Empty if no issues are detected. */
  warning?: string;
};

/** RestorePointContentObject list response */
export type RestorePointContentObjectListResponse =
  RestorePointContentObjectList;

/** RestorePointContentObject per app list response */
export type RestorePointContentObjectPerAppListResponse =
  RestorePointContentObjectPerAppList;

/** RestorePoint create response */
export type RestorePointCreateResponse = RestorePointObjectList;

/** RestorePoint API details response */
export type RestorePointDetailsResponse = RestorePointAPI & {
  /** Warning message about potential restore point issues. Empty if no issues are detected. */
  warning?: string;
};

/** RestorePointObject list response */
export type RestorePointObjectListResponse = RestorePointObjectList;

/** RestorePointObject per app list response */
export type RestorePointObjectPerAppListResponse = RestorePointObjectPerAppList;

/** Response for list all the restore points from cluster request */
export type RestorePointsListResponse = RestorePointsList;

/** RoleBinding list response */
export type RoleBindingListResponse = RoleBindingList;

/** RoleBinding operation response */
export type RoleBindingResponse = RoleBinding;

/** Role list response */
export type RoleCRListResponse = RoleCRList;

/** Role list response */
export type RoleListResponse = RoleList;

/** Role operation response */
export type RoleResponse = Role;

/** Response to browswer request for runaction details */
export type RunActionDetailsResponse = RunAction;

/** RunAction response */
export type RunActionResponse = RunActionP;

/** Response for list of all selectors */
export type SelectorListResponse = SelectorList;

/** List of objects that match a particular selection criteria. Only object identifier are included in the response */
export type SelectorResponse = ProtectedObjectList;

/** Snapshot storage usage */
export type SnapshotStorageUsageResponse = SnapshotStorageUsage;

/** List of apps, covered by the policy, and their current and future restore points */
export type SnapshotsSchedulesResponse = SnapshotsSchedules;

/** Response for BFF snapshot summary requests. */
export type SnapshotsSummaryResponse = SnapshotsSummary;

/** Response for Catalog snapshot stats requests. */
export type StatsResponse = Stats;

/** Storage class list response */
export type StorageClassListResponse = StorageClassList;

/** Storage class response */
export type StorageClassResponse = StorageClass;

/** StorageRepository details response */
export type StorageRepositoryDetailsResponse = StorageRepositoryAPI;

/** StorageRepository list response */
export type StorageRepositoryListResponse = StorageRepositoryList;

/** Storage usage metrics */
export type StorageSnapshotSizeResponse = PromRangeQueryResponse;

/** Response for BFF storage summary requests. */
export type StorageSummaryResponse = StorageSummary;

/** Store instance identifier */
export type StoreInstanceResponse = ItemId;

/** System information */
export type SystemInfoResponse = SystemInfo;

/** Transform operation Response */
export type TransformResponse = JSONObject;

/** Single transformSet response */
export interface TransformSetListResponse {
  /** List of custom transformSets */
  customTransformSets?: TransformSetList;
  /** List of transformSet examples */
  exampleTransformSets?: TransformSetList;
}

/** Single transformSet response */
export type TransformSetResponse = TransformSet;

/** UpgradeAction response */
export type UpgradeActionResponse = UpgradeActionP;

/** System information */
export type UpgradeInfoResponse = UpgradeInfo;

/** User information */
export type UserInfoResponse = UserInfo;

/** Response for a VM details */
export type VMDetailsResponse = VMDetails;

/** Response to request a set of VMs */
export type VMsToAnnotateResponse = Array<VMToAnnotateResponse>;

/** Temporary AWS credentials in the EKS pod-identity format */
export type VeeamVaultAwsCredentialsResponse = VeeamVaultAwsCredentials;

/** Response for registration status with Veeam Vault */
export type VeeamVaultRegistrationResponse = VeeamVaultRegistrationStatus;

/** Response for registration secrets to use in registration against Veeam Vault */
export type VeeamVaultRegistrationSecretsResponse =
  VeeamVaultRegistrationSecrets;

/** Response for listing all the virtual machines in the cluster */
export type VirtualMachineListResponse = VirtualMachineList;

/**
 * API keys, when set, are unique identifiers for a number of API Objects
 * backed by manifest.  API Objects may only have a single API key, but
 * multiple API Objects/keys may be backed by a single manifest.  These keys
 * are generated by kubernetes and take the form
 * /<API Group>/<Resource>/<Namespace>/<Name>.
 */
export type APIKey = string;

/** API object metadata */
export interface APIMeta {
  actionMeta?: ActionMetaP;
  annotations?: Array<KeyValue>;
  /** Name to use for display via K10 API */
  displayName?: string;
  /** K8s Labels (metadata.labels) */
  labels?: Array<KeyValue>;
}

/** An AWS passkey provider */
export type AWSPasskeyConfig = {
  /** The keyID of the AWS KMS passkey provider */
  keyID: string;
};

export interface ActionMetaP {
  /** @format date-time */
  scheduledTime?: string;
  subject?: {
    apiVersion?: string;
    kind?: string;
    name: string;
    namespace?: string;
  };
}

export interface ActionModifiersP {
  /** @format date-time */
  expiresAt?: string;
  restorePointID?: string;
  runNow?: boolean;
  user?: {
    extra?: Record<string, Array<string>>;
    groups?: Array<string>;
    uid?: string;
    username?: string;
  };
}

export interface ActionParametersP {
  backupClusterParameters?: {
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
  };
  backupParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    expiresAt?: string;
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    imageRepoProfile?: {
      name: string;
      namespace?: string;
    };
    profile?: {
      name: string;
      namespace?: string;
    };
  };
  batchRestoreParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    artifactOverrideProfile?: {
      name: string;
      namespace?: string;
    };
    dataOnly?: boolean;
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    overwriteExisting?: boolean;
    /** @format date-time */
    pointInTime?: string;
    profile?: {
      name: string;
      namespace?: string;
    };
    restoreClusterResources?: boolean;
    restorePointsDiscoveryRange?: {
      /** @format date-time */
      end?: string;
      /** @format date-time */
      start?: string;
    };
    skipWaitForWorkloadReady?: boolean;
    subjects: Array<{
      namespace: string;
      restorePointContentName?: string;
      restorePointName?: string;
    }>;
    targetNamespace?: string;
    targetNamespacePrefix?: string;
    targetNamespaceSuffix?: string;
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
    virtualMachineParameters?: {
      harvester?: {
        overrideVolumeImages?: Record<
          string,
          {
            ignoreChecks?: boolean;
            name?: string;
            namespace?: string;
          }
        >;
      };
      preserveVMMacAddresses?: boolean;
    };
    volumeClones?: boolean;
  };
  exportParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    blockModeProfile?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    expiresAt?: string;
    exportData?: {
      enabled: boolean;
      exporterStorageClassName?: string;
      overrides?: Array<{
        enabled: boolean;
        exporterStorageClassName?: string;
        storageClassName: string;
      }>;
    };
    frequency?: string;
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    migrationToken?: {
      name: string;
      namespace?: string;
    };
    profile?: {
      name: string;
      namespace?: string;
    };
    receiveString?: string;
    volumeSnapshots?: {
      awsEbs?: {
        destinationAccount?: string;
        regions?: Array<string>;
      };
      azure?: {
        regions?: Array<string>;
        resourceGroup?: string;
      };
    };
  };
  importParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    migrationToken?: {
      name: string;
      namespace?: string;
    };
    profile?: {
      name: string;
      namespace?: string;
    };
    receiveString?: string;
  };
  reportParameters?: {
    /** @format int32 */
    statsIntervalDays?: number;
    /** @format int32 */
    statsIntervalHours?: number;
  };
  restoreClusterParameters?: {
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
  };
  restoreParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    artifactOverrideProfile?: {
      name: string;
      namespace?: string;
    };
    dataOnly?: boolean;
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    overwriteExisting?: boolean;
    /** @format date-time */
    pointInTime?: string;
    profile?: {
      name: string;
      namespace?: string;
    };
    restoreClusterResources?: boolean;
    skipWaitForWorkloadReady?: boolean;
    targetNamespace?: string;
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
    virtualMachineParameters?: {
      harvester?: {
        overrideVolumeImages?: Record<
          string,
          {
            ignoreChecks?: boolean;
            name?: string;
            namespace?: string;
          }
        >;
      };
      preserveVMMacAddresses?: boolean;
    };
    volumeClones?: boolean;
  };
  retireParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    /** @format int32 */
    retireIndex?: number;
  };
  stageParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    transformations?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
  };
  upgradeParameters?: {
    profile?: {
      name: string;
      namespace?: string;
    };
  };
  validateParameters?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    volumeDataCheckOptions?: {
      failFast?: boolean;
      verifyFilesPercent?: string;
    };
  };
}

/** Unit of work for K10 Action */
export interface ActionPhase {
  /** Any attempt > 1 indicates that phase was attempted and failed. Indicating retry */
  attempt?: number;
  /** Time stamp for an event related to an object, for example when the object was created. */
  endTime?: TimeStamp;
  /** A list of errors indicating causes for job failures */
  errors?: Array<Error>;
  /**
   * Phase name/description
   * @example "Preparing for backup"
   */
  name?: string;
  /** Time stamp for an event related to an object, for example when the object was created. */
  startTime?: TimeStamp;
  /** Current state of the Job */
  state?: JobStatus;
  /** Time stamp for an event related to an object, for example when the object was created. */
  updatedTime?: TimeStamp;
}

export interface ActionStatus {
  actionDetails?: {
    artifacts?: Array<{
      meta?: {
        dataservice?: {
          kanisterArtifacts?: Array<{
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          }>;
          meta?: {
            host?: string;
            manager?: string;
            type?: string;
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
        };
        kanister?: {
          meta?: {
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            location?: {
              fileStore?: {
                claimName?: string;
                path?: string;
                /** @format int64 */
                suppGroup?: number;
              };
              objectStore?: {
                endpoint?: string;
                name?: string;
                objectStoreType?: string;
                path?: string;
                pathType?: string;
                region?: string;
                skipSSLVerify?: boolean;
              };
              type?: string;
              vbr?: {
                repoId?: string;
                repoName?: string;
                serverAddress?: string;
              };
            };
            profileRef?: {
              apiVersion?: string;
              kind?: string;
              name: string;
              namespace?: string;
            };
            storageUsage?: {
              /** @format int64 */
              count: number;
              /** @format int64 */
              freed: number;
              /** @format int64 */
              logical: number;
              /** @format int64 */
              physical: number;
            };
            type?: string;
            uploadDataFormat?: string;
            /** @format date-time */
            uploadEndTime?: string;
            version?: string;
          };
          name?: string;
          values?: Array<{
            key?: string;
            value?: string;
          }>;
        };
        snapshot?: {
          /** @format date-time */
          creationTime?: string;
          encrypted?: boolean;
          id?: string;
          k8sSnapshot?: {
            driver?: string;
            handle?: string;
            volumeSnapshotClassName?: string;
          };
          k8sVolume?: {
            name?: string;
            pvcName?: string;
            storageClassName?: string;
          };
          region?: string;
          /** @format int64 */
          size?: number;
          sizeUnit?: string;
          tags?: Array<{
            key?: string;
            value?: string;
          }>;
          type?: string;
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        spec?: {
          config?: string;
          group?: string;
          name?: string;
          namespace?: string;
          resource?: string;
          type?: string;
          version?: string;
        };
        vmSnapshot?: {
          cbtEligible?: boolean;
          cbtPvcNames?: Array<string>;
          snapshotConsistency?: string;
          vmStatus?: string;
        };
        volume?: {
          attributes: Array<{
            key?: string;
            value?: string;
          }>;
          az?: string;
          /** @format date-time */
          creationTime?: string;
          encrypted?: boolean;
          id?: string;
          /** @format int64 */
          iops?: number;
          /** @format int64 */
          size?: number;
          sizeUnit?: string;
          tags?: Array<{
            key?: string;
            value?: string;
          }>;
          type?: string;
          users?: Array<string>;
          volumeType?: string;
        };
      };
      source?: {
        apiVersion?: string;
        kind?: string;
        name: string;
        namespace?: string;
      };
    }>;
    phases?: Array<{
      /** @format int64 */
      attempt?: number;
      /** @format date-time */
      endTime?: string;
      errors?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      name?: string;
      /** @format date-time */
      startTime?: string;
      state?: string;
      /** @format date-time */
      updatedTime?: string;
      volumeOperations?: Array<{
        dataFormat?: string;
        driver?: string;
        exportDirective?: string;
        namespace: string;
        operation: string;
        pvcName: string;
        snapshotId?: string;
        storageClass?: string;
        storageType?: string;
        volumeSnapshotClass?: string;
      }>;
    }>;
  };
  actionPlan?: {
    phases?: Record<
      string,
      {
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        groups?: Record<
          string,
          {
            artifacts?: Array<{
              meta?: {
                dataservice?: {
                  kanisterArtifacts?: Array<{
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  }>;
                  meta?: {
                    host?: string;
                    manager?: string;
                    type?: string;
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                };
                kanister?: {
                  meta?: {
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    location?: {
                      fileStore?: {
                        claimName?: string;
                        path?: string;
                        /** @format int64 */
                        suppGroup?: number;
                      };
                      objectStore?: {
                        endpoint?: string;
                        name?: string;
                        objectStoreType?: string;
                        path?: string;
                        pathType?: string;
                        region?: string;
                        skipSSLVerify?: boolean;
                      };
                      type?: string;
                      vbr?: {
                        repoId?: string;
                        repoName?: string;
                        serverAddress?: string;
                      };
                    };
                    profileRef?: {
                      apiVersion?: string;
                      kind?: string;
                      name: string;
                      namespace?: string;
                    };
                    storageUsage?: {
                      /** @format int64 */
                      count: number;
                      /** @format int64 */
                      freed: number;
                      /** @format int64 */
                      logical: number;
                      /** @format int64 */
                      physical: number;
                    };
                    type?: string;
                    uploadDataFormat?: string;
                    /** @format date-time */
                    uploadEndTime?: string;
                    version?: string;
                  };
                  name?: string;
                  values?: Array<{
                    key?: string;
                    value?: string;
                  }>;
                };
                snapshot?: {
                  /** @format date-time */
                  creationTime?: string;
                  encrypted?: boolean;
                  id?: string;
                  k8sSnapshot?: {
                    driver?: string;
                    handle?: string;
                    volumeSnapshotClassName?: string;
                  };
                  k8sVolume?: {
                    name?: string;
                    pvcName?: string;
                    storageClassName?: string;
                  };
                  region?: string;
                  /** @format int64 */
                  size?: number;
                  sizeUnit?: string;
                  tags?: Array<{
                    key?: string;
                    value?: string;
                  }>;
                  type?: string;
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                spec?: {
                  config?: string;
                  group?: string;
                  name?: string;
                  namespace?: string;
                  resource?: string;
                  type?: string;
                  version?: string;
                };
                vmSnapshot?: {
                  cbtEligible?: boolean;
                  cbtPvcNames?: Array<string>;
                  snapshotConsistency?: string;
                  vmStatus?: string;
                };
                volume?: {
                  attributes: Array<{
                    key?: string;
                    value?: string;
                  }>;
                  az?: string;
                  /** @format date-time */
                  creationTime?: string;
                  encrypted?: boolean;
                  id?: string;
                  /** @format int64 */
                  iops?: number;
                  /** @format int64 */
                  size?: number;
                  sizeUnit?: string;
                  tags?: Array<{
                    key?: string;
                    value?: string;
                  }>;
                  type?: string;
                  users?: Array<string>;
                  volumeType?: string;
                };
              };
              source?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
            }>;
            objects?: Array<string>;
            reference?: Array<{
              name: string;
              namespace?: string;
            }>;
          }
        >;
        name?: string;
        transforms?: Array<{
          comment?: string;
          json: Array<{
            from?: string;
            op: string;
            path?: string;
            regex?: string;
            value?: string;
          }>;
          name?: string;
          subject?: {
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          };
          transformSetRef?: {
            name: string;
            namespace?: string;
          };
        }>;
      }
    >;
  };
  /** @format date-time */
  endTime?: string;
  error?: {
    cause?: string;
    fields?: Array<{
      name?: string;
      value?: string;
    }>;
    message?: string;
    retriable?: boolean;
  };
  exceptions?: Array<{
    cause?: string;
    fields?: Array<{
      name?: string;
      value?: string;
    }>;
    message?: string;
    retriable?: boolean;
  }>;
  /** @format int64 */
  progress?: number;
  progressDetails?: {
    /**
     * @format int64
     * @min 0
     */
    completedVolumes: number;
    /**
     * @format int64
     * @min 0
     */
    processedBytes: number;
    /**
     * @format int64
     * @min 0
     */
    processingRate: number;
    /**
     * @format int64
     * @min 0
     */
    readBytes: number;
    /**
     * @format int64
     * @min 0
     */
    totalBytes: number;
    /**
     * @format int64
     * @min 0
     */
    totalVolumes: number;
    /**
     * @format int64
     * @min 0
     */
    transferredBytes: number;
    /** @format date-time */
    updatedTime: string;
  };
  restorePoint?: {
    name: string;
    namespace?: string;
  };
  result?: {
    name: string;
    namespace?: string;
  };
  /** @format date-time */
  startTime?: string;
  state?: string;
}

/** Summary of K10 actions */
export interface ActionsListSummary {
  averageDuration: number;
  cancelledCount: number;
  completedCount: number;
  count: number;
  failedCount: number;
  pendingCount: number;
  runningCount: number;
  skippedCount: number;
}

/** Stable identifier for an application */
export interface AppIdentifier {
  /** "Nullable field used to identify an app with grouping type 'Namespace'" */
  namespace?: {
    /** Namespace name */
    name?: string;
  };
  /** Scheme used to group application components */
  type?: AppType;
  /** "Nullable field used to identify an app with grouping type 'VirtualMachine'" */
  virtualMachine?: {
    /** Virtual machine name */
    name?: string;
    /** Namespace of the virtual machine */
    namespace?: string;
  };
}

/** A map of policies per app */
export interface AppPolicies {
  appPolicies?: AppPoliciesMap;
}

export type AppPoliciesMap = Record<string, Array<string>>;

/** Represents object reference and Blueprint name */
export interface AppResourceBlueprintRef {
  /** Blueprint name */
  blueprint?: string;
  /** Describes a K8s object */
  object?: K8SObject;
}

export interface AppVolume {
  /** Name of the volume used in the workload spec */
  name?: string;
  /** Name of the PVC this volume references */
  persistentVolumeClaimName?: string;
  /** Name of the Pod the volume is currently bound to */
  podName?: string;
  /**
   * The size of the volume, in sizeUnits
   * @format int64
   */
  size?: number;
  /** The unit of size of the volume. The default size is GiB */
  sizeUnit?: string;
  /** Storage type for this volume */
  type?: StorageType;
}

export interface Application {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    namespace?: {
      name?: string;
    };
  };
  status?: {
    appDetails?: {
      components?: {
        config?: Array<{
          annotations?: Record<string, string>;
          apiVersion?: string;
          boundBlueprints?: Array<{
            bindingRef: {
              name: string;
              namespace?: string;
            };
            name: string;
            namespace: string;
          }>;
          group?: string;
          kind?: string;
          name?: string;
          namespace?: string;
          resource?: string;
        }>;
        customresources?: Array<{
          annotations?: Record<string, string>;
          apiVersion?: string;
          boundBlueprints?: Array<{
            bindingRef: {
              name: string;
              namespace?: string;
            };
            name: string;
            namespace: string;
          }>;
          group?: string;
          kind?: string;
          name?: string;
          namespace?: string;
          resource?: string;
        }>;
        dataservices?: Array<{
          host?: string;
          manager?: string;
          type?: string;
        }>;
        network?: Array<{
          annotations?: Record<string, string>;
          apiVersion?: string;
          boundBlueprints?: Array<{
            bindingRef: {
              name: string;
              namespace?: string;
            };
            name: string;
            namespace: string;
          }>;
          group?: string;
          kind?: string;
          name?: string;
          namespace?: string;
          resource?: string;
        }>;
        volumes?: Array<{
          annotations?: Record<string, string>;
          apiVersion?: string;
          boundBlueprints?: Array<{
            bindingRef: {
              name: string;
              namespace?: string;
            };
            name: string;
            namespace: string;
          }>;
          group?: string;
          kind?: string;
          name?: string;
          namespace?: string;
          persistentVolumeClaimName?: string;
          podName?: string;
          resource?: string;
          /** @format int64 */
          size?: number;
          type?: string;
        }>;
        workloads?: Array<{
          annotations?: Record<string, string>;
          apiVersion?: string;
          boundBlueprints?: Array<{
            bindingRef: {
              name: string;
              namespace?: string;
            };
            name: string;
            namespace: string;
          }>;
          group?: string;
          kind?: string;
          name?: string;
          namespace?: string;
          resource?: string;
        }>;
      };
      labels?: Array<{
        type?: string;
        value?: string;
      }>;
    };
  };
}

/** Artifact created as the result of an action in a job */
export interface Artifact {
  /** metrics accumulated from deleted children */
  accumulatedStats?: Stats;
  /** The job that created this artifact */
  createdBy?: {
    /** Item identifier */
    job?: ItemId;
    /** Name of phase within a Job */
    phase?: JobPhaseName;
  };
  /** Time stamp for an event related to an object, for example when the object was created. */
  creationTime?: TimeStamp;
  /** Time stamp for an event related to an object, for example when the object was created. */
  destructionTime?: TimeStamp;
  /**
   * Artifact identifier
   * @format uuid
   * @example "d290f1ee-6c54-4b01-90e6-d701748f0851"
   */
  id?: string;
  /** Status and state for using artifact as intent log entry */
  intent?: ArtifactIntentP;
  /** Information about VBR server to where k10 is added */
  linkedVbrServer?: LinkedVbrServer;
  /** The ID of the manifest that references this artifact */
  manifestID?: ItemId;
  meta?: {
    /** Snapshot of a DataService */
    dataservice?: DataServiceSnapshot;
    /** An encrypted encryption key */
    encryptionKey?: EncryptionKey;
    kanister?: KanisterArtifact;
    /** Labels inherited from the parent manifest artifact (e.g. app type, policy name) */
    labels?: Array<KeyValue>;
    /**
     * A Manifest captures the inputs to and results from a job. Every job
     * processes a manifest and may result in multiple artifacts or child
     * manifests. These artifacts are listed in a Manifest. The Manifest is
     * created initially with state of unitialized and submitted for execution.
     * Manifest state is set to running when the job begins. If the job
     * succeeds its status is succeeded, and if the job fails, its status is
     * marked as failed.
     */
    manifest?: Manifest;
    repository?: Repository;
    /** A snapshot created by k10 */
    snapshot?: Snapshot;
    /** The configuration of a K8s object */
    spec?: Spec;
    /** The type of object we've created */
    type?: ArtifactType;
    /** A VM snapshot created by k10 */
    vmSnapshot?: VMSnapshot;
    /** A storage provider volume tracked by k10 */
    volume?: Volume;
  };
  resourceVersion?: ResourceVersion;
  /** Artifact or object from which this artifact was derived */
  source?: {
    /** Nullable field indicating a source Artifacts if one exists */
    artifact?: {
      /** Item identifier */
      id?: ItemId;
    };
    /** Nullable field indicating a source ProtectedObject if one exists */
    protectedObject?: {
      /** The Name of the k8s object being protected */
      name?: string;
      /** The namespace of the object being protected */
      namespace?: string;
      /** k8s object type */
      type?: K8SObjectType;
    };
    /** The type of source object */
    type?: ArtifactSourceType;
  };
}

/** Represents a change in an Artifact */
export interface ArtifactEvent {
  /** Artifact created as the result of an action in a job */
  new?: Artifact;
  /** Artifact created as the result of an action in a job */
  old?: Artifact;
  resourceVersion?: number;
}

export type ArtifactEventList = Array<ArtifactEvent>;

export interface ArtifactIntentP {
  correlator?: {
    id?: string;
    /** @format int32 */
    offset?: number;
  };
  status?: string;
}

export type ArtifactList = Array<Artifact>;

export interface ArtifactListWithContinuation {
  continuation?: string;
  items?: ArtifactList;
}

export interface AssignedVeeamVault {
  awsSpec?: {
    bucketName?: string;
    bucketRegion?: string;
  };
  azureSpec: {
    storageAccountName?: string;
    storageAccountRegion?: string;
    storageAccountRegionDisplayName?: string;
    storageContainerName?: string;
  };
  description?: string;
  immutabilityMode?: string;
  name?: string;
  productEdition?: string;
  provider?: string;
  readOnly?: boolean;
  readOnlyReason?: string;
  region?: string;
  /** @format int32 */
  reservedCapacityGB?: number;
  /** @format date-time */
  validTill: string;
  vaultId?: string;
}

/** authv1.UserInfo data structure without Extra field, used to represent a user in k8s */
export interface AuthUser {
  groups?: Array<string>;
  uid?: string;
  username?: string;
}

/** An Azure Key Vault passkey provider */
export type AzurePassKeyConfig = {
  /** The name of the key in Azure Key Vault */
  keyName: string;
  /** The URL of the Azure Key Vault */
  keyVaultURL: string;
  /** The version of the key in Azure Key Vault */
  keyVersion: string;
};

export interface BackupActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    expiresAt?: string;
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    imageRepoProfile?: {
      name: string;
      namespace?: string;
    };
    profile?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface BackupClusterActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

/** List of UUID to retrieve */
export type BatchIDs = Array<string>;

export interface BatchRestoreActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    artifactOverrideProfile?: {
      name: string;
      namespace?: string;
    };
    dataOnly?: boolean;
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    overwriteExisting?: boolean;
    /** @format date-time */
    pointInTime?: string;
    profile?: {
      name: string;
      namespace?: string;
    };
    restoreClusterResources?: boolean;
    restorePointsDiscoveryRange?: {
      /** @format date-time */
      end?: string;
      /** @format date-time */
      start?: string;
    };
    /** @format date-time */
    scheduledTime?: string;
    skipWaitForWorkloadReady?: boolean;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
    subjects: Array<{
      namespace: string;
      restorePointContentName?: string;
      restorePointName?: string;
    }>;
    targetNamespace?: string;
    targetNamespacePrefix?: string;
    targetNamespaceSuffix?: string;
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
    virtualMachineParameters?: {
      harvester?: {
        overrideVolumeImages?: Record<
          string,
          {
            ignoreChecks?: boolean;
            name?: string;
            namespace?: string;
          }
        >;
      };
      preserveVMMacAddresses?: boolean;
    };
    volumeClones?: boolean;
  };
  status?: {
    actionDetails?: {
      actions: {
        /** @format int32 */
        cancelledCount: number;
        /** @format int32 */
        completedCount: number;
        /** @format int32 */
        failedCount: number;
        /** @format int32 */
        pendingCount: number;
        /** @format int32 */
        runningCount: number;
        /** @format int32 */
        skippedCount: number;
        /** @format int32 */
        totalCount: number;
      };
      applicationTypes?: Array<string>;
      failedApplications?: Array<string>;
      restoredApplications: Array<string>;
      /** @format int32 */
      subjectsCount: number;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface BatchRestoreParameters {
  actionPodSpec?: {
    name: string;
    namespace?: string;
  };
  artifactOverrideProfile?: {
    name: string;
    namespace?: string;
  };
  dataOnly?: boolean;
  filters?: {
    excludeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
  };
  hooks?: {
    onFailure?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
    onSuccess?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
    preHook?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
  };
  ignoreExceptions?: boolean;
  overwriteExisting?: boolean;
  /** @format date-time */
  pointInTime?: string;
  profile?: {
    name: string;
    namespace?: string;
  };
  restoreClusterResources?: boolean;
  restorePointsDiscoveryRange?: {
    /** @format date-time */
    end?: string;
    /** @format date-time */
    start?: string;
  };
  skipWaitForWorkloadReady?: boolean;
  subjects: Array<{
    namespace: string;
    restorePointContentName?: string;
    restorePointName?: string;
  }>;
  targetNamespace?: string;
  targetNamespacePrefix?: string;
  targetNamespaceSuffix?: string;
  transforms?: Array<{
    comment?: string;
    json: Array<{
      from?: string;
      op: string;
      path?: string;
      regex?: string;
      value?: string;
    }>;
    name?: string;
    subject?: {
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    };
    transformSetRef?: {
      name: string;
      namespace?: string;
    };
  }>;
  virtualMachineParameters?: {
    harvester?: {
      overrideVolumeImages?: Record<
        string,
        {
          ignoreChecks?: boolean;
          name?: string;
          namespace?: string;
        }
      >;
    };
    preserveVMMacAddresses?: boolean;
  };
  volumeClones?: boolean;
}

export interface Blueprint {
  actions?: Record<
    string,
    {
      configMapNames?: Array<string>;
      deferPhase?: {
        args: Record<string, any>;
        func: string;
        name: string;
        objects?: Record<
          string,
          {
            apiVersion: string;
            group: string;
            kind: string;
            name: string;
            namespace?: string;
            resource: string;
          }
        >;
      };
      inputArtifactNames?: Array<string>;
      kind: string;
      name: string;
      outputArtifacts?: Record<
        string,
        {
          keyValue?: Record<string, string>;
          kopiaSnapshot?: string;
        }
      >;
      phases?: Array<{
        args: Record<string, any>;
        func: string;
        name: string;
        objects?: Record<
          string,
          {
            apiVersion: string;
            group: string;
            kind: string;
            name: string;
            namespace?: string;
            resource: string;
          }
        >;
      }>;
      secretNames?: Array<string>;
    }
  >;
  apiVersion?: string;
  kind?: string;
  metadata: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
}

/** Name of the blueprint action */
export type BlueprintActionName = string;

export interface BlueprintBinding {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec: {
    blueprintRef: {
      name: string;
      namespace?: string;
    };
    disabled?: boolean;
    resources: {
      matchAll?: Array<{
        annotations?: {
          key: string;
          operator: string;
          values?: Array<string>;
        };
        labels?: {
          key: string;
          operator: string;
          values?: Array<string>;
        };
        namespace?: {
          operator: string;
          values?: Array<string>;
        };
        type?: {
          operator: string;
          values: Array<{
            group?: string;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
      }>;
      matchAny?: Array<{
        annotations?: {
          key: string;
          operator: string;
          values?: Array<string>;
        };
        labels?: {
          key: string;
          operator: string;
          values?: Array<string>;
        };
        namespace?: {
          operator: string;
          values?: Array<string>;
        };
        type?: {
          operator: string;
          values: Array<{
            group?: string;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
      }>;
    };
  };
  status?: {
    error?: Array<string>;
    /** @format int64 */
    observedGeneration?: number;
    validation?: string;
  };
}

export type BlueprintBindingList = Array<BlueprintBinding>;

export interface BlueprintBindingSpec {
  blueprintRef: {
    name: string;
    namespace?: string;
  };
  disabled?: boolean;
  resources: {
    matchAll?: Array<{
      annotations?: {
        key: string;
        operator: string;
        values?: Array<string>;
      };
      labels?: {
        key: string;
        operator: string;
        values?: Array<string>;
      };
      namespace?: {
        operator: string;
        values?: Array<string>;
      };
      type?: {
        operator: string;
        values: Array<{
          group?: string;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
    }>;
    matchAny?: Array<{
      annotations?: {
        key: string;
        operator: string;
        values?: Array<string>;
      };
      labels?: {
        key: string;
        operator: string;
        values?: Array<string>;
      };
      namespace?: {
        operator: string;
        values?: Array<string>;
      };
      type?: {
        operator: string;
        values: Array<{
          group?: string;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
    }>;
  };
}

/** Response of blueprint create action */
export interface BlueprintCreate {
  name?: string;
  namespace?: string;
}

export interface BlueprintList {
  apiVersion?: string;
  items: Array<{
    actions?: Record<
      string,
      {
        configMapNames?: Array<string>;
        deferPhase?: {
          args: Record<string, any>;
          func: string;
          name: string;
          objects?: Record<
            string,
            {
              apiVersion: string;
              group: string;
              kind: string;
              name: string;
              namespace?: string;
              resource: string;
            }
          >;
        };
        inputArtifactNames?: Array<string>;
        kind: string;
        name: string;
        outputArtifacts?: Record<
          string,
          {
            keyValue?: Record<string, string>;
            kopiaSnapshot?: string;
          }
        >;
        phases?: Array<{
          args: Record<string, any>;
          func: string;
          name: string;
          objects?: Record<
            string,
            {
              apiVersion: string;
              group: string;
              kind: string;
              name: string;
              namespace?: string;
              resource: string;
            }
          >;
        }>;
        secretNames?: Array<string>;
      }
    >;
    apiVersion?: string;
    kind?: string;
    metadata: {
      annotations?: Record<string, string>;
      /** @format date-time */
      creationTimestamp?: string;
      /** @format int64 */
      deletionGracePeriodSeconds?: number;
      /** @format date-time */
      deletionTimestamp?: string;
      finalizers?: Array<string>;
      generateName?: string;
      /** @format int64 */
      generation?: number;
      labels?: Record<string, string>;
      managedFields?: Array<{
        apiVersion?: string;
        fieldsType?: string;
        fieldsV1?: {};
        manager?: string;
        operation?: string;
        subresource?: string;
        /** @format date-time */
        time?: string;
      }>;
      name?: string;
      namespace?: string;
      ownerReferences?: Array<{
        apiVersion: string;
        blockOwnerDeletion?: boolean;
        controller?: boolean;
        kind: string;
        name: string;
        uid: string;
      }>;
      resourceVersion?: string;
      selfLink?: string;
      uid?: string;
    };
  }>;
  kind?: string;
  metadata: {
    continue?: string;
    /** @format int64 */
    remainingItemCount?: number;
    resourceVersion?: string;
    selfLink?: string;
  };
}

export interface Bootstrap {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    clusters?: Record<
      string,
      {
        apiserver?: {
          insecureTLS?: boolean;
          url: string;
        };
        context?: string;
        generateName?: string;
        k10?: {
          ingress?: {
            insecureTLS?: boolean;
            url: string;
          };
          namespace: string;
          releaseName: string;
        };
        labels?: Record<string, string>;
        name?: string;
        primary?: boolean;
        status?: {
          capabilities?: Array<string>;
          id?: string;
        };
      }
    >;
    secret?: string;
  };
  status?: {
    clusterStatuses?: Record<
      string,
      {
        conditions?: Array<{
          /** @format date-time */
          lastTransitionTime: string;
          message: string;
          /** @format int64 */
          observedGeneration?: number;
          reason: string;
          status: string;
          type: string;
        }>;
        name?: string;
      }
    >;
    conditions?: Array<{
      /** @format date-time */
      lastTransitionTime: string;
      message: string;
      /** @format int64 */
      observedGeneration?: number;
      reason: string;
      status: string;
      type: string;
    }>;
  };
}

/** Bootstrap object information */
export interface BootstrapInfo {
  clusterName?: string;
  /** Time stamp for an event related to an object, for example when the object was created. */
  createdAt?: TimeStamp;
  /** Time stamp for an event related to an object, for example when the object was created. */
  expiresAt?: TimeStamp;
  ingress?: string;
  message?: string;
  name?: string;
  state?: string;
}

export type BootstrapInfoList = Array<BootstrapInfo>;

export type BootstrapList = Array<Bootstrap>;

/** Parameters for creating a bootstrap with a secret */
export interface BootstrapWithSecretParams {
  bootstrap?: Bootstrap;
  secret?: {
    /** @format byte */
    kubeconfig?: Blob;
  };
}

export interface BucketProperties {
  bucketReadyForImmutableBackups: boolean;
  condIdx: Record<
    string,
    {
      /** @format date-time */
      lastTransitionTime: string;
      message: string;
      /** @format int64 */
      observedGeneration?: number;
      reason: string;
      status: string;
      type: string;
    }
  >;
  conditions?: Array<{
    /** @format date-time */
    lastTransitionTime: string;
    message: string;
    /** @format int64 */
    observedGeneration?: number;
    reason: string;
    status: string;
    type: string;
  }>;
  /**
   * @format int32
   * @min 0
   */
  maxProtectionPeriodDays?: number;
}

export interface CancelActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export type CatalogFileSize = Record<string, number>;

export interface Cluster {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    apiserver?: {
      insecureTLS?: boolean;
      url: string;
    };
    k10?: {
      ingress?: {
        insecureTLS?: boolean;
        url: string;
      };
      namespace?: string;
      releaseName?: string;
    };
    primary?: boolean;
    secret?: string;
  };
  status?: {
    capabilities?: Array<string>;
    conditions?: Array<{
      /** @format date-time */
      lastTransitionTime: string;
      message: string;
      /** @format int64 */
      observedGeneration?: number;
      reason: string;
      status: string;
      type: string;
    }>;
    id?: string;
  };
}

export type ClusterList = Array<Cluster>;

export interface ClusterRestorePointAPI {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  status?: {
    /** @format date-time */
    actionTime?: string;
    clusterRestorePointDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      originatingPolicies?: Array<{
        name: string;
        namespace?: string;
      }>;
      supportsPITR: boolean;
    };
    /** @format date-time */
    scheduledTime?: string;
  };
}

export type ClusterRestorePointObjectList = Array<ClusterRestorePointP>;

export interface ClusterRestorePointP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  status?: {
    /** @format date-time */
    actionTime?: string;
    clusterRestorePointDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      originatingPolicies?: Array<{
        name: string;
        namespace?: string;
      }>;
      supportsPITR: boolean;
    };
    /** @format date-time */
    scheduledTime?: string;
  };
}

export interface ClusterRole {
  /** The clusterRole's K8s representation */
  clusterRoleCR?: ClusterRoleCR;
  /** Is clusterRole editable */
  editable?: boolean;
  /** The clusterRole's JSON representation */
  rulesMap?: RulesMap;
}

export interface ClusterRoleBinding {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  roleRef: {
    apiGroup: string;
    kind: string;
    name: string;
  };
  subjects?: Array<{
    apiGroup?: string;
    kind: string;
    name: string;
    namespace?: string;
  }>;
}

/** ClusterRoleBinding data from browser for creating/editing roleBinding */
export interface ClusterRoleBindingForm {
  clusterRoleBinding?: ClusterRoleBinding;
}

export interface ClusterRoleBindingList {
  apiVersion?: string;
  items: Array<{
    apiVersion?: string;
    kind?: string;
    metadata?: {
      annotations?: Record<string, string>;
      /** @format date-time */
      creationTimestamp?: string;
      /** @format int64 */
      deletionGracePeriodSeconds?: number;
      /** @format date-time */
      deletionTimestamp?: string;
      finalizers?: Array<string>;
      generateName?: string;
      /** @format int64 */
      generation?: number;
      labels?: Record<string, string>;
      managedFields?: Array<{
        apiVersion?: string;
        fieldsType?: string;
        fieldsV1?: {};
        manager?: string;
        operation?: string;
        subresource?: string;
        /** @format date-time */
        time?: string;
      }>;
      name?: string;
      namespace?: string;
      ownerReferences?: Array<{
        apiVersion: string;
        blockOwnerDeletion?: boolean;
        controller?: boolean;
        kind: string;
        name: string;
        uid: string;
      }>;
      resourceVersion?: string;
      selfLink?: string;
      uid?: string;
    };
    roleRef: {
      apiGroup: string;
      kind: string;
      name: string;
    };
    subjects?: Array<{
      apiGroup?: string;
      kind: string;
      name: string;
      namespace?: string;
    }>;
  }>;
  kind?: string;
  metadata?: {
    continue?: string;
    /** @format int64 */
    remainingItemCount?: number;
    resourceVersion?: string;
    selfLink?: string;
  };
}

export interface ClusterRoleCR {
  aggregationRule?: {
    clusterRoleSelectors?: Array<{
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
    }>;
  };
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  rules: Array<{
    apiGroups?: Array<string>;
    nonResourceURLs?: Array<string>;
    resourceNames?: Array<string>;
    resources?: Array<string>;
    verbs: Array<string>;
  }>;
}

export interface ClusterRoleCRList {
  apiVersion?: string;
  items: Array<{
    aggregationRule?: {
      clusterRoleSelectors?: Array<{
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
      }>;
    };
    apiVersion?: string;
    kind?: string;
    metadata?: {
      annotations?: Record<string, string>;
      /** @format date-time */
      creationTimestamp?: string;
      /** @format int64 */
      deletionGracePeriodSeconds?: number;
      /** @format date-time */
      deletionTimestamp?: string;
      finalizers?: Array<string>;
      generateName?: string;
      /** @format int64 */
      generation?: number;
      labels?: Record<string, string>;
      managedFields?: Array<{
        apiVersion?: string;
        fieldsType?: string;
        fieldsV1?: {};
        manager?: string;
        operation?: string;
        subresource?: string;
        /** @format date-time */
        time?: string;
      }>;
      name?: string;
      namespace?: string;
      ownerReferences?: Array<{
        apiVersion: string;
        blockOwnerDeletion?: boolean;
        controller?: boolean;
        kind: string;
        name: string;
        uid: string;
      }>;
      resourceVersion?: string;
      selfLink?: string;
      uid?: string;
    };
    rules: Array<{
      apiGroups?: Array<string>;
      nonResourceURLs?: Array<string>;
      resourceNames?: Array<string>;
      resources?: Array<string>;
      verbs: Array<string>;
    }>;
  }>;
  kind?: string;
  metadata?: {
    continue?: string;
    /** @format int64 */
    remainingItemCount?: number;
    resourceVersion?: string;
    selfLink?: string;
  };
}

/** ClusterRole data from browser for creating/editing clusterRole */
export interface ClusterRoleForm {
  clusterRole?: ClusterRole;
}

export type ClusterRoleList = Array<ClusterRole>;

export interface Compliance {
  /** ProtectedObject compliance was determined for */
  protectedObject?: {
    /** Item identifier */
    id?: ItemId;
  };
  /**
   * Compliance state of the object this label was applied to.
   * Unmanaged: This object is not covered by any k10 policy
   * NonCompliant: System state is not in compliance with one or more policies
   *   covering this object
   * Compliant: System state is in compliance with all policies covering this
   *   object
   */
  state?: ComplianceState;
}

export interface ComplianceData {
  compliantCount: number;
  nonCompliantCount: number;
  selectorName?: string;
  total: number;
  unmanagedCount: number;
}

export interface ConfigMap {
  apiVersion?: string;
  binaryData?: Record<string, string>;
  data?: Record<string, string>;
  immutable?: boolean;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
}

export interface DRPassphraseForm {
  awsInfo?: {
    jsonKey: string;
    region: string;
    secretId: string;
    versionId: string;
    versionStage: string;
  };
  azureInfo?: {
    jsonKey: string;
    keyVaultURL: string;
    secretName: string;
    version?: string;
  };
  passphrase?: string;
  source?: string;
  vaultInfo?: {
    kvVersion: string;
    mountPath: string;
    secretName: string;
    secretPath: string;
  };
}

export interface DRRestoreInfo {
  overrideResources: boolean;
  restorePoint?: {
    exportedCatalogAvailable: boolean;
    localSnapshotTaken: boolean;
    snapshotID?: string;
    /** @format date-time */
    snapshotTime?: string;
    validSnapshotAvailable: boolean;
    version?: string;
  };
  sourceClusterInfo?: {
    passphraseInfo?: {
      awsInfo?: {
        jsonKey: string;
        region: string;
        secretId: string;
        versionId: string;
        versionStage: string;
      };
      azureInfo?: {
        jsonKey: string;
        keyVaultURL: string;
        secretName: string;
        version?: string;
      };
      passphrase?: string;
      source?: string;
      vaultInfo?: {
        kvVersion: string;
        mountPath: string;
        secretName: string;
        secretPath: string;
      };
    };
    pointInTime?: string;
    profileName?: string;
    sourceClusterID?: string;
  };
}

export interface DRRestorePoints {
  /** @format int32 */
  count?: number;
  restorePointList?: Array<{
    exportedCatalogAvailable: boolean;
    localSnapshotTaken: boolean;
    snapshotID?: string;
    /** @format date-time */
    snapshotTime?: string;
    validSnapshotAvailable: boolean;
    version?: string;
  }>;
}

export interface DRRestoreStatus {
  cause?: string;
  error?: string;
  progress?: string;
  status?: string;
}

export interface DRValidationStatus {
  cause?: string;
  error?: string;
  restorePoints?: {
    /** @format int32 */
    count?: number;
    restorePointList?: Array<{
      exportedCatalogAvailable: boolean;
      localSnapshotTaken: boolean;
      snapshotID?: string;
      /** @format date-time */
      snapshotTime?: string;
      validSnapshotAvailable: boolean;
      version?: string;
    }>;
  };
  status?: string;
}

export interface DashboardActionList {
  actions: K10ActionList;
  /**
   * If true, the backend end is asynchronously
   * generating the list for a user.
   * If false, the backend is not asynchronously
   * generating the list and instead returning
   * the cached list.
   */
  loading: boolean;
  /** The total number of actions, including those not listed by pagination. */
  totalCount: number;
}

/** Data for populating compliance section of Dashboard page */
export interface DashboardComplianceData {
  complianceData?: Array<ComplianceData>;
  /** Compliance score */
  complianceScore: number;
  /**
   * If true, the backend end is asynchronously
   * generating the list of namespaces for a user.
   * If false, the backend is not asynchronously
   * generating the list and instead returning
   * the cached list of namespaces.
   */
  loading: boolean;
}

/** DataService description */
export interface DataService {
  /** DataService host */
  host?: string;
  /** Data Service manager type */
  manager?: DataServiceManagerType;
  /** Data Service type */
  type?: DataServiceType;
}

export interface DataServiceRestoreOptions {
  /** ID of the Data Service artifact being restored that these options should apply to */
  artifactId?: ItemId;
  values?: Array<KeyValue>;
}

export type DataServiceRestoreOptionsList = Array<DataServiceRestoreOptions>;

/** Snapshot of a DataService */
export interface DataServiceSnapshot {
  kanisterArtifacts?: Array<KanisterArtifact>;
  /** DataService description */
  meta?: DataService;
  /** The configuration of a K8s object */
  spec?: Spec;
}

export interface DecryptedData {
  /**
   * Decrypted data
   * @format byte
   */
  data?: Blob;
}

/** Has the response of the delete license endpoint */
export interface DeleteLicense {
  /** Whether the license was deleted */
  success?: boolean;
}

/** Specifies input for a /derivekey operation */
export interface DeriveKeySpec {
  /** Describes what this key will be used for */
  purpose?: string;
}

export interface DerivedKey {
  /**
   * base64 encoded generated key in plaintext
   * @format byte
   */
  key?: Blob;
  /**
   * Set to true when there is no master key configured.
   * 'key' will be "" in this case
   */
  noMasterKey?: boolean;
}

export interface Distribution {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    clusters?: Array<{
      name?: string;
      selector?: string;
    }>;
    invalidationMarker?: string;
    sources?: Array<{
      ref?: {
        apiVersion: string;
        kind: string;
        name: string;
        namespace: string;
      };
    }>;
  };
  status?: {
    conditions?: Array<{
      /** @format date-time */
      lastTransitionTime: string;
      message: string;
      /** @format int64 */
      observedGeneration?: number;
      reason: string;
      status: string;
      type: string;
    }>;
    distributedObjects?: Array<{
      object: {
        apiVersion: string;
        kind: string;
        name: string;
        namespace: string;
      };
      obsolete?: boolean;
      sourceInfo: {
        /** @format int64 */
        generation?: number;
        resourceVersion?: string;
        uid: string;
      };
      stale?: boolean;
      state?: string;
      /** @format date-time */
      stateUpdatedAt?: string;
      targetCluster: {
        id: string;
        name: string;
      };
    }>;
    lastInvalidationMarker?: string;
  };
}

export type DistributionList = Array<Distribution>;

export type Duration = string;

/** The text of the EULA we display */
export type EULAText = string;

export interface EncryptedData {
  /**
   * Encrypted data
   * @format byte
   */
  data?: Blob;
}

export interface EncryptedDataWithKeyDetails {
  /**
   * Encrypted data
   * @format byte
   */
  data?: Blob;
  /** The algorithm used to derive a key */
  keyDerivationAlgorithm?: string;
  /**
   * Purpose used to derive a key to encrypt the data
   * @format byte
   */
  purpose?: Blob;
  /**
   * Salt used in the PBKDF to derive a key to encrypt the data
   * @format byte
   */
  salt?: Blob;
}

/** An encrypted encryption key */
export interface EncryptionKey {
  /**
   * Encrypted key
   * @format byte
   */
  cipherText?: Blob;
  /** The type of encryption key according to its intended usage */
  intent?: EncryptionKeyIntent;
  /** The algorithm used to derive a key */
  keyDerivationAlgorithm?: string;
  name?: string;
  passkeyConfig?: PasskeyConfig;
  /**
   * Salt used in the PBKDF to derive a key to encrypt a master key
   * @format byte
   */
  salt?: Blob;
  /** Set to true if the passkey is valid */
  valid?: boolean;
}

export type EncryptionKeyList = Array<EncryptionKey>;

/**
 * Used to propagate error messages, such as for failed jobs
 * @example "Failed to get policy for job"
 */
export interface Error {
  cause?: {};
  fields?: Array<Field>;
  message?: string;
  retriable?: boolean;
}

export interface ErrorDetail {
  code?: number;
  message?: string;
  /** If present in the error detail, this is what should be shown to end users with an option to show entire stack trace */
  userMessages?: Array<string>;
}

export interface Event {
  action: string;
  error?: {
    cause?: any;
    fields?: Array<{
      name: string;
      value: any;
    }>;
    file?: string;
    function?: string;
    /** @format int32 */
    linenumber?: number;
    message?: string;
    retriable?: boolean;
  };
  id: string;
  level: string;
  message?: string;
  source: string;
  title?: string;
}

export interface EventGroup {
  action: string;
  /**
   * @format int32
   * @min 0
   */
  count: number;
  error?: {
    cause?: any;
    fields?: Array<{
      name: string;
      value: any;
    }>;
    file?: string;
    function?: string;
    /** @format int32 */
    linenumber?: number;
    message?: string;
    retriable?: boolean;
  };
  /** @format date-time */
  firstSeen: string;
  id: string;
  /** @format date-time */
  lastSeen: string;
  level: string;
  message?: string;
  source: string;
  title?: string;
}

export type EventList = Array<{
  action: string;
  /**
   * @format int32
   * @min 0
   */
  count: number;
  error?: {
    cause?: any;
    fields?: Array<{
      name: string;
      value: any;
    }>;
    file?: string;
    function?: string;
    /** @format int32 */
    linenumber?: number;
    message?: string;
    retriable?: boolean;
  };
  /** @format date-time */
  firstSeen: string;
  id: string;
  /** @format date-time */
  lastSeen: string;
  level: string;
  message?: string;
  source: string;
  title?: string;
}>;

/** Number of nodes that are exempt from licensing */
export interface ExcludedNodesInCluster {
  /** Number of nodes that ignore license */
  ignoreLicenseLabelNodeCount: number;
  /** Number of nodes labeled as infra */
  infraLabelNodeCount: number;
  /** Number of nodes with NoSchedule/NoExecute taints */
  taintedNodeCount: number;
}

export interface ExportActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    blockModeProfile?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    expiresAt?: string;
    exportData?: {
      enabled: boolean;
      exporterStorageClassName?: string;
      overrides?: Array<{
        enabled: boolean;
        exporterStorageClassName?: string;
        storageClassName: string;
      }>;
    };
    frequency?: string;
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    migrationToken?: {
      name: string;
      namespace?: string;
    };
    profile?: {
      name: string;
      namespace?: string;
    };
    receiveString?: string;
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
    volumeSnapshots?: {
      awsEbs?: {
        destinationAccount?: string;
        regions?: Array<string>;
      };
      azure?: {
        regions?: Array<string>;
        resourceGroup?: string;
      };
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface ExportParametersP {
  actionPodSpec?: {
    name: string;
    namespace?: string;
  };
  blockModeProfile?: {
    name: string;
    namespace?: string;
  };
  /** @format date-time */
  expiresAt?: string;
  exportData?: {
    enabled: boolean;
    exporterStorageClassName?: string;
    overrides?: Array<{
      enabled: boolean;
      exporterStorageClassName?: string;
      storageClassName: string;
    }>;
  };
  frequency?: string;
  hooks?: {
    onFailure?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
    onSuccess?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
    preHook?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
  };
  ignoreExceptions?: boolean;
  migrationToken?: {
    name: string;
    namespace?: string;
  };
  profile?: {
    name: string;
    namespace?: string;
  };
  receiveString?: string;
  volumeSnapshots?: {
    awsEbs?: {
      destinationAccount?: string;
      regions?: Array<string>;
    };
    azure?: {
      regions?: Array<string>;
      resourceGroup?: string;
    };
  };
}

export interface Field {
  name?: string;
  value?: {};
}

/** Used to filter values */
export interface Filter {
  action?: string;
  application?: string;
  /** If true, only return actions that completed with exceptions */
  hasExceptions?: boolean;
  /**
   * If false, we'll return values matching Filter.value.
   * If true, return all other models.
   */
  invert?: boolean;
  policy?: string;
  status?: string;
  /** The type of filter */
  type?: FilterType;
  value?: string;
}

export interface GracePeriod {
  available: boolean;
  lastClusterState?: string;
  /** @format date-time */
  lastInvalidTime?: string;
  /** @format date-time */
  lastValidTime?: string;
  /** @format int32 */
  remainingMinutes: number;
}

export interface GroupVersionResource {
  Group: string;
  Resource: string;
  Version: string;
}

/** List of api resource types */
export type GroupVersionResourceList = Array<GroupVersionResource>;

export interface HoldInfo {
  DestructorNeeded: boolean;
  Holds: Record<string, {}>;
}

export interface ImportActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    migrationToken?: {
      name: string;
      namespace?: string;
    };
    profile?: {
      name: string;
      namespace?: string;
    };
    receiveString?: string;
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

/**
 * The value of an index in a store.
 * @example "app:mysql"
 */
export type IndexValue = string;

export type IndexValueList = Array<IndexValue>;

export interface IndexValueListWithContinuation {
  continuation?: string;
  items?: IndexValueList;
}

/**
 * Item identifier
 * @format uuid
 * @example "d290f1ee-6c54-4b01-90e6-d701748f0851"
 */
export type ItemId = string;

export type ItemIdList = Array<ItemId>;

export type JSONObject = Record<string, any>;

export interface Job {
  /** Number of times executor has blocked cancellation */
  blockCancelCount?: number;
  /** Time stamp for an event related to an object, for example when the object was created. */
  completeTime?: TimeStamp;
  /** Name used to serialize conflicting jobs (namespace for app manifest jobs) */
  conflictLockString?: string;
  /**
   * Number of times we've attempted to execute this job
   * @example 3
   */
  count?: number;
  /** Time stamp for an event related to an object, for example when the object was created. */
  creationTime?: TimeStamp;
  /** Time stamp for an event related to an object, for example when the object was created. */
  deadline?: TimeStamp;
  /** A list of errors indicating causes for job failures */
  errors?: Array<Error>;
  /** For interior nodes in the manifest tree, the group of jobs currently being operated on. */
  groupIndex?: number;
  /**
   * Job identifier
   * @format uuid
   */
  id?: string;
  /** ID of the manifest associated with this job */
  manifest?: ItemId;
  /** List of references to other objects */
  originatingPolicies?: ReferenceList;
  phases?: Array<JobPhase>;
  /** Time stamp for an event related to an object, for example when the object was created. */
  scheduledTime?: TimeStamp;
  /** Time stamp for an event related to an object, for example when the object was created. */
  startedTime?: TimeStamp;
  /** Current state of the Job */
  status?: JobStatus;
  /** Time stamp for an event related to an object, for example when the object was created. */
  updatedTime?: TimeStamp;
  /** Number of times executor has waited while polling conditions */
  waitCount?: number;
  /** Time stamp for an event related to an object, for example when the object was created. */
  waitStartTime?: TimeStamp;
}

export type JobList = Array<Job>;

/** Embedded inside a job denoting a unit of work */
export interface JobPhase {
  /** Name of phase within a Job */
  name?: JobPhaseName;
  /** A plan for a phase */
  plan?: StoredPlan;
  /** Progress of phase execution represented as integer value between 0 and 100 */
  progress?: ManifestProgress;
  /** Optional details for phase execution progress */
  progressDetails?: ManifestProgressDetails;
  scratch?: Array<KeyValue>;
  /** Current state of the Job phase */
  status?: JobPhaseStatus;
  /**
   * Phase progress weight
   * @max 100
   */
  weight?: number;
}

/** Name of phase within a Job */
export type JobPhaseName = string;

export interface JoinConfig {
  clusterIngress?: string;
  clusterName?: string;
  primaryIngress?: string;
  token: string;
}

export interface JoinTokenInfo {
  /** Time stamp for an event related to an object, for example when the object was created. */
  createdAt: TimeStamp;
  name: string;
  token: string;
}

export type JoinTokenList = Array<JoinTokenInfo>;

/** UI model for actions performed by system */
export interface K10Action {
  backupAction?: BackupActionP;
  backupClusterAction?: BackupClusterActionP;
  batchRestoreAction?: BatchRestoreActionP;
  exportAction?: ExportActionP;
  importAction?: ImportActionP;
  kind?: string;
  reportAction?: ReportActionP;
  restoreAction?: RestoreActionP;
  restoreClusterAction?: RestoreClusterActionP;
  retireAction?: RetireActionP;
  runAction?: RunActionP;
  stageAction?: StageActionP;
  upgradeAction?: UpgradeActionP;
  validateAction?: ValidateActionP;
}

export type K10ActionList = Array<K10Action>;

export interface K10ClusterRole {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    clusterRole?: string;
    group?: string;
    rules?: Array<{
      apiGroups?: Array<string>;
      nonResourceURLs?: Array<string>;
      resourceNames?: Array<string>;
      resources?: Array<string>;
      verbs: Array<string>;
    }>;
  };
  status?: {};
}

export interface K10ClusterRoleBinding {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    clusters?: Array<{
      name?: string;
      selector?: string;
    }>;
    k10ClusterRole?: string;
    subjects?: Array<{
      apiGroup?: string;
      kind: string;
      name: string;
      namespace?: string;
    }>;
  };
  status?: {};
}

export type K10ClusterRoleBindingList = Array<K10ClusterRoleBinding>;

export type K10ClusterRoleList = Array<K10ClusterRole>;

export interface K10HealthCheck {
  mcconn?: {
    description?: string;
    detail?: string;
    error?: string;
    name?: string;
    passed: boolean;
    suggestedAction?: string;
  };
  services: Array<{
    description?: string;
    detail?: string;
    error?: string;
    name?: string;
    passed: boolean;
    suggestedAction?: string;
  }>;
}

export interface K10HealthCheckEntry {
  description?: string;
  detail?: string;
  error?: string;
  name?: string;
  passed: boolean;
  suggestedAction?: string;
}

/** Contains information about a K10 object. */
export interface K10Object {
  Type?: "policy" | "manifest" | "repository";
  /** Item identifier */
  manifestId?: ItemId;
  /** Item identifier */
  policyId?: ItemId;
  /** Item identifier */
  repositoryId?: ItemId;
}

/** A K10 secret passphrase provider */
export type K10SecretPasskeyConfig = {
  /** The K10 secret containing the passphrase */
  secretName: string;
};

/** Describes a K8s object */
export interface K8SObject {
  annotations?: Array<KeyValue>;
  /**
   * K8s APIVersion for this object type
   * @example "v1beta1"
   */
  apiVersion?: string;
  /**
   * K8s group for this object
   * @example "cr.kanister.io"
   */
  group?: string;
  /** K8s Labels (metadata.labels) */
  labels?: Array<Label>;
  /** @example "catalog-svc" */
  name?: string;
  /** @example "default" */
  namespace?: string;
  /**
   * K8s resource name for this object
   * @example "profiles"
   */
  resource?: string;
  /** k8s object type */
  type?: K8SObjectType;
  /**
   * K8s generated UID
   * @format uuid
   * @example "9f4bdf0b-20fb-11e8-99a5-02973931ee80"
   */
  uid?: string;
}

/** List of K8sObjects */
export type K8SObjectList = Array<K8SObject>;

export interface K8SObjectListWithContinuation {
  continuation?: string;
  /** List of K8sObjects */
  items?: K8SObjectList;
}

export interface K8SObjectReference {
  apiVersion?: string;
  kind?: string;
  name: string;
  namespace?: string;
}

export interface K8SObjectReferenceConfigP {
  apiVersion: string;
  kind: string;
  name: string;
  namespace: string;
}

export interface K8SObjectReferenceP {
  apiVersion?: string;
  kind?: string;
  name: string;
  namespace?: string;
}

/** Kubernetes volume snapshot */
export interface K8SSnapshot {
  /** Name of the CSI driver */
  driver?: string;
  /** Handle ID of the snapshot given by the CSI driver */
  handle?: string;
  /** Name of the VolumeSnapshotClass used by the snapshot */
  volumeSnapshotClassName?: string;
}

/** Kubernetes pod-spec volume definition */
export interface K8SVolume {
  /** Volume name in pod spec */
  name?: string;
  /**
   * For Snapshot artifacts this contains the backing PV's topology constraints (nodeAffinity).
   * This is used to decide the node for temp PVC and copy-vol-data pod that Kasten creates to export a PVC.
   */
  nodeAffinity?: NodeAffinity;
  /** PVC name referenced by this volume */
  pvcName?: string;
  /** Storage class used to create the PVC */
  storageClassName?: string;
}

export interface KanisterArtifact {
  /** Kopia snapshot information produced by kando */
  kopiaSnapshot?: KopiaSnapshot;
  meta?: {
    /** Time stamp for an event related to an object, for example when the object was created. */
    endTime?: TimeStamp;
    /** Kubernetes volume */
    k8sVolume?: K8SVolume;
    /** Hostname used while performing kopia operations */
    kopiaHostname?: string;
    location?: Location;
    /** UID of the owner application namespace */
    namespaceUID?: string;
    operationType?: OperationType;
    profileRef?: K8SObjectReferenceConfigP;
    storageUsage?: StorageUsage;
    /** The type of the kanister artifact object */
    type?: KanisterArtifactType;
    /** The format of data uploaded by the operation that created this artifact */
    uploadDataFormat?: UploadDataFormat;
    /** Version of the Kanister function used */
    version?: string;
  };
  /** Artifact name */
  name?: string;
  values?: Array<KeyValue>;
}

/** String key-value pairs */
export interface KeyValue {
  /** Key or index name */
  key?: string;
  /** Value string */
  value?: string;
}

/** Available keyless authentications modes in clusters */
export interface KeylessAuth {
  /** Status of the Azure keyless auth option */
  azure?: KeylessAuthAZStatus;
}

/** Status of the Azure keyless auth option */
export interface KeylessAuthAZStatus {
  /** Status of Azure keyless auth in cluster */
  status?: KeylessAuthAZStatusType;
}

export interface KopiaSnapshot {
  id: string;
  /** @format int64 */
  logicalSize: number;
  /** @format int64 */
  physicalSize: number;
}

export interface Label {
  /** k8s object type */
  type?: K8SObjectType;
  /**
   * The value of the label
   * @example "app:mysql"
   */
  value?: string;
}

export interface LabelSelector {
  matchExpressions?: Array<{
    key: string;
    operator: string;
    values?: Array<string>;
  }>;
  matchLabels?: Record<string, string>;
}

/** List of labelSelectors */
export type LabelSelectorList = Array<LabelSelector>;

/** Lease information */
export interface LeaseInfo {
  /** Whether the lease is valid */
  isValid: boolean;
  /** Node count contributed to multi cluster pool */
  nodesContributed: number;
  /** Leased node count */
  nodesLeased: number;
  /** Lease status */
  status: string;
}

export interface License {
  /** @format int64 */
  daysToExpiry: number;
  inUse: boolean;
  isValid: boolean;
  licenseID?: string;
  licenseName?: string;
  licenseType?: string;
  nodeLimit?: {
    /** @format int64 */
    current: number;
    /** @format int64 */
    limit: number;
  };
  status: string;
}

export interface LicenseData {
  /** Either a license content from a file or a base64 encoded string */
  license?: string;
}

export interface LicenseResponse {
  customerName: string;
  /** @format date-time */
  dateEnd: string;
  /** @format date-time */
  dateStart: string;
  features: Record<string, string>;
  id: string;
  product: string;
  restrictions: Record<string, string>;
  serviceAccountKey: string;
  signature: string;
  unvalidatedFeatures: Record<string, string>;
  version: string;
}

/** Licensing Status */
export interface LicenseStatus {
  gracePeriod?: GracePeriod;
  /** Tells us the license ID */
  licenseID?: string;
  /** Tells the type of license installed */
  licenseType?:
    | "starter"
    | "trial"
    | "awsCloudMetering"
    | "gCloudMetering"
    | "redhatCloudMetering"
    | "azureCloudMetering"
    | "awsTotem"
    | "enterprise";
  /** The current value and its limit imposed by the our license */
  nodeLimit?: LicenseStatusLimit;
  /** An enum of active and inactive states */
  phoneHomeStatus?: "active" | "offlineMode" | "unreachableBucket";
  /** An enum of valid and invalid states */
  status?:
    | "valid"
    | "eulaNotAccepted"
    | "invalidSignature"
    | "licenseExpired"
    | "nodeLimitExceeded"
    | "awsMarketMeteringFailed"
    | "googleMarketMeteringFailed"
    | "redhatCloudMeteringFailed"
    | "azureCloudMeteringFailed"
    | "awsTotemFailed"
    | "nolicensesfound"
    | "invalidOffline"
    | "duplicate"
    | "indeterminate";
}

/** The current value and its limit imposed by the our license */
export interface LicenseStatusLimit {
  current: number;
  limit: number;
}

/** Lease information */
export interface LicensingInfo {
  /** Number of nodes that are exempt from licensing */
  excludedNodesInCluster?: ExcludedNodesInCluster;
  /** Lease information */
  lease?: LeaseInfo;
  /** Number of installed licenses available on this cluster */
  locallyInstalledLicenses: number;
  /** Worker node count in the cluster */
  nodesRequiringLicense: number;
  /** Node count in the cluster including excluded nodes */
  totalNodesInCluster: number;
}

export interface LimiterResponse {
  granted: boolean;
}

export interface LimiterTagsP {
  jobID: string;
  requestTag: string;
}

export interface LinkedVbrServer {
  serverId: string;
  serverName: string;
}

/** List of licenses */
export interface ListLicenses {
  licenses?: Array<License>;
  /** Lease information */
  licensingInfo?: LicensingInfo;
}

export interface Location {
  /** Metadata for file store locations */
  fileStore?: LocationFileStore;
  /** Metadata for image repository locations */
  imageRepo?: LocationImageRepo;
  /** Metadata for object store locations */
  objectStore?: LocationObjectStore;
  /** The location type */
  type?: LocationType;
  vbr?: LocationVBR;
}

/** Metadata for file store locations */
export interface LocationFileStore {
  /** Name of the Persistent Volume Claim */
  claimName?: string;
  /**
   * Path inside the root mount path
   * @example "root/k10/path"
   */
  path?: string;
  /**
   * Supplemental Group
   * @example 0
   */
  suppGroup?: number;
}

/** Metadata for image repository locations */
export interface LocationImageRepo {
  /** Endpoint of the image repository */
  endpoint?: string;
  /**
   * If true, disable SSL verification. If false (the default), SSL
   * verification is enabled.
   */
  skipSSLVerify?: boolean;
}

/** Metadata for object store locations */
export interface LocationObjectStore {
  /**
   * Endpoint used to access the object store. It can be implicit for
   * stores from certain cloud providers such as AWS. In that case it can
   * be empty
   */
  endpoint?: string;
  /** Name of the container (bucket) in the object store */
  name?: string;
  /** Supported object stores */
  objectStoreType?: ObjectStoreType;
  /**
   * Path inside the container.
   * @example "root/k10/path/object"
   */
  path?: string;
  /** Whether the path points to a directory or an object */
  pathType?: "Directory" | "Object";
  /** Protection period for repositories in the bucket */
  protectionPeriod?: Duration;
  /**
   * Region for a location. In the AWS case, the region affects the
   * visibility of certain resources, such as EBS snapshots.
   */
  region?: string;
  /**
   * If true, disable SSL verification. If false (the default), SSL
   * verification is enabled.
   */
  skipSSLVerify?: boolean;
}

export interface LocationVBR {
  repoId?: string;
  repoName?: string;
  repoType?: string;
  serverAddress?: string;
  serverId?: string;
  /** @format int32 */
  serverPort?: number;
  serverThumbprint?: string;
  serverVersion?: string;
  skipSSLVerify?: boolean;
  /** @format int32 */
  vmbApiPort?: number;
}

/** Log level */
export interface LogMessage {
  fields?: Array<Field>;
  /** Log level severities */
  level?: LogLevelType;
  message?: string;
  sessionId?: string;
  /** Time stamp for an event related to an object, for example when the object was created. */
  time?: TimeStamp;
}

export interface MCClusterInfo {
  clusterName?: string;
  connectionStatus?: MCConnectionStatus;
  primaryInfo?: MCPrimaryInfo;
}

export interface MCConnectionStatus {
  /** Time stamp for an event related to an object, for example when the object was created. */
  lastActive?: TimeStamp;
}

export interface MCInfo {
  clusterInfo?: MCClusterInfo;
  joinStatus?: MCJoinStatus;
}

export interface MCJoinStatus {
  joinConfig?: JoinConfig;
  message?: string;
  status?: "ready" | "joining" | "joined" | "rejected";
  /** Time stamp for an event related to an object, for example when the object was created. */
  timestamp?: TimeStamp;
}

export interface MCLicenseUsage {
  leasesFulfilled: number;
  leasesUnfulfilled: number;
  nodesContributedFromClusters: number;
  nodesLent: number;
  nodesRequestedByClusters: number;
}

export interface MCMetrics {
  clusterSummaries?: Record<
    string,
    {
      actions?: {
        /** @format int64 */
        cancelled?: number;
        /** @format int64 */
        failed?: number;
        /** @format int64 */
        skipped?: number;
        /** @format int64 */
        succeeded?: number;
      };
      apps?: {
        /** @format int64 */
        compliant?: number;
        /** @format int64 */
        nonCompliant?: number;
        /** @format int64 */
        total?: number;
        /** @format int64 */
        unmanaged?: number;
      };
      licenseInfo?: {
        /** @format int64 */
        licensesExpired?: number;
        licensesStatuses?: string;
        /** @format int64 */
        locallyInstalledLicenses?: number;
        /** @format int64 */
        nodesContributed?: number;
        /** @format int64 */
        nodesLeased?: number;
      };
      licenses?: Array<{
        /** @format int64 */
        daysToExpiry: number;
        inUse: boolean;
        isValid: boolean;
        licenseID?: string;
        licenseName?: string;
        licenseType?: string;
        nodeLimit?: {
          /** @format int64 */
          current: number;
          /** @format int64 */
          limit: number;
        };
        status: string;
      }>;
      /** @format int64 */
      nodesViolations?: number;
      /** @format int64 */
      policies?: number;
    }
  >;
  globalSummary?: {
    actions?: {
      /** @format int64 */
      cancelled?: number;
      /** @format int64 */
      failed?: number;
      /** @format int64 */
      skipped?: number;
      /** @format int64 */
      succeeded?: number;
    };
    /** @format int64 */
    apps?: number;
    /** @format int64 */
    availablePooledLicenses?: number;
    dataUsage?: {
      /** @format int64 */
      object?: number;
      /** @format int64 */
      snapshot?: number;
      /** @format int64 */
      total?: number;
    };
    /** @format int64 */
    licensesExpired?: number;
    nodesSummary?: {
      /** @format int64 */
      ignoreLicenseLabelNodeCount?: number;
      /** @format int64 */
      infraLabelNodeCount?: number;
      /** @format int64 */
      nodesRequiringLicense?: number;
      /** @format int64 */
      taintedNodeCount?: number;
      /** @format int64 */
      totalNodesInCluster?: number;
    };
    /** @format int64 */
    nodesViolations?: number;
    /** @format int64 */
    nonCompliantApps?: number;
    /** @format int64 */
    policies?: number;
  };
}

export interface MCPrimaryInfo {
  endpoint?: string;
  ingress?: string;
  name?: string;
}

/**
 * A Manifest captures the inputs to and results from a job. Every job
 * processes a manifest and may result in multiple artifacts or child
 * manifests. These artifacts are listed in a Manifest. The Manifest is
 * created initially with state of unitialized and submitted for execution.
 * Manifest state is set to running when the job begins. If the job
 * succeeds its status is succeeded, and if the job fails, its status is
 * marked as failed.
 */
export interface Manifest {
  /** Identifies the action associated with this Manifest */
  action?: Action;
  /** Modifiers for action runtime execution.  These are runtime action inputs that do not appear directly in the API. */
  actionModifiers?: ActionModifiersP;
  apiKeys?: Array<APIKey>;
  /** API metadata for manifests that represent API objects */
  apiMeta?: APIMeta;
  /** Time stamp for an event related to an object, for example when the object was created. */
  deadline?: TimeStamp;
  /** Whether a manifest should be executed after planning */
  dryRun?: DryRunType;
  /** Time stamp for an event related to an object, for example when the object was created. */
  endTime?: TimeStamp;
  entries?: Array<ManifestEntry>;
  /** A list of exceptions ignored during action */
  exceptions?: Array<Error>;
  /** Final error in job that marks manifest status terminally failed */
  finalFailure?: Error;
  /** Normally empty. Included in hash to avoid collisions and force GetOrCreate uniqueness */
  hashbreaker?: string;
  /** The ID of the job that executes this manifest */
  jobID?: ItemId;
  /** List of references to other objects */
  originatingPolicies?: ReferenceList;
  /** Parameters that may need to be recorded about an action on an object */
  parameters?: ManifestParameters;
  /** Progress of manifest execution represented as integer value between 0 and 100 */
  progress?: ManifestProgress;
  /** Optional details for ManifestProgress */
  progressDetails?: ManifestProgressDetails;
  /** Identifies the protected object this Manifest is for */
  protectedObject?: ProtectedObjectOwner;
  /** Extensible container of results from manifest processing */
  results?: ManifestResults;
  /** Time stamp for an event related to an object, for example when the object was created. */
  scheduledTime?: TimeStamp;
  /** Child manifests for policy-driven API actions should be created as ManifesStatusSkipped */
  shouldSkipActions?: boolean;
  /** The status of the manifest */
  status?: ManifestStatus;
  /** Identifies the subject this Manifest is for */
  subject?: ManifestSubject;
}

/** A ManifestEntry could be an artifact or some other result from a job */
export interface ManifestEntry {
  /** "The artifact, empty unless this entry is of type Artifact" */
  artifact?: Artifact;
  /** "A reference to an artifact, empty unless this entry is of type ArtifactReference" */
  artifactReference?: ReferenceId;
  /**
   * A group of manifest references that can be processed in parallel.
   * Empty unless this entry is of type ArtifactReferenceGroup.
   */
  artifactReferenceGroup?: ItemIdList;
  /** The type of manifest entry */
  type?: ManifestEntryType;
}

export interface ManifestParameters {
  action?: ActionParametersP;
  /** Per policy optional parameters */
  policy?: PolicyParameters;
  /**
   * Policy parameters. Note use of custom json name here and related
   * json inline of apiconfig.PolicySpec for compatibility and upgrade.
   */
  policySpec?: PolicyParametersP;
}

/**
 * Progress of manifest execution represented as integer value between 0 and 100
 * @max 100
 */
export type ManifestProgress = number;

/** Optional details for ManifestProgress */
export interface ManifestProgressDetails {
  /**
   * Number of volumes already processed
   * @format uint64
   */
  completedVolumes?: number;
  /**
   * Number of bytes already processed
   * @format uint64
   */
  processedBytes?: number;
  /**
   * Number of bytes processed per second
   * @format uint64
   */
  processingRate?: number;
  /**
   * Number of bytes read
   * @format uint64
   */
  readBytes?: number;
  /**
   * Total size of the volumes containing data to be exported
   * @format uint64
   */
  totalBytes?: number;
  /**
   * Number of volumes to be processed
   * @format uint64
   */
  totalVolumes?: number;
  /**
   * Number of bytes transferred
   * @format uint64
   */
  transferredBytes?: number;
  /** Time stamp when progress details were updated */
  updatedTime?: TimeStamp;
}

export interface ManifestResults {
  /** @format int32 */
  applicationsCount?: number;
  exportCollection?: string;
  reportName?: string;
  statistics?: {
    /** @format int64 */
    processedBytes: number;
    /** @format int64 */
    readBytes: number;
    /** @format int64 */
    transferredBytes: number;
  };
  validationResults?: {
    volumeDataCheckResults?: Array<{
      appName?: string;
      result?: {
        /** @format int32 */
        errorCount: number;
        errorStrings?: Array<string>;
        stats: {
          /** @format int64 */
          expectedTotalBytes: number;
          /** @format int64 */
          expectedTotalFileCount: number;
          /** @format int64 */
          expectedTotalObjectCount: number;
          /** @format int64 */
          processedBytes: number;
          /** @format int64 */
          processedObjectCount: number;
          /** @format int64 */
          readBytes: number;
          /** @format int64 */
          readFileCount: number;
        };
      };
      volumeName?: string;
    }>;
  };
  vmSnapshot?: {
    cbtEligible?: boolean;
    cbtPvcNames?: Array<string>;
    snapshotConsistency?: string;
    vmStatus?: string;
  };
}

/** Object that a manifest acts on. */
export interface ManifestSubject {
  /** The type of the referenced object. */
  Type?: "k10" | "app" | "k8s" | "cloudStorage" | "empty";
  /** Represents a group of objects to act on. */
  app?: AppIdentifier;
  /** The k10 object being referenced. */
  k10Object?: K10Object;
  /** The k8s object being referenced. */
  k8sObject?: K8SObject;
}

export interface MeteringItem {
  /**
   * The unique identifier for the event that caused this measurement
   * @format uuid
   * @example "d290f1ee-6c54-4b01-90e6-d701748f0851"
   */
  id?: string;
  /** Custom label for additional context */
  label?: string;
  /** The unique identifier for the specific metric */
  metricName?:
    | "DownloadedRestoreActionBytes"
    | "TransferredExportActionBytes"
    | "ProcessedExportActionBytes"
    | "ProcessedExportActionVolumes"
    | "BackupActionDuration"
    | "ExportActionDuration"
    | "UserAccess"
    | "RestoreActionRetries"
    | "PasskeyAdded"
    | "RetireFromLockedBucket"
    | "ProcessedImageLogicalBytes"
    | "ProcessedImagePhysicalBytes"
    | "ProcessedImages"
    | "EvaluateNodeComplianceViolation"
    | "WorkloadShapeRepoSizeLogicalBytes"
    | "WorkloadShapeNumFiles"
    | "WorkloadShapeAvgFileSizeBytes"
    | "WorkloadShapeBlockModeNumBlocks"
    | "WorkloadShapeBlockModeRepoSizeLogicalBytes";
  /** Measurement value of the metric */
  value?: number;
}

export interface MeteringStats {
  /** @format int64 */
  pvcBytes: number;
  /** @format int64 */
  pvcCount: number;
}

/** Specification for a manual migrate operation */
export interface MigrateSpec {
  /** List of references to other objects */
  artifacts?: ReferenceList;
  clusterRestorePoint?: ReferenceP;
  params?: ExportParametersP;
  restorePoint?: ReferenceP;
  restorePointContent?: ReferenceP;
  targetProfile?: ReferenceP;
  targetProfileId?: ReferenceId;
}

export type MonitoringSummary = Array<{
  blobStats?: {
    /** @format int32 */
    count: number;
    /** @format int64 */
    sizeB: number;
  };
  /** @format int32 */
  completedRequestCount?: number;
  /**
   * @format int64
   * @min 0
   */
  completedRequestID?: number;
  full?: {
    enabled: boolean;
    /** @format int64 */
    interval: number;
  };
  id: string;
  /** @format date-time */
  lastModifiedTime?: string;
  /** @format date-time */
  lastProcessEndTime?: string;
  lastProcessError?: string;
  /** @format date-time */
  lastProcessStartTime?: string;
  maintenanceDeactivated: boolean;
  /** @format int32 */
  maintenanceRunsCompleted: number;
  monitoredByService: boolean;
  name: string;
  namespace: string;
  /** @format date-time */
  nextFullMaintenanceTime?: string;
  /** @format date-time */
  nextScheduledProcess?: string;
  repoHasBeenErroring: boolean;
  repoHasBeenIdle: boolean;
  repoIsReadOnly: boolean;
  snapshotStats?: {
    /** @format int32 */
    count: number;
    /** @format int64 */
    sizeB: number;
  };
}>;

export interface Namespace {
  compliance?: ComplianceData;
  /**
   * If true, the namespace currently exists. If false, the
   * namespace no longer exists, but can possibly be restored.
   */
  live: boolean;
  name?: string;
  /**
   * Indicates whether the namespace can be restored using different
   * sources of backups.
   */
  restoreCapability?: RestoreCapability;
  /** Key-value pairs */
  selector?: Selector;
}

export interface NamespaceInfo {
  name?: string;
}

export type NamespaceInfoList = Array<NamespaceInfo>;

export interface NamespaceListResponseData {
  /**
   * If true, the backend end is asynchronously
   * generating the list of namespaces for a user.
   * If false, the backend is not asynchronously
   * generating the list and instead returning
   * the cached list of namespaces.
   */
  loading: boolean;
  namespaces?: Array<Namespace>;
}

export type NamespacePhase = string;

export interface NodeAffinity {
  required?: {
    nodeSelectorTerms: Array<{
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchFields?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
    }>;
  };
}

export interface NodeUsageEntry {
  /** @format int32 */
  nodePeak: number;
  timePeriod: string;
}

export type NodeUsageHistory = Array<NodeUsageEntry>;

export interface ObjectMeta {
  annotations?: Record<string, string>;
  /** @format date-time */
  creationTimestamp?: string;
  /** @format int64 */
  deletionGracePeriodSeconds?: number;
  /** @format date-time */
  deletionTimestamp?: string;
  finalizers?: Array<string>;
  generateName?: string;
  /** @format int64 */
  generation?: number;
  labels?: Record<string, string>;
  managedFields?: Array<{
    apiVersion?: string;
    fieldsType?: string;
    fieldsV1?: {};
    manager?: string;
    operation?: string;
    subresource?: string;
    /** @format date-time */
    time?: string;
  }>;
  name?: string;
  namespace?: string;
  ownerReferences?: Array<{
    apiVersion: string;
    blockOwnerDeletion?: boolean;
    controller?: boolean;
    kind: string;
    name: string;
    uid: string;
  }>;
  resourceVersion?: string;
  selfLink?: string;
  uid?: string;
}

export type OperationType = string;

/** PVC stats */
export interface PVCStats {
  /**
   * The size of all PVC volumes, in bytes
   * @format int64
   */
  pvcBytes?: number;
  pvcCount?: number;
}

export type PageSize = string;

/** Partial restore of these kinds of objects. Empty means full restore */
export type PartialRestorePartList = Array<PartialRestorePart>;

export interface PasskeyConfig {
  /** An AWS passkey provider */
  awsPasskeyConfig?: AWSPasskeyConfig;
  /** An Azure Key Vault passkey provider */
  azurePassKeyConfig?: AzurePassKeyConfig;
  /** A K10 secret passphrase provider */
  k10SecretPasskeyConfig?: K10SecretPasskeyConfig;
  passkeyName: string;
  /** A Vault passkey provider */
  vaultPasskeyConfig?: VaultPasskeyConfig;
}

/** Passkey data from browser for creating passkey */
export interface PasskeyForm {
  awsCmkKeyId?: string;
  azureKeyName?: string;
  azureKeyVaultURL?: string;
  azureKeyVersion?: string;
  name?: string;
  passPhrase?: string;
  vaultTransitKeyName?: string;
  vaultTransitPath?: string;
}

export type PasskeyList = Array<PasskeyP>;

export interface PasskeyP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    awscmkkeyid?: string;
    azurekeyname?: string;
    azurekeyvaulturl?: string;
    secret?: {
      name?: string;
      namespace?: string;
    };
    vaultauthmountpath?: string;
    vaultauthrole?: string;
    vaultk8sserviceaccounttokenpath?: string;
    vaulttransitkeyname?: string;
    vaulttransitpath?: string;
  };
  status?: {
    state?: string;
    valid: boolean;
  };
}

export type PhasePlanReferenceMap = Record<
  string,
  {
    k10ArtifactIDs?: Array<string>;
    k8sReferences?: Array<{
      apiVersion?: string;
      group?: string;
      name?: string;
      namespace?: string;
      resource?: string;
      uid?: string;
    }>;
    k8sRuntimeObjects?: Array<Record<string, any>>;
  }
>;

export type PoliciesDetailsList = Array<PolicyDetails>;

export interface PolicyCR {
  policy?: PolicyP;
}

export type PolicyCRList = Array<PolicyP>;

export interface PolicyDetails {
  lastRun?: {
    error?: string;
    state?: string;
    /** @format date-time */
    time?: string;
    unauthorized: boolean;
  };
  policy?: {
    apiVersion?: string;
    kind?: string;
    metadata?: {
      annotations?: Record<string, string>;
      /** @format date-time */
      creationTimestamp?: string;
      /** @format int64 */
      deletionGracePeriodSeconds?: number;
      /** @format date-time */
      deletionTimestamp?: string;
      finalizers?: Array<string>;
      generateName?: string;
      /** @format int64 */
      generation?: number;
      labels?: Record<string, string>;
      managedFields?: Array<{
        apiVersion?: string;
        fieldsType?: string;
        fieldsV1?: {};
        manager?: string;
        operation?: string;
        subresource?: string;
        /** @format date-time */
        time?: string;
      }>;
      name?: string;
      namespace?: string;
      ownerReferences?: Array<{
        apiVersion: string;
        blockOwnerDeletion?: boolean;
        controller?: boolean;
        kind: string;
        name: string;
        uid: string;
      }>;
      resourceVersion?: string;
      selfLink?: string;
      uid?: string;
    };
    spec?: {
      actions?: Array<{
        action?: string;
        backupClusterParameters?: {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
        };
        backupParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          /** @format date-time */
          expiresAt?: string;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          imageRepoProfile?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
        };
        batchRestoreParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          artifactOverrideProfile?: {
            name: string;
            namespace?: string;
          };
          dataOnly?: boolean;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          overwriteExisting?: boolean;
          /** @format date-time */
          pointInTime?: string;
          profile?: {
            name: string;
            namespace?: string;
          };
          restoreClusterResources?: boolean;
          restorePointsDiscoveryRange?: {
            /** @format date-time */
            end?: string;
            /** @format date-time */
            start?: string;
          };
          skipWaitForWorkloadReady?: boolean;
          subjects: Array<{
            namespace: string;
            restorePointContentName?: string;
            restorePointName?: string;
          }>;
          targetNamespace?: string;
          targetNamespacePrefix?: string;
          targetNamespaceSuffix?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
          virtualMachineParameters?: {
            harvester?: {
              overrideVolumeImages?: Record<
                string,
                {
                  ignoreChecks?: boolean;
                  name?: string;
                  namespace?: string;
                }
              >;
            };
            preserveVMMacAddresses?: boolean;
          };
          volumeClones?: boolean;
        };
        exportParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          blockModeProfile?: {
            name: string;
            namespace?: string;
          };
          /** @format date-time */
          expiresAt?: string;
          exportData?: {
            enabled: boolean;
            exporterStorageClassName?: string;
            overrides?: Array<{
              enabled: boolean;
              exporterStorageClassName?: string;
              storageClassName: string;
            }>;
          };
          frequency?: string;
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          migrationToken?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          receiveString?: string;
          volumeSnapshots?: {
            awsEbs?: {
              destinationAccount?: string;
              regions?: Array<string>;
            };
            azure?: {
              regions?: Array<string>;
              resourceGroup?: string;
            };
          };
        };
        importParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          migrationToken?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          receiveString?: string;
        };
        reportParameters?: {
          /** @format int32 */
          statsIntervalDays?: number;
          /** @format int32 */
          statsIntervalHours?: number;
        };
        restoreClusterParameters?: {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        };
        restoreParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          artifactOverrideProfile?: {
            name: string;
            namespace?: string;
          };
          dataOnly?: boolean;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          overwriteExisting?: boolean;
          /** @format date-time */
          pointInTime?: string;
          profile?: {
            name: string;
            namespace?: string;
          };
          restoreClusterResources?: boolean;
          skipWaitForWorkloadReady?: boolean;
          targetNamespace?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
          virtualMachineParameters?: {
            harvester?: {
              overrideVolumeImages?: Record<
                string,
                {
                  ignoreChecks?: boolean;
                  name?: string;
                  namespace?: string;
                }
              >;
            };
            preserveVMMacAddresses?: boolean;
          };
          volumeClones?: boolean;
        };
        retention?: {
          /** @format int64 */
          daily?: number;
          /** @format int64 */
          hourly?: number;
          /** @format int64 */
          monthly?: number;
          table?: Array<{
            /** @format int64 */
            count?: number;
            crontab?: string;
          }>;
          /** @format int64 */
          weekly?: number;
          /** @format int64 */
          yearly?: number;
        };
        retireParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          /** @format int32 */
          retireIndex?: number;
        };
        stageParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          transformations?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        };
        upgradeParameters?: {
          profile?: {
            name: string;
            namespace?: string;
          };
        };
        validateParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          volumeDataCheckOptions?: {
            failFast?: boolean;
            verifyFilesPercent?: string;
          };
        };
      }>;
      backupWindow?: {
        end: {
          /** @format int32 */
          hour: number;
          /** @format int32 */
          minute: number;
        };
        start: {
          /** @format int32 */
          hour: number;
          /** @format int32 */
          minute: number;
        };
      };
      comment?: string;
      createdBy?: string;
      enableStaggering?: boolean;
      frequency?: string;
      kdrSnapshotConfiguration?: {
        exportCatalogSnapshot?: boolean;
        takeLocalCatalogSnapshot?: boolean;
      };
      /** @format int64 */
      lastModifyHash?: number;
      modifiedBy?: string;
      paused?: boolean;
      presetRef?: {
        name: string;
        namespace?: string;
      };
      retention?: {
        /** @format int64 */
        daily?: number;
        /** @format int64 */
        hourly?: number;
        /** @format int64 */
        monthly?: number;
        table?: Array<{
          /** @format int64 */
          count?: number;
          crontab?: string;
        }>;
        /** @format int64 */
        weekly?: number;
        /** @format int64 */
        yearly?: number;
      };
      selector?: {
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
      };
      subFrequency?: {
        days?: Array<number>;
        hours?: Array<number>;
        minutes?: Array<number>;
        months?: Array<number>;
        weekdays?: Array<number>;
      };
    };
    status?: {
      error?: Array<string>;
      /** @format int64 */
      hash?: number;
      /** @format date-time */
      specModifiedTime?: string;
      validation?: string;
    };
  };
  preset?: {
    error?: string;
    preset?: {
      apiVersion?: string;
      kind?: string;
      metadata?: {
        annotations?: Record<string, string>;
        /** @format date-time */
        creationTimestamp?: string;
        /** @format int64 */
        deletionGracePeriodSeconds?: number;
        /** @format date-time */
        deletionTimestamp?: string;
        finalizers?: Array<string>;
        generateName?: string;
        /** @format int64 */
        generation?: number;
        labels?: Record<string, string>;
        managedFields?: Array<{
          apiVersion?: string;
          fieldsType?: string;
          fieldsV1?: {};
          manager?: string;
          operation?: string;
          subresource?: string;
          /** @format date-time */
          time?: string;
        }>;
        name?: string;
        namespace?: string;
        ownerReferences?: Array<{
          apiVersion: string;
          blockOwnerDeletion?: boolean;
          controller?: boolean;
          kind: string;
          name: string;
          uid: string;
        }>;
        resourceVersion?: string;
        selfLink?: string;
        uid?: string;
      };
      spec: {
        backup?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          backupWindow?: {
            end: {
              /** @format int32 */
              hour: number;
              /** @format int32 */
              minute: number;
            };
            start: {
              /** @format int32 */
              hour: number;
              /** @format int32 */
              minute: number;
            };
          };
          enableStaggering?: boolean;
          frequency: string;
          imageRepoProfile?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          retention: {
            /** @format int64 */
            daily?: number;
            /** @format int64 */
            hourly?: number;
            /** @format int64 */
            monthly?: number;
            table?: Array<{
              /** @format int64 */
              count?: number;
              crontab?: string;
            }>;
            /** @format int64 */
            weekly?: number;
            /** @format int64 */
            yearly?: number;
          };
          subFrequency?: {
            days?: Array<number>;
            hours?: Array<number>;
            minutes?: Array<number>;
            months?: Array<number>;
            weekdays?: Array<number>;
          };
        };
        comment?: string;
        export?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          blockModeProfile?: {
            name: string;
            namespace?: string;
          };
          exportData: {
            enabled: boolean;
            exporterStorageClassName?: string;
            overrides?: Array<{
              enabled: boolean;
              exporterStorageClassName?: string;
              storageClassName: string;
            }>;
          };
          frequency?: string;
          profile: {
            name: string;
            namespace?: string;
          };
          retention?: {
            /** @format int64 */
            daily?: number;
            /** @format int64 */
            hourly?: number;
            /** @format int64 */
            monthly?: number;
            table?: Array<{
              /** @format int64 */
              count?: number;
              crontab?: string;
            }>;
            /** @format int64 */
            weekly?: number;
            /** @format int64 */
            yearly?: number;
          };
          volumeSnapshots?: {
            awsEbs?: {
              destinationAccount?: string;
              regions?: Array<string>;
            };
            azure?: {
              regions?: Array<string>;
              resourceGroup?: string;
            };
          };
        };
        exports?: Array<{
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          blockModeProfile?: {
            name: string;
            namespace?: string;
          };
          exportData: {
            enabled: boolean;
            exporterStorageClassName?: string;
            overrides?: Array<{
              enabled: boolean;
              exporterStorageClassName?: string;
              storageClassName: string;
            }>;
          };
          frequency?: string;
          profile: {
            name: string;
            namespace?: string;
          };
          retention?: {
            /** @format int64 */
            daily?: number;
            /** @format int64 */
            hourly?: number;
            /** @format int64 */
            monthly?: number;
            table?: Array<{
              /** @format int64 */
              count?: number;
              crontab?: string;
            }>;
            /** @format int64 */
            weekly?: number;
            /** @format int64 */
            yearly?: number;
          };
          volumeSnapshots?: {
            awsEbs?: {
              destinationAccount?: string;
              regions?: Array<string>;
            };
            azure?: {
              regions?: Array<string>;
              resourceGroup?: string;
            };
          };
        }>;
      };
      status?: {
        error?: Array<string>;
        /** @format date-time */
        lastValidatedAt?: string;
        /** @format int64 */
        observedGeneration?: number;
        type?: string;
        validation?: string;
      };
    };
    unauthorized: boolean;
  };
}

export interface PolicyP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actions?: Array<{
      action?: string;
      backupClusterParameters?: {
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
      };
      backupParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        /** @format date-time */
        expiresAt?: string;
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        hooks?: {
          onFailure?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          onSuccess?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          preHook?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
        };
        ignoreExceptions?: boolean;
        imageRepoProfile?: {
          name: string;
          namespace?: string;
        };
        profile?: {
          name: string;
          namespace?: string;
        };
      };
      batchRestoreParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        artifactOverrideProfile?: {
          name: string;
          namespace?: string;
        };
        dataOnly?: boolean;
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        hooks?: {
          onFailure?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          onSuccess?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          preHook?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
        };
        ignoreExceptions?: boolean;
        overwriteExisting?: boolean;
        /** @format date-time */
        pointInTime?: string;
        profile?: {
          name: string;
          namespace?: string;
        };
        restoreClusterResources?: boolean;
        restorePointsDiscoveryRange?: {
          /** @format date-time */
          end?: string;
          /** @format date-time */
          start?: string;
        };
        skipWaitForWorkloadReady?: boolean;
        subjects: Array<{
          namespace: string;
          restorePointContentName?: string;
          restorePointName?: string;
        }>;
        targetNamespace?: string;
        targetNamespacePrefix?: string;
        targetNamespaceSuffix?: string;
        transforms?: Array<{
          comment?: string;
          json: Array<{
            from?: string;
            op: string;
            path?: string;
            regex?: string;
            value?: string;
          }>;
          name?: string;
          subject?: {
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          };
          transformSetRef?: {
            name: string;
            namespace?: string;
          };
        }>;
        virtualMachineParameters?: {
          harvester?: {
            overrideVolumeImages?: Record<
              string,
              {
                ignoreChecks?: boolean;
                name?: string;
                namespace?: string;
              }
            >;
          };
          preserveVMMacAddresses?: boolean;
        };
        volumeClones?: boolean;
      };
      exportParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        blockModeProfile?: {
          name: string;
          namespace?: string;
        };
        /** @format date-time */
        expiresAt?: string;
        exportData?: {
          enabled: boolean;
          exporterStorageClassName?: string;
          overrides?: Array<{
            enabled: boolean;
            exporterStorageClassName?: string;
            storageClassName: string;
          }>;
        };
        frequency?: string;
        hooks?: {
          onFailure?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          onSuccess?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          preHook?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
        };
        ignoreExceptions?: boolean;
        migrationToken?: {
          name: string;
          namespace?: string;
        };
        profile?: {
          name: string;
          namespace?: string;
        };
        receiveString?: string;
        volumeSnapshots?: {
          awsEbs?: {
            destinationAccount?: string;
            regions?: Array<string>;
          };
          azure?: {
            regions?: Array<string>;
            resourceGroup?: string;
          };
        };
      };
      importParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        migrationToken?: {
          name: string;
          namespace?: string;
        };
        profile?: {
          name: string;
          namespace?: string;
        };
        receiveString?: string;
      };
      reportParameters?: {
        /** @format int32 */
        statsIntervalDays?: number;
        /** @format int32 */
        statsIntervalHours?: number;
      };
      restoreClusterParameters?: {
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        hooks?: {
          onFailure?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          onSuccess?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          preHook?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
        };
        transforms?: Array<{
          comment?: string;
          json: Array<{
            from?: string;
            op: string;
            path?: string;
            regex?: string;
            value?: string;
          }>;
          name?: string;
          subject?: {
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          };
          transformSetRef?: {
            name: string;
            namespace?: string;
          };
        }>;
      };
      restoreParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        artifactOverrideProfile?: {
          name: string;
          namespace?: string;
        };
        dataOnly?: boolean;
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        hooks?: {
          onFailure?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          onSuccess?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
          preHook?: {
            actionName?: string;
            blueprint?: string;
            subject?: {
              name?: string;
              namespace?: string;
              type?: string;
            };
          };
        };
        ignoreExceptions?: boolean;
        overwriteExisting?: boolean;
        /** @format date-time */
        pointInTime?: string;
        profile?: {
          name: string;
          namespace?: string;
        };
        restoreClusterResources?: boolean;
        skipWaitForWorkloadReady?: boolean;
        targetNamespace?: string;
        transforms?: Array<{
          comment?: string;
          json: Array<{
            from?: string;
            op: string;
            path?: string;
            regex?: string;
            value?: string;
          }>;
          name?: string;
          subject?: {
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          };
          transformSetRef?: {
            name: string;
            namespace?: string;
          };
        }>;
        virtualMachineParameters?: {
          harvester?: {
            overrideVolumeImages?: Record<
              string,
              {
                ignoreChecks?: boolean;
                name?: string;
                namespace?: string;
              }
            >;
          };
          preserveVMMacAddresses?: boolean;
        };
        volumeClones?: boolean;
      };
      retention?: {
        /** @format int64 */
        daily?: number;
        /** @format int64 */
        hourly?: number;
        /** @format int64 */
        monthly?: number;
        table?: Array<{
          /** @format int64 */
          count?: number;
          crontab?: string;
        }>;
        /** @format int64 */
        weekly?: number;
        /** @format int64 */
        yearly?: number;
      };
      retireParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        /** @format int32 */
        retireIndex?: number;
      };
      stageParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        transformations?: Array<{
          comment?: string;
          json: Array<{
            from?: string;
            op: string;
            path?: string;
            regex?: string;
            value?: string;
          }>;
          name?: string;
          subject?: {
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          };
          transformSetRef?: {
            name: string;
            namespace?: string;
          };
        }>;
      };
      upgradeParameters?: {
        profile?: {
          name: string;
          namespace?: string;
        };
      };
      validateParameters?: {
        actionPodSpec?: {
          name: string;
          namespace?: string;
        };
        filters?: {
          excludeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          excludeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeClusterResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeExtraResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
          includeResources?: Array<{
            group?: string;
            matchExpressions?: Array<{
              key: string;
              operator: string;
              values?: Array<string>;
            }>;
            matchLabels?: Record<string, string>;
            name?: string;
            resource?: string;
            version?: string;
          }>;
        };
        volumeDataCheckOptions?: {
          failFast?: boolean;
          verifyFilesPercent?: string;
        };
      };
    }>;
    backupWindow?: {
      end: {
        /** @format int32 */
        hour: number;
        /** @format int32 */
        minute: number;
      };
      start: {
        /** @format int32 */
        hour: number;
        /** @format int32 */
        minute: number;
      };
    };
    comment?: string;
    createdBy?: string;
    enableStaggering?: boolean;
    frequency?: string;
    kdrSnapshotConfiguration?: {
      exportCatalogSnapshot?: boolean;
      takeLocalCatalogSnapshot?: boolean;
    };
    /** @format int64 */
    lastModifyHash?: number;
    modifiedBy?: string;
    paused?: boolean;
    presetRef?: {
      name: string;
      namespace?: string;
    };
    retention?: {
      /** @format int64 */
      daily?: number;
      /** @format int64 */
      hourly?: number;
      /** @format int64 */
      monthly?: number;
      table?: Array<{
        /** @format int64 */
        count?: number;
        crontab?: string;
      }>;
      /** @format int64 */
      weekly?: number;
      /** @format int64 */
      yearly?: number;
    };
    selector?: {
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
    };
    subFrequency?: {
      days?: Array<number>;
      hours?: Array<number>;
      minutes?: Array<number>;
      months?: Array<number>;
      weekdays?: Array<number>;
    };
  };
  status?: {
    error?: Array<string>;
    /** @format int64 */
    hash?: number;
    /** @format date-time */
    specModifiedTime?: string;
    validation?: string;
  };
}

/** Per policy optional parameters */
export interface PolicyParameters {
  /** Parameters for copy */
  copy?: PolicyParametersCopy;
  /** Migration receive policy */
  migrationReceive?: PolicyParametersMigrationReceive;
  /** Migration send policy */
  migrationSend?: PolicyParametersMigrationSend;
  restore?: RestoreParameters;
  /** Parameters for snapshot policy */
  snapshot?: PolicyParametersSnapshot;
}

/** Parameters for copy */
export interface PolicyParametersCopy {
  /** Frequency of copy operation */
  frequency?: TimeTable;
}

/** Migration receive policy */
export interface PolicyParametersMigrationReceive {
  /**
   * Opaque string that describes where to receive migration artifacts from
   * @format string
   */
  receiveString?: string;
  /** Automatically restore after importing */
  restoreAfterImport?: boolean;
  /** MigrationSource Profile CRD reference */
  sourceProfile?: ReferenceP;
  /**
   * Profile ID of type MigrationSource
   * @format uuid
   */
  sourceProfileID?: string;
}

/** Migration send policy */
export interface PolicyParametersMigrationSend {
  /**
   * Opaque string that describes where to receive migration artifacts created by this policy from
   * @format string
   */
  receiveString?: string;
  /** MigrationTarget Profile CRD reference */
  targetProfile?: ReferenceP;
  /**
   * Profile ID of type MigrationTarget
   * @format uuid
   */
  targetProfileID?: string;
}

export interface PolicyParametersP {
  actions?: Array<{
    action?: string;
    backupClusterParameters?: {
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
    };
    backupParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      /** @format date-time */
      expiresAt?: string;
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
      hooks?: {
        onFailure?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        onSuccess?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        preHook?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
      };
      ignoreExceptions?: boolean;
      imageRepoProfile?: {
        name: string;
        namespace?: string;
      };
      profile?: {
        name: string;
        namespace?: string;
      };
    };
    batchRestoreParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      artifactOverrideProfile?: {
        name: string;
        namespace?: string;
      };
      dataOnly?: boolean;
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
      hooks?: {
        onFailure?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        onSuccess?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        preHook?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
      };
      ignoreExceptions?: boolean;
      overwriteExisting?: boolean;
      /** @format date-time */
      pointInTime?: string;
      profile?: {
        name: string;
        namespace?: string;
      };
      restoreClusterResources?: boolean;
      restorePointsDiscoveryRange?: {
        /** @format date-time */
        end?: string;
        /** @format date-time */
        start?: string;
      };
      skipWaitForWorkloadReady?: boolean;
      subjects: Array<{
        namespace: string;
        restorePointContentName?: string;
        restorePointName?: string;
      }>;
      targetNamespace?: string;
      targetNamespacePrefix?: string;
      targetNamespaceSuffix?: string;
      transforms?: Array<{
        comment?: string;
        json: Array<{
          from?: string;
          op: string;
          path?: string;
          regex?: string;
          value?: string;
        }>;
        name?: string;
        subject?: {
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        };
        transformSetRef?: {
          name: string;
          namespace?: string;
        };
      }>;
      virtualMachineParameters?: {
        harvester?: {
          overrideVolumeImages?: Record<
            string,
            {
              ignoreChecks?: boolean;
              name?: string;
              namespace?: string;
            }
          >;
        };
        preserveVMMacAddresses?: boolean;
      };
      volumeClones?: boolean;
    };
    exportParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      blockModeProfile?: {
        name: string;
        namespace?: string;
      };
      /** @format date-time */
      expiresAt?: string;
      exportData?: {
        enabled: boolean;
        exporterStorageClassName?: string;
        overrides?: Array<{
          enabled: boolean;
          exporterStorageClassName?: string;
          storageClassName: string;
        }>;
      };
      frequency?: string;
      hooks?: {
        onFailure?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        onSuccess?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        preHook?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
      };
      ignoreExceptions?: boolean;
      migrationToken?: {
        name: string;
        namespace?: string;
      };
      profile?: {
        name: string;
        namespace?: string;
      };
      receiveString?: string;
      volumeSnapshots?: {
        awsEbs?: {
          destinationAccount?: string;
          regions?: Array<string>;
        };
        azure?: {
          regions?: Array<string>;
          resourceGroup?: string;
        };
      };
    };
    importParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      migrationToken?: {
        name: string;
        namespace?: string;
      };
      profile?: {
        name: string;
        namespace?: string;
      };
      receiveString?: string;
    };
    reportParameters?: {
      /** @format int32 */
      statsIntervalDays?: number;
      /** @format int32 */
      statsIntervalHours?: number;
    };
    restoreClusterParameters?: {
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
      hooks?: {
        onFailure?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        onSuccess?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        preHook?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
      };
      transforms?: Array<{
        comment?: string;
        json: Array<{
          from?: string;
          op: string;
          path?: string;
          regex?: string;
          value?: string;
        }>;
        name?: string;
        subject?: {
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        };
        transformSetRef?: {
          name: string;
          namespace?: string;
        };
      }>;
    };
    restoreParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      artifactOverrideProfile?: {
        name: string;
        namespace?: string;
      };
      dataOnly?: boolean;
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
      hooks?: {
        onFailure?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        onSuccess?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
        preHook?: {
          actionName?: string;
          blueprint?: string;
          subject?: {
            name?: string;
            namespace?: string;
            type?: string;
          };
        };
      };
      ignoreExceptions?: boolean;
      overwriteExisting?: boolean;
      /** @format date-time */
      pointInTime?: string;
      profile?: {
        name: string;
        namespace?: string;
      };
      restoreClusterResources?: boolean;
      skipWaitForWorkloadReady?: boolean;
      targetNamespace?: string;
      transforms?: Array<{
        comment?: string;
        json: Array<{
          from?: string;
          op: string;
          path?: string;
          regex?: string;
          value?: string;
        }>;
        name?: string;
        subject?: {
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        };
        transformSetRef?: {
          name: string;
          namespace?: string;
        };
      }>;
      virtualMachineParameters?: {
        harvester?: {
          overrideVolumeImages?: Record<
            string,
            {
              ignoreChecks?: boolean;
              name?: string;
              namespace?: string;
            }
          >;
        };
        preserveVMMacAddresses?: boolean;
      };
      volumeClones?: boolean;
    };
    retention?: {
      /** @format int64 */
      daily?: number;
      /** @format int64 */
      hourly?: number;
      /** @format int64 */
      monthly?: number;
      table?: Array<{
        /** @format int64 */
        count?: number;
        crontab?: string;
      }>;
      /** @format int64 */
      weekly?: number;
      /** @format int64 */
      yearly?: number;
    };
    retireParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      /** @format int32 */
      retireIndex?: number;
    };
    stageParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
      transformations?: Array<{
        comment?: string;
        json: Array<{
          from?: string;
          op: string;
          path?: string;
          regex?: string;
          value?: string;
        }>;
        name?: string;
        subject?: {
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        };
        transformSetRef?: {
          name: string;
          namespace?: string;
        };
      }>;
    };
    upgradeParameters?: {
      profile?: {
        name: string;
        namespace?: string;
      };
    };
    validateParameters?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      filters?: {
        excludeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        excludeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeClusterResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeExtraResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
        includeResources?: Array<{
          group?: string;
          matchExpressions?: Array<{
            key: string;
            operator: string;
            values?: Array<string>;
          }>;
          matchLabels?: Record<string, string>;
          name?: string;
          resource?: string;
          version?: string;
        }>;
      };
      volumeDataCheckOptions?: {
        failFast?: boolean;
        verifyFilesPercent?: string;
      };
    };
  }>;
  backupWindow?: {
    end: {
      /** @format int32 */
      hour: number;
      /** @format int32 */
      minute: number;
    };
    start: {
      /** @format int32 */
      hour: number;
      /** @format int32 */
      minute: number;
    };
  };
  comment?: string;
  createdBy?: string;
  enableStaggering?: boolean;
  frequency?: string;
  kdrSnapshotConfiguration?: {
    exportCatalogSnapshot?: boolean;
    takeLocalCatalogSnapshot?: boolean;
  };
  /** @format int64 */
  lastModifyHash?: number;
  modifiedBy?: string;
  paused?: boolean;
  policymeta: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  presetRef?: {
    name: string;
    namespace?: string;
  };
  retention?: {
    /** @format int64 */
    daily?: number;
    /** @format int64 */
    hourly?: number;
    /** @format int64 */
    monthly?: number;
    table?: Array<{
      /** @format int64 */
      count?: number;
      crontab?: string;
    }>;
    /** @format int64 */
    weekly?: number;
    /** @format int64 */
    yearly?: number;
  };
  selector?: {
    matchExpressions?: Array<{
      key: string;
      operator: string;
      values?: Array<string>;
    }>;
    matchLabels?: Record<string, string>;
  };
  subFrequency?: {
    days?: Array<number>;
    hours?: Array<number>;
    minutes?: Array<number>;
    months?: Array<number>;
    weekdays?: Array<number>;
  };
}

/** Parameters for snapshot policy */
export interface PolicyParametersSnapshot {
  /**
   * Snapshot apps selected by namespace or label
   * Submitted in Manifest with Policy Subject and fanned out
   * into child manifests for each app
   */
  appSelectors?: SelectorList;
  /** Describes which of the snapshots should be selected for export */
  exportSelector?: TimeTable;
}

export interface PolicyPreset {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec: {
    backup?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      backupWindow?: {
        end: {
          /** @format int32 */
          hour: number;
          /** @format int32 */
          minute: number;
        };
        start: {
          /** @format int32 */
          hour: number;
          /** @format int32 */
          minute: number;
        };
      };
      enableStaggering?: boolean;
      frequency: string;
      imageRepoProfile?: {
        name: string;
        namespace?: string;
      };
      profile?: {
        name: string;
        namespace?: string;
      };
      retention: {
        /** @format int64 */
        daily?: number;
        /** @format int64 */
        hourly?: number;
        /** @format int64 */
        monthly?: number;
        table?: Array<{
          /** @format int64 */
          count?: number;
          crontab?: string;
        }>;
        /** @format int64 */
        weekly?: number;
        /** @format int64 */
        yearly?: number;
      };
      subFrequency?: {
        days?: Array<number>;
        hours?: Array<number>;
        minutes?: Array<number>;
        months?: Array<number>;
        weekdays?: Array<number>;
      };
    };
    comment?: string;
    export?: {
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      blockModeProfile?: {
        name: string;
        namespace?: string;
      };
      exportData: {
        enabled: boolean;
        exporterStorageClassName?: string;
        overrides?: Array<{
          enabled: boolean;
          exporterStorageClassName?: string;
          storageClassName: string;
        }>;
      };
      frequency?: string;
      profile: {
        name: string;
        namespace?: string;
      };
      retention?: {
        /** @format int64 */
        daily?: number;
        /** @format int64 */
        hourly?: number;
        /** @format int64 */
        monthly?: number;
        table?: Array<{
          /** @format int64 */
          count?: number;
          crontab?: string;
        }>;
        /** @format int64 */
        weekly?: number;
        /** @format int64 */
        yearly?: number;
      };
      volumeSnapshots?: {
        awsEbs?: {
          destinationAccount?: string;
          regions?: Array<string>;
        };
        azure?: {
          regions?: Array<string>;
          resourceGroup?: string;
        };
      };
    };
    exports?: Array<{
      actionPodSpec?: {
        name: string;
        namespace?: string;
      };
      blockModeProfile?: {
        name: string;
        namespace?: string;
      };
      exportData: {
        enabled: boolean;
        exporterStorageClassName?: string;
        overrides?: Array<{
          enabled: boolean;
          exporterStorageClassName?: string;
          storageClassName: string;
        }>;
      };
      frequency?: string;
      profile: {
        name: string;
        namespace?: string;
      };
      retention?: {
        /** @format int64 */
        daily?: number;
        /** @format int64 */
        hourly?: number;
        /** @format int64 */
        monthly?: number;
        table?: Array<{
          /** @format int64 */
          count?: number;
          crontab?: string;
        }>;
        /** @format int64 */
        weekly?: number;
        /** @format int64 */
        yearly?: number;
      };
      volumeSnapshots?: {
        awsEbs?: {
          destinationAccount?: string;
          regions?: Array<string>;
        };
        azure?: {
          regions?: Array<string>;
          resourceGroup?: string;
        };
      };
    }>;
  };
  status?: {
    error?: Array<string>;
    /** @format date-time */
    lastValidatedAt?: string;
    /** @format int64 */
    observedGeneration?: number;
    type?: string;
    validation?: string;
  };
}

export interface PolicyPresetCR {
  policyPreset?: PolicyPreset;
}

export type PolicyPresetList = Array<PolicyPreset>;

export interface PolicySelectingAnApp {
  lastRun?: {
    error?: string;
    state?: string;
    /** @format date-time */
    time?: string;
    unauthorized: boolean;
  };
  name: string;
  namespace?: string;
  validation?: string;
}

/** Current status for an upgrade */
export interface PolicyUpgradeStatus {
  currentVersion?: number;
  expectedVersion?: number;
  name?: string;
  namespace?: string;
  /** Current state of an upgrade */
  state?: PolicyUpgradeState;
  uid?: string;
}

export interface ProfileCR {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec: {
    export?: {
      credential: {
        secret: {
          apiVersion: string;
          kind: string;
          name: string;
          namespace: string;
        };
        secretType: string;
      };
      destinationAccount?: string;
      infraPortable?: boolean;
      location: {
        fileStore?: {
          claimName?: string;
          path?: string;
          /** @format int64 */
          suppGroup?: number;
        };
        imageRepo?: {
          endpoint?: string;
          skipSSLVerify?: boolean;
        };
        objectStore?: {
          endpoint?: string;
          name: string;
          objectStoreType: string;
          path?: string;
          pathType?: string;
          protectionPeriod?: string;
          region?: string;
          skipSSLVerify?: boolean;
        };
        type: string;
        vbr?: {
          repoId?: string;
          repoName?: string;
          repoType?: string;
          serverAddress?: string;
          serverId?: string;
          /** @format int32 */
          serverPort?: number;
          serverThumbprint?: string;
          serverVersion?: string;
          skipSSLVerify?: boolean;
          /** @format int32 */
          vmbApiPort?: number;
        };
      };
      role?: string;
    };
    import?: {
      credential: {
        secret: {
          apiVersion: string;
          kind: string;
          name: string;
          namespace: string;
        };
        secretType: string;
      };
      location: {
        fileStore?: {
          claimName?: string;
          path?: string;
          /** @format int64 */
          suppGroup?: number;
        };
        imageRepo?: {
          endpoint?: string;
          skipSSLVerify?: boolean;
        };
        objectStore?: {
          endpoint?: string;
          name: string;
          objectStoreType: string;
          path?: string;
          pathType?: string;
          protectionPeriod?: string;
          region?: string;
          skipSSLVerify?: boolean;
        };
        type: string;
        vbr?: {
          repoId?: string;
          repoName?: string;
          repoType?: string;
          serverAddress?: string;
          serverId?: string;
          /** @format int32 */
          serverPort?: number;
          serverThumbprint?: string;
          serverVersion?: string;
          skipSSLVerify?: boolean;
          /** @format int32 */
          vmbApiPort?: number;
        };
      };
      role?: string;
    };
    infra?: {
      aws?: {
        disableEBSDirectForBlockMode?: boolean;
        hasAccessForEBS?: boolean;
        hasAccessForEFS?: boolean;
      };
      azure?: {
        ADEndpoint?: string;
        ADResource?: string;
        cloudEnv?: string;
        credentialType?: string;
        resourceGroup?: string;
        resourceManagerEndpoint?: string;
        subscriptionID?: string;
        useDefaultMSI?: boolean;
        useFederatedIdentity?: boolean;
      };
      credential?: {
        secret: {
          apiVersion: string;
          kind: string;
          name: string;
          namespace: string;
        };
        secretType: string;
      };
      openStack?: {
        cinderEndpoint?: string;
        keystoneEndpoint?: string;
      };
      portworx?: {
        namespace?: string;
        serviceName?: string;
      };
      type?: string;
      vsphere?: {
        guestClusterName?: string;
        guestClusterUid?: string;
        paraVirtualizedVolumes?: boolean;
        serverAddress?: string;
      };
    };
    kanister?: {
      credential: {
        secret: {
          apiVersion: string;
          kind: string;
          name: string;
          namespace: string;
        };
        secretType: string;
      };
      location: {
        fileStore?: {
          claimName?: string;
          path?: string;
          /** @format int64 */
          suppGroup?: number;
        };
        imageRepo?: {
          endpoint?: string;
          skipSSLVerify?: boolean;
        };
        objectStore?: {
          endpoint?: string;
          name: string;
          objectStoreType: string;
          path?: string;
          pathType?: string;
          protectionPeriod?: string;
          region?: string;
          skipSSLVerify?: boolean;
        };
        type: string;
        vbr?: {
          repoId?: string;
          repoName?: string;
          repoType?: string;
          serverAddress?: string;
          serverId?: string;
          /** @format int32 */
          serverPort?: number;
          serverThumbprint?: string;
          serverVersion?: string;
          skipSSLVerify?: boolean;
          /** @format int32 */
          vmbApiPort?: number;
        };
      };
    };
    locationSpec?: {
      credential?: {
        secret: {
          apiVersion: string;
          kind: string;
          name: string;
          namespace: string;
        };
        secretType: string;
      };
      fileStore?: {
        claimName?: string;
        path?: string;
        /** @format int64 */
        suppGroup?: number;
      };
      imageRepo?: {
        endpoint?: string;
        skipSSLVerify?: boolean;
      };
      infraPortable?: boolean;
      objectStore?: {
        endpoint?: string;
        name: string;
        objectStoreType: string;
        path?: string;
        pathType?: string;
        protectionPeriod?: string;
        region?: string;
        skipSSLVerify?: boolean;
      };
      type: string;
      vbr?: {
        repoId?: string;
        repoName?: string;
        repoType?: string;
        serverAddress?: string;
        serverId?: string;
        /** @format int32 */
        serverPort?: number;
        serverThumbprint?: string;
        serverVersion?: string;
        skipSSLVerify?: boolean;
        /** @format int32 */
        vmbApiPort?: number;
      };
    };
    type: string;
  };
  status?: {
    error?: Array<string>;
    /** @format int64 */
    hash?: number;
    infra?: {
      aws?: {
        hasAccessForEBS?: boolean;
        hasAccessForEBSDirect?: boolean;
        hasAccessForEFS?: boolean;
      };
    };
    kanisterProfileCR?: {
      apiVersion: string;
      kind: string;
      name: string;
      namespace: string;
    };
    validation?: string;
    warning?: Array<string>;
  };
}

/** Profile data from browser for creating/editing profile */
export interface ProfileCRForm {
  profile?: ProfileCR;
  secret?: Secret;
}

export type ProfileCRList = Array<ProfileCR>;

/** Prometheus range query response */
export interface PromRangeQueryResponse {
  data?: PromRangeQueryResponseData;
  status?: string;
}

export interface PromRangeQueryResponseData {
  result?: PromResult;
  resultType?: string;
}

export type PromResult = Array<{
  histograms: Array<{
    Histogram: {
      buckets: Array<{
        /** @format int32 */
        Boundaries: number;
        /** @format double */
        Count: number;
        /** @format double */
        Lower: number;
        /** @format double */
        Upper: number;
      }>;
      /** @format double */
      count: number;
      /** @format double */
      sum: number;
    };
    /** @format int64 */
    Timestamp: number;
  }>;
  metric: Record<string, string>;
  values: Array<Array<number>>;
}>;

export interface PrometheusScrapeTarget {
  labels: Record<string, string>;
  targets: Array<string>;
}

export type PrometheusScrapeTargets = Array<PrometheusScrapeTarget>;

export interface ProtectedDeployment {
  annotations?: Array<KeyValue>;
  /** K8s Labels (metadata.labels) */
  labels?: Array<Label>;
  /** Name of the Deployment */
  name?: string;
}

export interface ProtectedDeploymentConfig {
  annotations?: Array<KeyValue>;
  /** K8s Labels (metadata.labels) */
  labels?: Array<Label>;
  /** Name of the DeploymentConfig */
  name?: string;
}

export interface ProtectedNamespace {
  annotations?: Array<KeyValue>;
  /** K8s Labels (metadata.labels) */
  labels?: Array<Label>;
  /** Name of the Namespace */
  name?: string;
  phase?: NamespacePhase;
}

/** Object to be protected e.g. kubernetes workload */
export interface ProtectedObject {
  deployment?: ProtectedDeployment;
  deploymentConfig?: ProtectedDeploymentConfig;
  /**
   * Protected object identifier
   * @format uuid
   */
  id: string;
  /**
   * Namespace name
   * @example "default"
   */
  namespace?: string;
  ns?: ProtectedNamespace;
  /** Type of protected object e.g. Kubernetes Deployment */
  protectedObjectType: ProtectedObjectType;
  statefulSet?: ProtectedStatefulSet;
  virtualMachine?: ProtectedVirtualMachine;
}

export type ProtectedObjectList = Array<ProtectedObject>;

/** Top level k8s object that owns a protected object */
export interface ProtectedObjectOwner {
  /**
   * The name of the owning object
   * @example "nginx"
   */
  name?: string;
  /**
   * Namespace the owning object is in
   * @example "default"
   */
  namespace?: string;
  /** k8s object type */
  type?: K8SObjectType;
}

export interface ProtectedStatefulSet {
  annotations?: Array<KeyValue>;
  /** K8s Labels (metadata.labels) */
  labels?: Array<Label>;
  /** Name of the StatefulSet */
  name?: string;
}

export interface ProtectedVirtualMachine {
  annotations?: Array<KeyValue>;
  labels?: Array<Label>;
  /** Name of the Virtual Machine */
  name?: string;
  status?: VirtualMachineStatus;
}

export interface PushedMetric {
  labels?: Array<{
    name?: string;
    value?: string;
  }>;
  /** Time stamp for an event related to an object, for example when the object was created. */
  lastTime?: TimeStamp;
  podName?: string;
  value?: string;
}

export interface PushedMetricFamily {
  metricType?: string;
  metrics?: Array<PushedMetric>;
  name?: string;
}

export interface QueuedJob {
  /**
   * Id of this job on the job queue
   * @format string
   */
  id?: string;
  /** Associated job ID and cancel request state */
  job?: {
    /** Cancellation requested for this job */
    cancelRequested?: boolean;
    /** Item identifier */
    id?: ItemId;
  };
}

export type QueuedJobList = Array<QueuedJob>;

export interface QueuedMsg {
  kind: string;
  message: string;
  msgID: string;
}

export type RBACNamespace = string;

export type RBACNamespaceList = Array<RBACNamespace>;

export interface ReferenceId {
  /** Item identifier */
  id?: ItemId;
}

/** List of references to other objects */
export type ReferenceList = Array<ReferenceId>;

export interface ReferenceP {
  name: string;
  namespace?: string;
}

/** List of references to other objects */
export type ReferencePList = Array<ReferenceP>;

export interface Report {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  results?: {
    actions?: {
      countStats: {
        backup: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        backupCluster: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        export: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        import: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        report: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        restore: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        restoreCluster: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
        run: {
          /** @format int32 */
          cancelled: number;
          /** @format int32 */
          completed: number;
          /** @format int32 */
          failed: number;
          /** @format int32 */
          skipped: number;
        };
      };
    };
    compliance?: {
      /** @format int32 */
      applicationCount: number;
      /** @format int32 */
      compliantCount: number;
      loading?: boolean;
      /** @format int32 */
      nonCompliantCount: number;
      someNonCompliantApps?: Array<{
        name: string;
      }>;
      /** @format int32 */
      unmanagedCount: number;
    };
    general?: {
      aws?: {
        role?: string;
      };
      clusterId?: string;
      clusterName?: string;
      clusterRegion?: string;
      infraType: {
        isOpenShift: boolean;
        provider?: string;
      };
      k10Version: string;
      k10namespace?: string;
      k8sVersion: string;
    };
    k10Services?: Array<{
      diskUsage: {
        /** @format int64 */
        freeBytes: number;
        /** @format int32 */
        freePercentage: number;
        /** @format int64 */
        usedBytes: number;
      };
      name: string;
    }>;
    licensing?: {
      /** @format date-time */
      expiry: string;
      /** @format int32 */
      nodeCount: number;
      /** @format int32 */
      nodeLimit: number;
      status: string;
      type: string;
    };
    policies?: {
      k10DR: {
        backupFrequency: string;
        immutability: {
          protection: string;
          /** @format int32 */
          protectionDays: number;
        };
        profile: string;
        status: string;
      };
      summaries: Array<{
        actions: Array<string>;
        frequency: string;
        name: string;
        namespace: string;
        paused?: boolean;
        profileNames: Array<string>;
        validation: string;
      }>;
    };
    profiles?: {
      summaries: Array<{
        bucket?: string;
        claimName?: string;
        dataPortability?: string;
        endpoint?: string;
        immutability: {
          protection: string;
          /** @format int32 */
          protectionDays: number;
        };
        name: string;
        objectStoreType?: string;
        path?: string;
        region?: string;
        sslVerification?: string;
        /** @format int64 */
        suppGroup?: number;
        type: string;
        validation: string;
        /** @format int32 */
        vbrPort?: number;
        vbrRepoName?: string;
        vbrServer?: string;
      }>;
    };
    storage?: {
      objectStorage: {
        /** @format int32 */
        count: number;
        /** @format int64 */
        freedBytes?: number;
        /** @format int64 */
        logicalBytes: number;
        /** @format int64 */
        physicalBytes: number;
      };
      pvcStats: {
        /** @format int64 */
        pvcBytes: number;
        /** @format int32 */
        pvcCount: number;
      };
      snapshotStorage: {
        /** @format int32 */
        count: number;
        /** @format int64 */
        freedBytes?: number;
        /** @format int64 */
        logicalBytes: number;
        /** @format int64 */
        physicalBytes: number;
      };
    };
  };
  spec?: {
    /** @format date-time */
    reportTimestamp: string;
    /** @format int32 */
    statsIntervalDays?: number;
    /** @format date-time */
    statsIntervalEndTimestamp: string;
    /** @format int32 */
    statsIntervalHours?: number;
    /** @format date-time */
    statsIntervalStartTimestamp: string;
  };
}

export interface ReportActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    /** @format date-time */
    scheduledTime?: string;
    /** @format int32 */
    statsIntervalDays?: number;
    /** @format int32 */
    statsIntervalHours?: number;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface ReposUsage {
  /** @format int64 */
  totalLogicalUsageB: number;
  /** @format int64 */
  totalPhysicalUsageB: number;
}

export interface Repository {
  AppName: string;
  /** @format date-time */
  abandonedAt?: string;
  apiKeys?: Array<string>;
  apiMeta?: {
    actionMeta?: {
      /** @format date-time */
      scheduledTime?: string;
      subject?: {
        apiVersion?: string;
        kind?: string;
        name: string;
        namespace?: string;
      };
    };
    annotations: Array<{
      key?: string;
      value?: string;
    }>;
    displayName?: string;
    labels: Array<{
      key?: string;
      value?: string;
    }>;
  };
  /** @format int64 */
  backgroundProcessTimeout?: number;
  deactivateMaintenance: boolean;
  encryptionKeyRefID: string;
  /** @format date-time */
  lastBLMScanTime?: string;
  location: {
    fileStore?: {
      claimName?: string;
      path?: string;
      /** @format int64 */
      suppGroup?: number;
    };
    imageRepo?: {
      endpoint?: string;
      skipSSLVerify?: boolean;
    };
    objectStore?: {
      endpoint?: string;
      name: string;
      objectStoreType: string;
      path?: string;
      pathType?: string;
      protectionPeriod?: string;
      region?: string;
      skipSSLVerify?: boolean;
    };
    type: string;
    vbr?: {
      repoId?: string;
      repoName?: string;
      repoType?: string;
      serverAddress?: string;
      serverId?: string;
      /** @format int32 */
      serverPort?: number;
      serverThumbprint?: string;
      serverVersion?: string;
      skipSSLVerify?: boolean;
      /** @format int32 */
      vmbApiPort?: number;
    };
  };
  /** @format date-time */
  modifiedTime: string;
  overrideLocation?: {
    name: string;
    namespace?: string;
  };
  readOnly?: boolean;
  /** @format int32 */
  repoFormatVersion: number;
  repoPath: string;
  status: {
    kopia?: {
      maintenanceInfo?: {
        /** @format date-time */
        completedTime: string;
        full: {
          enabled: boolean;
          /** @format int64 */
          interval: number;
        };
        /** @format date-time */
        nextFullMaintenanceTime: string;
        /** @format date-time */
        nextQuickMaintenanceTime: string;
        ownerHostName: string;
        ownerUserName: string;
        payload?: string;
        quick: {
          enabled: boolean;
          /** @format int64 */
          interval: number;
        };
        runs: Record<
          string,
          Array<{
            /** @format date-time */
            end: string;
            error?: string;
            /** @format date-time */
            start: string;
            success: boolean;
          }>
        >;
      };
      maintenanceRun: {
        /** @format int32 */
        cleanedLogsTotal: number;
        deletedUnrefBlobsTotal: {
          /** @format int32 */
          count: number;
          /** @format int64 */
          sizeB: number;
        };
        recentResults: Array<{
          /** @format date-time */
          completedTime: string;
          /** @format date-time */
          scheduledTime: string;
          stats: {
            /** @format int32 */
            cleanedLogs: number;
            deletedUnrefBlobs: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
            inUseContents: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
            inUseSysContents: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
            keptLogs: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
            unusedContents: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
            unusedContentsRecent: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
          };
        }>;
        /** @format int32 */
        runsTotal: number;
      };
      repoStatus?: {
        /**
         * @format int64
         * @min 0
         */
        available?: number;
        /**
         * @format int64
         * @min 0
         */
        capacity?: number;
        /** @format date-time */
        completedTime: string;
        encryption?: string;
        /** @format int32 */
        formatVersion?: number;
        hash?: string;
        /** @format int32 */
        indexFormat?: number;
        kopiaUpgradeStatus?: string;
        payload?: string;
        splitter?: string;
      };
      storageUsage: {
        blobStats?: {
          /** @format date-time */
          completedTime: string;
          sizeStat: {
            /** @format int32 */
            count: number;
            /** @format int64 */
            sizeB: number;
          };
        };
        snapshotStats?: {
          /** @format date-time */
          completedTime: string;
          sizeStat: {
            /** @format int32 */
            count: number;
            /** @format int64 */
            sizeB: number;
          };
        };
      };
    };
    processResults?: {
      /** @format int32 */
      processCount: number;
      recentResults?: Array<{
        commandResults?: Array<{
          desc: string;
          /** @format date-time */
          endTime: string;
          error?: string;
          /** @format date-time */
          startTime: string;
          succeeded: boolean;
        }>;
        /** @format date-time */
        endTime: string;
        procedure: string;
        procedureError?: string;
        /** @format date-time */
        startTime: string;
        succeeded: boolean;
      }>;
    };
  };
  type: string;
}

/** Resource matchers for use in StoredPlan */
export interface ResourceFilter {
  exclude?: ResourceMatchers;
  include?: ResourceMatchers;
}

export type ResourceMatchers = Array<{
  group?: string;
  matchExpressions?: Array<{
    key: string;
    operator: string;
    values?: Array<string>;
  }>;
  matchLabels?: Record<string, string>;
  name?: string;
  resource?: string;
  version?: string;
}>;

/** @format int64 */
export type ResourceVersion = number;

export interface RestoreActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    artifactOverrideProfile?: {
      name: string;
      namespace?: string;
    };
    dataOnly?: boolean;
    dryRun?: boolean;
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    ignoreExceptions?: boolean;
    overwriteExisting?: boolean;
    /** @format date-time */
    pointInTime?: string;
    profile?: {
      name: string;
      namespace?: string;
    };
    restoreClusterResources?: boolean;
    /** @format date-time */
    scheduledTime?: string;
    skipWaitForWorkloadReady?: boolean;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
    targetNamespace?: string;
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
    virtualMachineParameters?: {
      harvester?: {
        overrideVolumeImages?: Record<
          string,
          {
            ignoreChecks?: boolean;
            name?: string;
            namespace?: string;
          }
        >;
      };
      preserveVMMacAddresses?: boolean;
    };
    volumeClones?: boolean;
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

/**
 * Indicates whether the namespace can be restored using different
 * sources of backups.
 */
export interface RestoreCapability {
  /**
   * If true, the namespace has persistent backups that are exported
   * and can be utilized for restoration.
   * If false, there are no exported persistent backups to be restored
   * from.
   */
  export?: boolean;
  /**
   * If true, the namespace has persistent backups that are imported
   * and can be utilized for restoration.
   * If false, there are no imported persistent backups to be restored
   * from.
   */
  import?: boolean;
  /**
   * If true, the namespace has local snapshots and can be restored
   * using them.
   * If false, the namespace does not have the capability to be
   * restored from local snapshots.
   */
  snapshot?: boolean;
}

export interface RestoreClusterActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    hooks?: {
      onFailure?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      onSuccess?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
      preHook?: {
        actionName?: string;
        blueprint?: string;
        subject?: {
          name?: string;
          namespace?: string;
          type?: string;
        };
      };
    };
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

/** Data from browser for initiating a restore action */
export interface RestoreForm {
  dryRun?: boolean;
  params?: RestoreParametersP;
  restorePoint?: ReferenceP;
  restorePointContent?: ReferenceP;
}

export interface RestoreParameters {
  dataServices?: DataServiceRestoreOptionsList;
  /** The namespace into which something should be restored */
  namespace?: string;
  /** Partial restore of these kinds of objects. Empty means full restore */
  partialParts?: PartialRestorePartList;
  /** Time stamp for an event related to an object, for example when the object was created. */
  pointInTime?: TimeStamp;
}

export interface RestoreParametersP {
  actionPodSpec?: {
    name: string;
    namespace?: string;
  };
  artifactOverrideProfile?: {
    name: string;
    namespace?: string;
  };
  dataOnly?: boolean;
  filters?: {
    excludeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
  };
  hooks?: {
    onFailure?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
    onSuccess?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
    preHook?: {
      actionName?: string;
      blueprint?: string;
      subject?: {
        name?: string;
        namespace?: string;
        type?: string;
      };
    };
  };
  ignoreExceptions?: boolean;
  overwriteExisting?: boolean;
  /** @format date-time */
  pointInTime?: string;
  profile?: {
    name: string;
    namespace?: string;
  };
  restoreClusterResources?: boolean;
  skipWaitForWorkloadReady?: boolean;
  targetNamespace?: string;
  transforms?: Array<{
    comment?: string;
    json: Array<{
      from?: string;
      op: string;
      path?: string;
      regex?: string;
      value?: string;
    }>;
    name?: string;
    subject?: {
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    };
    transformSetRef?: {
      name: string;
      namespace?: string;
    };
  }>;
  virtualMachineParameters?: {
    harvester?: {
      overrideVolumeImages?: Record<
        string,
        {
          ignoreChecks?: boolean;
          name?: string;
          namespace?: string;
        }
      >;
    };
    preserveVMMacAddresses?: boolean;
  };
  volumeClones?: boolean;
}

export interface RestorePoint {
  artifacts?: ArtifactList;
  /** List of references to other objects */
  originatingPolicies?: ReferenceList;
  /** Point-in-time range (minutes) available */
  pitRange?: number;
  /** Time stamp for an event related to an object, for example when the object was created. */
  scheduledTime?: TimeStamp;
  /** succeeded iff all associated jobs were successful */
  status?: RestorePointStatus;
}

export interface RestorePointAPI {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    restorePointContentRef?: {
      name?: string;
    };
  };
  status?: {
    /** @format date-time */
    actionTime?: string;
    /** @format int64 */
    logicalSizeBytes?: number;
    /** @format int64 */
    physicalSizeBytes?: number;
    restorePointDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      originatingPolicies?: Array<{
        name: string;
        namespace?: string;
      }>;
      supportsPITR: boolean;
    };
    /** @format date-time */
    scheduledTime?: string;
    vmInfo?: {
      snapshotConsistency?: string;
      status?: string;
    };
  };
}

export interface RestorePointContentAPI {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  status?: {
    /** @format date-time */
    actionTime?: string;
    restorePointContentDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      originatingPolicies?: Array<{
        name: string;
        namespace?: string;
      }>;
      supportsPITR: boolean;
    };
    restorePointRef?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    scheduledTime?: string;
    state?: string;
    vmInfo?: {
      snapshotConsistency?: string;
      status?: string;
    };
  };
}

export type RestorePointContentObjectList = Array<RestorePointContentP>;

export type RestorePointContentObjectPerAppList = Array<{
  /** Application name */
  app: string;
  /** Type of application */
  appType?: string;
  restorePoint?: RestorePointContentP;
}>;

export interface RestorePointContentP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  status?: {
    /** @format date-time */
    actionTime?: string;
    restorePointContentDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      originatingPolicies?: Array<{
        name: string;
        namespace?: string;
      }>;
      supportsPITR: boolean;
    };
    restorePointRef?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    scheduledTime?: string;
    state?: string;
    vmInfo?: {
      snapshotConsistency?: string;
      status?: string;
    };
  };
}

/** List of Restore Point Contents and target namespace */
export interface RestorePointCreateForm {
  /** List of references to other objects */
  restorePointContentRefList?: ReferencePList;
  targetNamespace?: string;
}

export type RestorePointObjectList = Array<RestorePointP>;

export type RestorePointObjectPerAppList = Array<{
  /** Application name */
  app: string;
  /** Type of application */
  appType?: string;
  restorePoint?: RestorePointP;
}>;

export interface RestorePointP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    restorePointContentRef?: {
      name?: string;
    };
  };
  status?: {
    /** @format date-time */
    actionTime?: string;
    /** @format int64 */
    logicalSizeBytes?: number;
    /** @format int64 */
    physicalSizeBytes?: number;
    restorePointDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      exceptions?: Array<{
        cause?: string;
        fields?: Array<{
          name?: string;
          value?: string;
        }>;
        message?: string;
        retriable?: boolean;
      }>;
      originatingPolicies?: Array<{
        name: string;
        namespace?: string;
      }>;
      supportsPITR: boolean;
    };
    /** @format date-time */
    scheduledTime?: string;
    vmInfo?: {
      snapshotConsistency?: string;
      status?: string;
    };
  };
}

export interface RestorePointsList {
  restorePoints?: Array<{
    /** @format date-time */
    createdAt?: string;
    isClusterRestorePoint: boolean;
    labels?: Record<string, string>;
    name?: string;
    rpcName?: string;
  }>;
  /** @format int64 */
  totalCount?: number;
}

export interface RetireActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    /** @format int32 */
    retireIndex?: number;
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface Role {
  /** Is role editable */
  editable?: boolean;
  /** The role's K8s representation */
  roleCR?: RoleCR;
  /** The role's JSON representation */
  rulesMap?: RulesMap;
}

export interface RoleBinding {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  roleRef: {
    apiGroup: string;
    kind: string;
    name: string;
  };
  subjects?: Array<{
    apiGroup?: string;
    kind: string;
    name: string;
    namespace?: string;
  }>;
}

/** RoleBindings data from browser for creating multiple roleBindings */
export interface RoleBindingForNamespacesForm {
  namespaces?: RBACNamespaceList;
  roleBinding?: RoleBinding;
}

/** RoleBinding data from browser for creating/editing roleBinding */
export interface RoleBindingForm {
  roleBinding?: RoleBinding;
}

export interface RoleBindingList {
  apiVersion?: string;
  items: Array<{
    apiVersion?: string;
    kind?: string;
    metadata?: {
      annotations?: Record<string, string>;
      /** @format date-time */
      creationTimestamp?: string;
      /** @format int64 */
      deletionGracePeriodSeconds?: number;
      /** @format date-time */
      deletionTimestamp?: string;
      finalizers?: Array<string>;
      generateName?: string;
      /** @format int64 */
      generation?: number;
      labels?: Record<string, string>;
      managedFields?: Array<{
        apiVersion?: string;
        fieldsType?: string;
        fieldsV1?: {};
        manager?: string;
        operation?: string;
        subresource?: string;
        /** @format date-time */
        time?: string;
      }>;
      name?: string;
      namespace?: string;
      ownerReferences?: Array<{
        apiVersion: string;
        blockOwnerDeletion?: boolean;
        controller?: boolean;
        kind: string;
        name: string;
        uid: string;
      }>;
      resourceVersion?: string;
      selfLink?: string;
      uid?: string;
    };
    roleRef: {
      apiGroup: string;
      kind: string;
      name: string;
    };
    subjects?: Array<{
      apiGroup?: string;
      kind: string;
      name: string;
      namespace?: string;
    }>;
  }>;
  kind?: string;
  metadata?: {
    continue?: string;
    /** @format int64 */
    remainingItemCount?: number;
    resourceVersion?: string;
    selfLink?: string;
  };
}

export interface RoleCR {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  rules: Array<{
    apiGroups?: Array<string>;
    nonResourceURLs?: Array<string>;
    resourceNames?: Array<string>;
    resources?: Array<string>;
    verbs: Array<string>;
  }>;
}

export interface RoleCRList {
  apiVersion?: string;
  items: Array<{
    apiVersion?: string;
    kind?: string;
    metadata?: {
      annotations?: Record<string, string>;
      /** @format date-time */
      creationTimestamp?: string;
      /** @format int64 */
      deletionGracePeriodSeconds?: number;
      /** @format date-time */
      deletionTimestamp?: string;
      finalizers?: Array<string>;
      generateName?: string;
      /** @format int64 */
      generation?: number;
      labels?: Record<string, string>;
      managedFields?: Array<{
        apiVersion?: string;
        fieldsType?: string;
        fieldsV1?: {};
        manager?: string;
        operation?: string;
        subresource?: string;
        /** @format date-time */
        time?: string;
      }>;
      name?: string;
      namespace?: string;
      ownerReferences?: Array<{
        apiVersion: string;
        blockOwnerDeletion?: boolean;
        controller?: boolean;
        kind: string;
        name: string;
        uid: string;
      }>;
      resourceVersion?: string;
      selfLink?: string;
      uid?: string;
    };
    rules: Array<{
      apiGroups?: Array<string>;
      nonResourceURLs?: Array<string>;
      resourceNames?: Array<string>;
      resources?: Array<string>;
      verbs: Array<string>;
    }>;
  }>;
  kind?: string;
  metadata?: {
    continue?: string;
    /** @format int64 */
    remainingItemCount?: number;
    resourceVersion?: string;
    selfLink?: string;
  };
}

/** Roles data from browser for creating multiple roles */
export interface RoleForNamespacesForm {
  namespaces?: RBACNamespaceList;
  role?: Role;
}

/** Role data from browser for creating/editing role */
export interface RoleForm {
  role?: Role;
}

export type RoleList = Array<Role>;

export interface RulesMap {
  actions: {
    backup: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    backupCluster: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    batchRestore: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    cancel: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    export: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    import: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    report: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    restore: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    restoreCluster: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    retire: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    run: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    validate: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
  };
  apps: {
    applications: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    clusterRestorePoints: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    restorePointContents: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    restorePoints: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
  };
  config: {
    blueprintbindings: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    policies: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    policypresets: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    profiles: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    storagesecuritycontextbindings: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    storagesecuritycontexts: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
    transformsets: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
  };
  reporting: {
    reports: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
  };
  vault: {
    passkeys: {
      delete: boolean;
      display: string;
      read: boolean;
      write: boolean;
    };
  };
}

export interface RunAction {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    dryRun?: string;
    /** @format date-time */
    expiresAt?: string;
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      applications?: Array<string>;
      summary?: {
        actions: {
          /** @format int32 */
          cancelledCount: number;
          /** @format int32 */
          completedCount: number;
          /** @format int32 */
          failedCount: number;
          /** @format int32 */
          pendingCount: number;
          /** @format int32 */
          runningCount: number;
          /** @format int32 */
          skippedCount: number;
          /** @format int32 */
          totalCount: number;
        };
        /** @format int32 */
        applicationCount: number;
        /** @format int32 */
        importedRestorePointCount: number;
      };
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    policySpec?: {
      actions?: Array<{
        action?: string;
        backupClusterParameters?: {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
        };
        backupParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          /** @format date-time */
          expiresAt?: string;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          imageRepoProfile?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
        };
        batchRestoreParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          artifactOverrideProfile?: {
            name: string;
            namespace?: string;
          };
          dataOnly?: boolean;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          overwriteExisting?: boolean;
          /** @format date-time */
          pointInTime?: string;
          profile?: {
            name: string;
            namespace?: string;
          };
          restoreClusterResources?: boolean;
          restorePointsDiscoveryRange?: {
            /** @format date-time */
            end?: string;
            /** @format date-time */
            start?: string;
          };
          skipWaitForWorkloadReady?: boolean;
          subjects: Array<{
            namespace: string;
            restorePointContentName?: string;
            restorePointName?: string;
          }>;
          targetNamespace?: string;
          targetNamespacePrefix?: string;
          targetNamespaceSuffix?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
          virtualMachineParameters?: {
            harvester?: {
              overrideVolumeImages?: Record<
                string,
                {
                  ignoreChecks?: boolean;
                  name?: string;
                  namespace?: string;
                }
              >;
            };
            preserveVMMacAddresses?: boolean;
          };
          volumeClones?: boolean;
        };
        exportParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          blockModeProfile?: {
            name: string;
            namespace?: string;
          };
          /** @format date-time */
          expiresAt?: string;
          exportData?: {
            enabled: boolean;
            exporterStorageClassName?: string;
            overrides?: Array<{
              enabled: boolean;
              exporterStorageClassName?: string;
              storageClassName: string;
            }>;
          };
          frequency?: string;
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          migrationToken?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          receiveString?: string;
          volumeSnapshots?: {
            awsEbs?: {
              destinationAccount?: string;
              regions?: Array<string>;
            };
            azure?: {
              regions?: Array<string>;
              resourceGroup?: string;
            };
          };
        };
        importParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          migrationToken?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          receiveString?: string;
        };
        reportParameters?: {
          /** @format int32 */
          statsIntervalDays?: number;
          /** @format int32 */
          statsIntervalHours?: number;
        };
        restoreClusterParameters?: {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        };
        restoreParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          artifactOverrideProfile?: {
            name: string;
            namespace?: string;
          };
          dataOnly?: boolean;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          overwriteExisting?: boolean;
          /** @format date-time */
          pointInTime?: string;
          profile?: {
            name: string;
            namespace?: string;
          };
          restoreClusterResources?: boolean;
          skipWaitForWorkloadReady?: boolean;
          targetNamespace?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
          virtualMachineParameters?: {
            harvester?: {
              overrideVolumeImages?: Record<
                string,
                {
                  ignoreChecks?: boolean;
                  name?: string;
                  namespace?: string;
                }
              >;
            };
            preserveVMMacAddresses?: boolean;
          };
          volumeClones?: boolean;
        };
        retireParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          /** @format int32 */
          retireIndex?: number;
        };
        stageParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          transformations?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        };
        upgradeParameters?: {
          profile?: {
            name: string;
            namespace?: string;
          };
        };
        validateParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          volumeDataCheckOptions?: {
            failFast?: boolean;
            verifyFilesPercent?: string;
          };
        };
      }>;
      paused?: boolean;
      presetRef?: {
        name: string;
        namespace?: string;
      };
      selector?: {
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
      };
    };
    /** @format int64 */
    progress?: number;
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface RunActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    dryRun?: string;
    /** @format date-time */
    expiresAt?: string;
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      applications?: Array<string>;
      summary?: {
        actions: {
          /** @format int32 */
          cancelledCount: number;
          /** @format int32 */
          completedCount: number;
          /** @format int32 */
          failedCount: number;
          /** @format int32 */
          pendingCount: number;
          /** @format int32 */
          runningCount: number;
          /** @format int32 */
          skippedCount: number;
          /** @format int32 */
          totalCount: number;
        };
        /** @format int32 */
        applicationCount: number;
        /** @format int32 */
        importedRestorePointCount: number;
      };
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    policySpec?: {
      actions?: Array<{
        action?: string;
        backupClusterParameters?: {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
        };
        backupParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          /** @format date-time */
          expiresAt?: string;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          imageRepoProfile?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
        };
        batchRestoreParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          artifactOverrideProfile?: {
            name: string;
            namespace?: string;
          };
          dataOnly?: boolean;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          overwriteExisting?: boolean;
          /** @format date-time */
          pointInTime?: string;
          profile?: {
            name: string;
            namespace?: string;
          };
          restoreClusterResources?: boolean;
          restorePointsDiscoveryRange?: {
            /** @format date-time */
            end?: string;
            /** @format date-time */
            start?: string;
          };
          skipWaitForWorkloadReady?: boolean;
          subjects: Array<{
            namespace: string;
            restorePointContentName?: string;
            restorePointName?: string;
          }>;
          targetNamespace?: string;
          targetNamespacePrefix?: string;
          targetNamespaceSuffix?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
          virtualMachineParameters?: {
            harvester?: {
              overrideVolumeImages?: Record<
                string,
                {
                  ignoreChecks?: boolean;
                  name?: string;
                  namespace?: string;
                }
              >;
            };
            preserveVMMacAddresses?: boolean;
          };
          volumeClones?: boolean;
        };
        exportParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          blockModeProfile?: {
            name: string;
            namespace?: string;
          };
          /** @format date-time */
          expiresAt?: string;
          exportData?: {
            enabled: boolean;
            exporterStorageClassName?: string;
            overrides?: Array<{
              enabled: boolean;
              exporterStorageClassName?: string;
              storageClassName: string;
            }>;
          };
          frequency?: string;
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          migrationToken?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          receiveString?: string;
          volumeSnapshots?: {
            awsEbs?: {
              destinationAccount?: string;
              regions?: Array<string>;
            };
            azure?: {
              regions?: Array<string>;
              resourceGroup?: string;
            };
          };
        };
        importParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          migrationToken?: {
            name: string;
            namespace?: string;
          };
          profile?: {
            name: string;
            namespace?: string;
          };
          receiveString?: string;
        };
        reportParameters?: {
          /** @format int32 */
          statsIntervalDays?: number;
          /** @format int32 */
          statsIntervalHours?: number;
        };
        restoreClusterParameters?: {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        };
        restoreParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          artifactOverrideProfile?: {
            name: string;
            namespace?: string;
          };
          dataOnly?: boolean;
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          hooks?: {
            onFailure?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            onSuccess?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
            preHook?: {
              actionName?: string;
              blueprint?: string;
              subject?: {
                name?: string;
                namespace?: string;
                type?: string;
              };
            };
          };
          ignoreExceptions?: boolean;
          overwriteExisting?: boolean;
          /** @format date-time */
          pointInTime?: string;
          profile?: {
            name: string;
            namespace?: string;
          };
          restoreClusterResources?: boolean;
          skipWaitForWorkloadReady?: boolean;
          targetNamespace?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
          virtualMachineParameters?: {
            harvester?: {
              overrideVolumeImages?: Record<
                string,
                {
                  ignoreChecks?: boolean;
                  name?: string;
                  namespace?: string;
                }
              >;
            };
            preserveVMMacAddresses?: boolean;
          };
          volumeClones?: boolean;
        };
        retireParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          /** @format int32 */
          retireIndex?: number;
        };
        stageParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          transformations?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        };
        upgradeParameters?: {
          profile?: {
            name: string;
            namespace?: string;
          };
        };
        validateParameters?: {
          actionPodSpec?: {
            name: string;
            namespace?: string;
          };
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          volumeDataCheckOptions?: {
            failFast?: boolean;
            verifyFilesPercent?: string;
          };
        };
      }>;
      paused?: boolean;
      presetRef?: {
        name: string;
        namespace?: string;
      };
      selector?: {
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
      };
    };
    /** @format int64 */
    progress?: number;
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface ScheduledRestorePoint {
  crontab?: string;
  /** Time stamp for an event related to an object, for example when the object was created. */
  expectedTime?: TimeStamp;
  restorePoint?: RestorePoint;
}

export interface ScheduledRestorePointApps {
  appName?: string;
  scheduledRestorePoints?: Array<ScheduledRestorePoint>;
}

export interface Secret {
  api?: {
    key?: string;
  };
  aws?: {
    accessKeyId?: string;
    role?: string;
    secretAccessKey?: string;
  };
  azure?: {
    azureClientID?: string;
    azureClientSecret?: string;
    azureFederatedIdentity?: boolean;
    azureTenantID?: string;
    storageAccount?: string;
    storageEnv?: string;
    storageKey?: string;
  };
  gcp?: {
    projectId?: string;
    serviceKey?: string;
  };
  imageRepo?: {
    file?: string;
    password?: string;
    token?: string;
    user?: string;
  };
  openStack?: {
    domain?: string;
    password?: string;
    project?: string;
    region?: string;
    user?: string;
  };
  portworx?: {
    issuer?: string;
    secret?: string;
  };
  type?: string;
  vbr?: {
    password?: string;
    user?: string;
  };
  veeamVault?: {
    certificate?: string;
    clientID?: string;
    key?: string;
    storageAccount?: string;
    tenantID?: string;
  };
  veeamVaultAWS?: {
    bucketName?: string;
    clientID?: string;
    roleARN?: string;
    tenantID?: string;
    vaultID?: string;
  };
  veeamVaultAzure?: {
    certificate?: string;
    clientID?: string;
    key?: string;
    storageAccount?: string;
    tenantID?: string;
  };
  vsphere?: {
    password?: string;
    user?: string;
  };
}

/** Key-value pairs */
export interface Selector {
  /** Key or index name */
  key?: string;
  /**
   * Namespace name
   * @example "default"
   */
  namespace?: string;
  /** The type of selector */
  type?: SelectorType;
  value?: string;
}

export type SelectorList = Array<Selector>;

/** Information about a K10 service */
export interface ServiceInfo {
  /**
   * Kubernetes namespace the service is running in
   * @example "kasten-io"
   */
  namespace?: string;
  /**
   * Version
   * @example "5013.master.1aad3b42644c91e698e8c96c0f5451df598da784"
   */
  version?: string;
}

export interface SetupPrimaryConfig {
  clusterName: string;
  ingressURL: string;
}

/** A snapshot created by k10 */
export interface Snapshot {
  /** Time stamp when snapshot creation was initiated */
  creationTime?: TimeStamp;
  /** Snapshot is encrypted */
  encrypted?: boolean;
  /**
   * A unique identifier generated by the storage provider
   * @example "snap-0d598ab8144f70843"
   */
  id?: string;
  /** Kubernetes volume snapshot */
  k8sSnapshot?: K8SSnapshot;
  /** Kubernetes volume */
  k8sVolume?: K8SVolume;
  /**
   * Snapshot availability region
   * @example "us-west-2"
   */
  region?: string;
  /**
   * The size of the snapshot, in sizeUnit
   * @format int64
   */
  size?: number;
  /** The unit of size of the snapshot. The default size is GiB */
  sizeUnit?: string;
  tags?: Array<KeyValue>;
  /** Storage type of the source volume for this snapshot */
  type?: StorageType;
  /** A storage provider volume tracked by k10 */
  volume?: Volume;
}

export type SnapshotStorageUsage = Record<string, number>;

/** List of apps and their scheduled restore points */
export type SnapshotsSchedules = Array<ScheduledRestorePointApps>;

/** Summary of K10 managed snapshots */
export interface SnapshotsSummary {
  count: number;
  maxSize: number;
  medianSize: number;
  minSize: number;
  retiredCount: number;
}

export interface SourceClusterInfo {
  passphraseInfo?: {
    awsInfo?: {
      jsonKey: string;
      region: string;
      secretId: string;
      versionId: string;
      versionStage: string;
    };
    azureInfo?: {
      jsonKey: string;
      keyVaultURL: string;
      secretName: string;
      version?: string;
    };
    passphrase?: string;
    source?: string;
    vaultInfo?: {
      kvVersion: string;
      mountPath: string;
      secretName: string;
      secretPath: string;
    };
  };
  pointInTime?: string;
  profileName?: string;
  sourceClusterID?: string;
}

/** The configuration of a K8s object */
export interface Spec {
  /** Annotations in this spec */
  annotations?: Array<KeyValue>;
  /** JSON representation of the K8s object */
  config?: string;
  /** Encrypted JSON representation of the K8s object */
  encryptedConfig?: EncryptedDataWithKeyDetails;
  groupVersionResource?: GroupVersionResource;
  /** K8s Labels (metadata.labels) */
  labels?: Array<KeyValue>;
  name?: string;
  namespace?: string;
  /** k8s object type */
  type?: K8SObjectType;
}

export interface Specifications {
  json: Array<{
    from?: string;
    op: string;
    path?: string;
    regex?: string;
    value?: string;
  }>;
}

export interface StageActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
    transformations?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
      transformSetRef?: {
        name: string;
        namespace?: string;
      };
    }>;
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

/** Data from browser for initiating a stage action */
export interface StageForm {
  params?: StageParametersP;
  restorePoint?: ReferenceP;
  restorePointContent?: ReferenceP;
}

export interface StageParametersP {
  actionPodSpec?: {
    name: string;
    namespace?: string;
  };
  filters?: {
    excludeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
  };
  transformations?: Array<{
    comment?: string;
    json: Array<{
      from?: string;
      op: string;
      path?: string;
      regex?: string;
      value?: string;
    }>;
    name?: string;
    subject?: {
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    };
    transformSetRef?: {
      name: string;
      namespace?: string;
    };
  }>;
}

export type Stats = Record<string, number>;

export interface StorageClass {
  allowVolumeExpansion: boolean;
  annotations?: Record<string, string>;
  isDefault: boolean;
  name?: string;
  provisioner?: string;
  reclaimPolicy?: string;
  type?: string;
  volumeBindingMode?: string;
}

export type StorageClassList = Array<StorageClass>;

export interface StorageRepositoryAPI {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec: {
    backgroundProcessTimeout: string;
    disableMaintenance: boolean;
    overrideLocation?: {
      name: string;
      namespace?: string;
    };
  };
  status?: {
    appName?: string;
    backendType?: string;
    contentType?: string;
    details?: {
      kopiaMeta?: {
        /** @format int32 */
        formatVersion?: number;
        maintenanceInfo?: {
          /** @format date-time */
          completedTime: string;
          full: {
            enabled: boolean;
            /** @format int64 */
            interval: number;
          };
          /** @format date-time */
          nextFullMaintenanceTime: string;
          /** @format date-time */
          nextQuickMaintenanceTime: string;
          quick: {
            enabled: boolean;
            /** @format int64 */
            interval: number;
          };
          runs: Record<
            string,
            Array<{
              /** @format date-time */
              end: string;
              error?: string;
              /** @format date-time */
              start: string;
              success: boolean;
            }>
          >;
        };
        maintenanceRun?: {
          /** @format int32 */
          cleanedLogsTotal: number;
          deletedUnrefBlobsTotal: {
            /** @format int32 */
            count: number;
            /** @format int64 */
            sizeB: number;
          };
          recentResults: Array<{
            /** @format date-time */
            completedTime: string;
            /** @format date-time */
            scheduledTime: string;
            stats: {
              /** @format int32 */
              cleanedLogs: number;
              deletedUnrefBlobs: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              inUseContents: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              inUseSysContents: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              keptLogs: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              unusedContents: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              unusedContentsRecent: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
            };
          }>;
          /** @format int32 */
          runsTotal: number;
        };
        repoStatus?: {
          /**
           * @format int64
           * @min 0
           */
          available?: number;
          /**
           * @format int64
           * @min 0
           */
          capacity?: number;
          /** @format date-time */
          completedTime: string;
          encryption?: string;
          /** @format int32 */
          formatVersion?: number;
          hash?: string;
          /** @format int32 */
          indexFormat?: number;
          splitter?: string;
        };
        storageUsage?: {
          blobStats?: {
            /** @format date-time */
            completedTime: string;
            sizeStat: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
          };
          snapshotStats?: {
            /** @format date-time */
            completedTime: string;
            sizeStat: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
          };
        };
      };
      /** @format date-time */
      modifiedTime?: string;
      /** @format date-time */
      nextProessTime?: string;
    };
    location?: {
      fileStore?: {
        claimName?: string;
        path?: string;
        /** @format int64 */
        suppGroup?: number;
      };
      imageRepo?: {
        endpoint?: string;
        skipSSLVerify?: boolean;
      };
      objectStore?: {
        endpoint?: string;
        name: string;
        objectStoreType: string;
        path?: string;
        pathType?: string;
        protectionPeriod?: string;
        region?: string;
        skipSSLVerify?: boolean;
      };
      type: string;
      vbr?: {
        repoId?: string;
        repoName?: string;
        repoType?: string;
        serverAddress?: string;
        serverId?: string;
        /** @format int32 */
        serverPort?: number;
        serverThumbprint?: string;
        serverVersion?: string;
        skipSSLVerify?: boolean;
        /** @format int32 */
        vmbApiPort?: number;
      };
    };
    processResults?: {
      /** @format int32 */
      processCount: number;
      recentResults?: Array<{
        commandResults?: Array<{
          desc: string;
          /** @format date-time */
          endTime: string;
          error?: string;
          /** @format date-time */
          startTime: string;
          succeeded: boolean;
        }>;
        /** @format date-time */
        endTime: string;
        procedure: string;
        procedureError?: string;
        /** @format date-time */
        startTime: string;
        succeeded: boolean;
      }>;
    };
    readOnly?: boolean;
  };
}

export type StorageRepositoryList = Array<StorageRepositoryP>;

export interface StorageRepositoryP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec: {
    backgroundProcessTimeout: string;
    disableMaintenance: boolean;
    overrideLocation?: {
      name: string;
      namespace?: string;
    };
  };
  status?: {
    appName?: string;
    backendType?: string;
    contentType?: string;
    details?: {
      kopiaMeta?: {
        /** @format int32 */
        formatVersion?: number;
        maintenanceInfo?: {
          /** @format date-time */
          completedTime: string;
          full: {
            enabled: boolean;
            /** @format int64 */
            interval: number;
          };
          /** @format date-time */
          nextFullMaintenanceTime: string;
          /** @format date-time */
          nextQuickMaintenanceTime: string;
          quick: {
            enabled: boolean;
            /** @format int64 */
            interval: number;
          };
          runs: Record<
            string,
            Array<{
              /** @format date-time */
              end: string;
              error?: string;
              /** @format date-time */
              start: string;
              success: boolean;
            }>
          >;
        };
        maintenanceRun?: {
          /** @format int32 */
          cleanedLogsTotal: number;
          deletedUnrefBlobsTotal: {
            /** @format int32 */
            count: number;
            /** @format int64 */
            sizeB: number;
          };
          recentResults: Array<{
            /** @format date-time */
            completedTime: string;
            /** @format date-time */
            scheduledTime: string;
            stats: {
              /** @format int32 */
              cleanedLogs: number;
              deletedUnrefBlobs: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              inUseContents: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              inUseSysContents: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              keptLogs: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              unusedContents: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
              unusedContentsRecent: {
                /** @format int32 */
                count: number;
                /** @format int64 */
                sizeB: number;
              };
            };
          }>;
          /** @format int32 */
          runsTotal: number;
        };
        repoStatus?: {
          /**
           * @format int64
           * @min 0
           */
          available?: number;
          /**
           * @format int64
           * @min 0
           */
          capacity?: number;
          /** @format date-time */
          completedTime: string;
          encryption?: string;
          /** @format int32 */
          formatVersion?: number;
          hash?: string;
          /** @format int32 */
          indexFormat?: number;
          splitter?: string;
        };
        storageUsage?: {
          blobStats?: {
            /** @format date-time */
            completedTime: string;
            sizeStat: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
          };
          snapshotStats?: {
            /** @format date-time */
            completedTime: string;
            sizeStat: {
              /** @format int32 */
              count: number;
              /** @format int64 */
              sizeB: number;
            };
          };
        };
      };
      /** @format date-time */
      modifiedTime?: string;
      /** @format date-time */
      nextProessTime?: string;
    };
    location?: {
      fileStore?: {
        claimName?: string;
        path?: string;
        /** @format int64 */
        suppGroup?: number;
      };
      imageRepo?: {
        endpoint?: string;
        skipSSLVerify?: boolean;
      };
      objectStore?: {
        endpoint?: string;
        name: string;
        objectStoreType: string;
        path?: string;
        pathType?: string;
        protectionPeriod?: string;
        region?: string;
        skipSSLVerify?: boolean;
      };
      type: string;
      vbr?: {
        repoId?: string;
        repoName?: string;
        repoType?: string;
        serverAddress?: string;
        serverId?: string;
        /** @format int32 */
        serverPort?: number;
        serverThumbprint?: string;
        serverVersion?: string;
        skipSSLVerify?: boolean;
        /** @format int32 */
        vmbApiPort?: number;
      };
    };
    processResults?: {
      /** @format int32 */
      processCount: number;
      recentResults?: Array<{
        commandResults?: Array<{
          desc: string;
          /** @format date-time */
          endTime: string;
          error?: string;
          /** @format date-time */
          startTime: string;
          succeeded: boolean;
        }>;
        /** @format date-time */
        endTime: string;
        procedure: string;
        procedureError?: string;
        /** @format date-time */
        startTime: string;
        succeeded: boolean;
      }>;
    };
    readOnly?: boolean;
  };
}

/** K10 storage summary */
export interface StorageSummary {
  objectStorage?: StorageUsage;
  /** PVC stats */
  pvcStats?: PVCStats;
  snapshotStorage?: StorageUsage;
}

export interface StorageUsage {
  /** @format int64 */
  count: number;
  /** @format int64 */
  freed: number;
  /** @format int64 */
  logical: number;
  /** @format int64 */
  numBlocks?: number;
  /** @format int64 */
  numFiles?: number;
  /** @format int64 */
  physical: number;
}

/** A plan for a phase */
export interface StoredPlan {
  groups?: PhasePlanReferenceMap;
  /** The name of the phase for which the plan is for */
  name?: JobPhaseName;
  /** Resource matchers for use in StoredPlan */
  resourceFilter?: ResourceFilter;
}

export interface SystemInfo {
  authType?: string;
  aws?: {
    role?: string;
  };
  capabilities: Array<string>;
  clusterId?: string;
  clusterName?: string;
  features: Array<string>;
  grafanaURL?: string;
  infraType?: {
    isOpenShift: boolean;
    provider?: string;
  };
  k8sVersion: string;
  namespace?: string;
  region?: string;
  version?: string;
}

/**
 * Time stamp for an event related to an object, for example when the object was created.
 * @format date-time
 * @example "2016-08-29T09:12:33.001Z"
 */
export type TimeStamp = string;

/** Time table contains the TT entries */
export type TimeTable = Array<TimeTableEntry>;

/** Entry / row in a time table containing a retention count and a crontab specification for when the action should occur */
export interface TimeTableEntry {
  /**
   * Number of artifacts to retain for this Entry
   * @example 24
   */
  count?: number;
  /**
   * crontab entry (line) specifying when the action should occur.
   * See `man crontab` and https://en.wikipedia.org/wiki/Cron#CRON_expression
   * @example "@daily"
   */
  crontab?: string;
}

/** Params for specifying a transform operation */
export interface TransformParam {
  /** Transform operations to apply */
  operation?: Specifications;
  /** JSON object to transform */
  spec?: JSONObject;
}

export interface TransformSet {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec: {
    comment?: string;
    transforms?: Array<{
      comment?: string;
      json: Array<{
        from?: string;
        op: string;
        path?: string;
        regex?: string;
        value?: string;
      }>;
      name?: string;
      subject?: {
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      };
    }>;
  };
  status?: {
    error?: Array<string>;
    /** @format int64 */
    observedGeneration?: number;
    validation?: string;
  };
}

/** List of transformSets */
export type TransformSetList = Array<TransformSet>;

export interface TransformSetSpec {
  comment?: string;
  transforms?: Array<{
    comment?: string;
    json: Array<{
      from?: string;
      op: string;
      path?: string;
      regex?: string;
      value?: string;
    }>;
    name?: string;
    subject?: {
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    };
  }>;
}

export interface TypeMeta {
  apiVersion?: string;
  kind?: string;
}

export interface UpgradeActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    profile?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
    };
    actionPlan?: {
      phases?: Record<
        string,
        {
          filters?: {
            excludeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            excludeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeClusterResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeExtraResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
            includeResources?: Array<{
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            }>;
          };
          groups?: Record<
            string,
            {
              artifacts?: Array<{
                meta?: {
                  dataservice?: {
                    kanisterArtifacts?: Array<{
                      meta?: {
                        k8sVolume?: {
                          name?: string;
                          pvcName?: string;
                          storageClassName?: string;
                        };
                        location?: {
                          fileStore?: {
                            claimName?: string;
                            path?: string;
                            /** @format int64 */
                            suppGroup?: number;
                          };
                          objectStore?: {
                            endpoint?: string;
                            name?: string;
                            objectStoreType?: string;
                            path?: string;
                            pathType?: string;
                            region?: string;
                            skipSSLVerify?: boolean;
                          };
                          type?: string;
                          vbr?: {
                            repoId?: string;
                            repoName?: string;
                            serverAddress?: string;
                          };
                        };
                        profileRef?: {
                          apiVersion?: string;
                          kind?: string;
                          name: string;
                          namespace?: string;
                        };
                        storageUsage?: {
                          /** @format int64 */
                          count: number;
                          /** @format int64 */
                          freed: number;
                          /** @format int64 */
                          logical: number;
                          /** @format int64 */
                          physical: number;
                        };
                        type?: string;
                        uploadDataFormat?: string;
                        /** @format date-time */
                        uploadEndTime?: string;
                        version?: string;
                      };
                      name?: string;
                      values?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                    }>;
                    meta?: {
                      host?: string;
                      manager?: string;
                      type?: string;
                    };
                    spec?: {
                      config?: string;
                      group?: string;
                      name?: string;
                      namespace?: string;
                      resource?: string;
                      type?: string;
                      version?: string;
                    };
                  };
                  kanister?: {
                    meta?: {
                      k8sVolume?: {
                        name?: string;
                        pvcName?: string;
                        storageClassName?: string;
                      };
                      location?: {
                        fileStore?: {
                          claimName?: string;
                          path?: string;
                          /** @format int64 */
                          suppGroup?: number;
                        };
                        objectStore?: {
                          endpoint?: string;
                          name?: string;
                          objectStoreType?: string;
                          path?: string;
                          pathType?: string;
                          region?: string;
                          skipSSLVerify?: boolean;
                        };
                        type?: string;
                        vbr?: {
                          repoId?: string;
                          repoName?: string;
                          serverAddress?: string;
                        };
                      };
                      profileRef?: {
                        apiVersion?: string;
                        kind?: string;
                        name: string;
                        namespace?: string;
                      };
                      storageUsage?: {
                        /** @format int64 */
                        count: number;
                        /** @format int64 */
                        freed: number;
                        /** @format int64 */
                        logical: number;
                        /** @format int64 */
                        physical: number;
                      };
                      type?: string;
                      uploadDataFormat?: string;
                      /** @format date-time */
                      uploadEndTime?: string;
                      version?: string;
                    };
                    name?: string;
                    values?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                  };
                  snapshot?: {
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    k8sSnapshot?: {
                      driver?: string;
                      handle?: string;
                      volumeSnapshotClassName?: string;
                    };
                    k8sVolume?: {
                      name?: string;
                      pvcName?: string;
                      storageClassName?: string;
                    };
                    region?: string;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    volume?: {
                      attributes: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      az?: string;
                      /** @format date-time */
                      creationTime?: string;
                      encrypted?: boolean;
                      id?: string;
                      /** @format int64 */
                      iops?: number;
                      /** @format int64 */
                      size?: number;
                      sizeUnit?: string;
                      tags?: Array<{
                        key?: string;
                        value?: string;
                      }>;
                      type?: string;
                      users?: Array<string>;
                      volumeType?: string;
                    };
                  };
                  spec?: {
                    config?: string;
                    group?: string;
                    name?: string;
                    namespace?: string;
                    resource?: string;
                    type?: string;
                    version?: string;
                  };
                  vmSnapshot?: {
                    cbtEligible?: boolean;
                    cbtPvcNames?: Array<string>;
                    snapshotConsistency?: string;
                    vmStatus?: string;
                  };
                  volume?: {
                    attributes: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    az?: string;
                    /** @format date-time */
                    creationTime?: string;
                    encrypted?: boolean;
                    id?: string;
                    /** @format int64 */
                    iops?: number;
                    /** @format int64 */
                    size?: number;
                    sizeUnit?: string;
                    tags?: Array<{
                      key?: string;
                      value?: string;
                    }>;
                    type?: string;
                    users?: Array<string>;
                    volumeType?: string;
                  };
                };
                source?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
              }>;
              objects?: Array<string>;
              reference?: Array<{
                name: string;
                namespace?: string;
              }>;
            }
          >;
          name?: string;
          transforms?: Array<{
            comment?: string;
            json: Array<{
              from?: string;
              op: string;
              path?: string;
              regex?: string;
              value?: string;
            }>;
            name?: string;
            subject?: {
              group?: string;
              matchExpressions?: Array<{
                key: string;
                operator: string;
                values?: Array<string>;
              }>;
              matchLabels?: Record<string, string>;
              name?: string;
              resource?: string;
              version?: string;
            };
            transformSetRef?: {
              name: string;
              namespace?: string;
            };
          }>;
        }
      >;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    restorePoint?: {
      name: string;
      namespace?: string;
    };
    result?: {
      name: string;
      namespace?: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

export interface UpgradeInfo {
  /** @format int32 */
  catalogPercentFreeSpace?: number;
  currentVersion?: string;
  isHelmInstall: boolean;
  latestVersion?: string;
  upgradeSteps?: Array<string>;
}

export interface UserEULAInfo {
  /** The user's company */
  company?: string;
  /** The user's email */
  email?: string;
}

export interface UserInfo {
  access: Record<
    string,
    Record<
      string,
      {
        allowed: boolean;
        reason?: string;
      }
    >
  >;
  isPrimaryAdmin: boolean;
  primary: boolean;
  user: {
    extra?: Record<string, Array<string>>;
    groups?: Array<string>;
    uid?: string;
    username?: string;
  };
}

export interface UserPermissionFlag {
  allowed: boolean;
}

export interface VMDetails {
  components?: {
    config?: Array<{
      annotations?: Record<string, string>;
      apiVersion?: string;
      boundBlueprints?: Array<{
        bindingRef: {
          name: string;
          namespace?: string;
        };
        name: string;
        namespace: string;
      }>;
      group?: string;
      kind?: string;
      name?: string;
      namespace?: string;
      resource?: string;
    }>;
    network?: Array<{
      annotations?: Record<string, string>;
      apiVersion?: string;
      boundBlueprints?: Array<{
        bindingRef: {
          name: string;
          namespace?: string;
        };
        name: string;
        namespace: string;
      }>;
      group?: string;
      kind?: string;
      name?: string;
      namespace?: string;
      resource?: string;
    }>;
    others?: Array<{
      annotations?: Record<string, string>;
      apiVersion?: string;
      boundBlueprints?: Array<{
        bindingRef: {
          name: string;
          namespace?: string;
        };
        name: string;
        namespace: string;
      }>;
      group?: string;
      kind?: string;
      name?: string;
      namespace?: string;
      resource?: string;
    }>;
    vmVolumes?: {
      errMsg?: string;
      /** @format int64 */
      totalSize?: number;
      volumes?: Array<{
        annotations?: Record<string, string>;
        apiVersion?: string;
        boundBlueprints?: Array<{
          bindingRef: {
            name: string;
            namespace?: string;
          };
          name: string;
          namespace: string;
        }>;
        group?: string;
        kind?: string;
        name?: string;
        namespace?: string;
        persistentVolumeClaimName?: string;
        podName?: string;
        resource?: string;
        /** @format int64 */
        size?: number;
        type?: string;
      }>;
    };
  };
  freezeOS: boolean;
  labels?: Array<{
    type?: string;
    value?: string;
  }>;
  name?: string;
  status?: string;
}

/** Used to filter virtual machines */
export interface VMFilter {
  /** Filter by whether VM filesystem quiescing was requested during backup */
  freezeOS?: boolean | null;
  /**
   * If false, return VMs matching the filter criteria.
   * If true, return all other VMs that don't match the criteria.
   */
  invert?: boolean;
  /** Filter by VM name (supports partial matching, case-insensitive) */
  name?: string;
  /** Filter by namespace (supports partial matching, case-insensitive) */
  namespace?: string;
  /**
   * Filter by VM status (e.g., Running, Stopped).
   * If multiple statuses are provided, VMs matching any of the statuses will be included.
   */
  statuses?: Array<VirtualMachineStatus>;
}

/** A VM snapshot created by k10 */
export interface VMSnapshot {
  /** Whether the VM is eligible for Changed Block Tracking backup (VEP-25) */
  cbtEligible?: boolean;
  /** PVC names associated with the VM discovered during backup when CBT-eligible */
  cbtPvcNames?: Array<string>;
  /** Snapshot consistency */
  snapshotConsistency?: "ApplicationConsistent" | "CrashConsistent";
  vmStatus?: VirtualMachineStatus;
}

export interface VMToAnnotateResponse {
  err?: string;
  name?: string;
  namespace?: string;
  success: boolean;
}

export interface VMsToAnnotate {
  annotations?: Record<string, string>;
  virtualMachines?: Array<{
    Name: string;
    Namespace: string;
  }>;
}

export interface ValidateActionP {
  apiVersion?: string;
  kind?: string;
  metadata?: {
    annotations?: Record<string, string>;
    /** @format date-time */
    creationTimestamp?: string;
    /** @format int64 */
    deletionGracePeriodSeconds?: number;
    /** @format date-time */
    deletionTimestamp?: string;
    finalizers?: Array<string>;
    generateName?: string;
    /** @format int64 */
    generation?: number;
    labels?: Record<string, string>;
    managedFields?: Array<{
      apiVersion?: string;
      fieldsType?: string;
      fieldsV1?: {};
      manager?: string;
      operation?: string;
      subresource?: string;
      /** @format date-time */
      time?: string;
    }>;
    name?: string;
    namespace?: string;
    ownerReferences?: Array<{
      apiVersion: string;
      blockOwnerDeletion?: boolean;
      controller?: boolean;
      kind: string;
      name: string;
      uid: string;
    }>;
    resourceVersion?: string;
    selfLink?: string;
    uid?: string;
  };
  spec?: {
    actionPodSpec?: {
      name: string;
      namespace?: string;
    };
    filters?: {
      excludeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      excludeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeClusterResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeExtraResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
      includeResources?: Array<{
        group?: string;
        matchExpressions?: Array<{
          key: string;
          operator: string;
          values?: Array<string>;
        }>;
        matchLabels?: Record<string, string>;
        name?: string;
        resource?: string;
        version?: string;
      }>;
    };
    /** @format date-time */
    scheduledTime?: string;
    subject?: {
      apiVersion?: string;
      kind?: string;
      name: string;
      namespace?: string;
    };
    volumeDataCheckOptions?: {
      failFast?: boolean;
      verifyFilesPercent?: string;
    };
  };
  status?: {
    actionDetails?: {
      artifacts?: Array<{
        meta?: {
          dataservice?: {
            kanisterArtifacts?: Array<{
              meta?: {
                k8sVolume?: {
                  name?: string;
                  pvcName?: string;
                  storageClassName?: string;
                };
                location?: {
                  fileStore?: {
                    claimName?: string;
                    path?: string;
                    /** @format int64 */
                    suppGroup?: number;
                  };
                  objectStore?: {
                    endpoint?: string;
                    name?: string;
                    objectStoreType?: string;
                    path?: string;
                    pathType?: string;
                    region?: string;
                    skipSSLVerify?: boolean;
                  };
                  type?: string;
                  vbr?: {
                    repoId?: string;
                    repoName?: string;
                    serverAddress?: string;
                  };
                };
                profileRef?: {
                  apiVersion?: string;
                  kind?: string;
                  name: string;
                  namespace?: string;
                };
                storageUsage?: {
                  /** @format int64 */
                  count: number;
                  /** @format int64 */
                  freed: number;
                  /** @format int64 */
                  logical: number;
                  /** @format int64 */
                  physical: number;
                };
                type?: string;
                uploadDataFormat?: string;
                /** @format date-time */
                uploadEndTime?: string;
                version?: string;
              };
              name?: string;
              values?: Array<{
                key?: string;
                value?: string;
              }>;
            }>;
            meta?: {
              host?: string;
              manager?: string;
              type?: string;
            };
            spec?: {
              config?: string;
              group?: string;
              name?: string;
              namespace?: string;
              resource?: string;
              type?: string;
              version?: string;
            };
          };
          kanister?: {
            meta?: {
              k8sVolume?: {
                name?: string;
                pvcName?: string;
                storageClassName?: string;
              };
              location?: {
                fileStore?: {
                  claimName?: string;
                  path?: string;
                  /** @format int64 */
                  suppGroup?: number;
                };
                objectStore?: {
                  endpoint?: string;
                  name?: string;
                  objectStoreType?: string;
                  path?: string;
                  pathType?: string;
                  region?: string;
                  skipSSLVerify?: boolean;
                };
                type?: string;
                vbr?: {
                  repoId?: string;
                  repoName?: string;
                  serverAddress?: string;
                };
              };
              profileRef?: {
                apiVersion?: string;
                kind?: string;
                name: string;
                namespace?: string;
              };
              storageUsage?: {
                /** @format int64 */
                count: number;
                /** @format int64 */
                freed: number;
                /** @format int64 */
                logical: number;
                /** @format int64 */
                physical: number;
              };
              type?: string;
              uploadDataFormat?: string;
              /** @format date-time */
              uploadEndTime?: string;
              version?: string;
            };
            name?: string;
            values?: Array<{
              key?: string;
              value?: string;
            }>;
          };
          snapshot?: {
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            k8sSnapshot?: {
              driver?: string;
              handle?: string;
              volumeSnapshotClassName?: string;
            };
            k8sVolume?: {
              name?: string;
              pvcName?: string;
              storageClassName?: string;
            };
            region?: string;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            volume?: {
              attributes: Array<{
                key?: string;
                value?: string;
              }>;
              az?: string;
              /** @format date-time */
              creationTime?: string;
              encrypted?: boolean;
              id?: string;
              /** @format int64 */
              iops?: number;
              /** @format int64 */
              size?: number;
              sizeUnit?: string;
              tags?: Array<{
                key?: string;
                value?: string;
              }>;
              type?: string;
              users?: Array<string>;
              volumeType?: string;
            };
          };
          spec?: {
            config?: string;
            group?: string;
            name?: string;
            namespace?: string;
            resource?: string;
            type?: string;
            version?: string;
          };
          vmSnapshot?: {
            cbtEligible?: boolean;
            cbtPvcNames?: Array<string>;
            snapshotConsistency?: string;
            vmStatus?: string;
          };
          volume?: {
            attributes: Array<{
              key?: string;
              value?: string;
            }>;
            az?: string;
            /** @format date-time */
            creationTime?: string;
            encrypted?: boolean;
            id?: string;
            /** @format int64 */
            iops?: number;
            /** @format int64 */
            size?: number;
            sizeUnit?: string;
            tags?: Array<{
              key?: string;
              value?: string;
            }>;
            type?: string;
            users?: Array<string>;
            volumeType?: string;
          };
        };
        source?: {
          apiVersion?: string;
          kind?: string;
          name: string;
          namespace?: string;
        };
      }>;
      /** @format int32 */
      errorCount: number;
      phases?: Array<{
        /** @format int64 */
        attempt?: number;
        /** @format date-time */
        endTime?: string;
        errors?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        exceptions?: Array<{
          cause?: string;
          fields?: Array<{
            name?: string;
            value?: string;
          }>;
          message?: string;
          retriable?: boolean;
        }>;
        name?: string;
        /** @format date-time */
        startTime?: string;
        state?: string;
        /** @format date-time */
        updatedTime?: string;
        volumeOperations?: Array<{
          dataFormat?: string;
          driver?: string;
          exportDirective?: string;
          namespace: string;
          operation: string;
          pvcName: string;
          snapshotId?: string;
          storageClass?: string;
          storageType?: string;
          volumeSnapshotClass?: string;
        }>;
      }>;
      volumeDataCheckResult?: Array<{
        appName?: string;
        /** @format int32 */
        errCount: number;
        errors?: Array<string>;
        stats?: {
          /** @format int64 */
          processedBytes: number;
          /** @format int64 */
          processedObjectCount: number;
          /** @format int64 */
          readBytes: number;
          /** @format int64 */
          readFileCount: number;
          /** @format int64 */
          totalBytes: number;
          /** @format int64 */
          totalFileCount: number;
          /** @format int64 */
          totalObjectCount: number;
        };
        volumeName?: string;
      }>;
    };
    /** @format date-time */
    endTime?: string;
    error?: {
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    };
    exceptions?: Array<{
      cause?: string;
      fields?: Array<{
        name?: string;
        value?: string;
      }>;
      message?: string;
      retriable?: boolean;
    }>;
    /** @format int64 */
    progress?: number;
    progressDetails?: {
      /**
       * @format int64
       * @min 0
       */
      completedVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      processedBytes: number;
      /**
       * @format int64
       * @min 0
       */
      processedObjects?: number;
      /**
       * @format int64
       * @min 0
       */
      processingRate: number;
      /**
       * @format int64
       * @min 0
       */
      readBytes: number;
      /**
       * @format int64
       * @min 0
       */
      readFiles?: number;
      /**
       * @format int64
       * @min 0
       */
      totalBytes: number;
      /**
       * @format int64
       * @min 0
       */
      totalFileCount?: number;
      /**
       * @format int64
       * @min 0
       */
      totalObjects?: number;
      /**
       * @format int64
       * @min 0
       */
      totalVolumes: number;
      /**
       * @format int64
       * @min 0
       */
      transferredBytes: number;
      /** @format date-time */
      updatedTime: string;
    };
    /** @format date-time */
    startTime?: string;
    state?: string;
  };
}

/** Data from browser for initiating a validate action */
export interface ValidateForm {
  /** The namespace in which the validate action will be created */
  namespace?: string;
  params?: ValidateParametersP;
  restorePoint?: ReferenceP;
  restorePointContent?: ReferenceP;
}

export interface ValidateParametersP {
  actionPodSpec?: {
    name: string;
    namespace?: string;
  };
  filters?: {
    excludeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    excludeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeClusterResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeExtraResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
    includeResources?: Array<{
      group?: string;
      matchExpressions?: Array<{
        key: string;
        operator: string;
        values?: Array<string>;
      }>;
      matchLabels?: Record<string, string>;
      name?: string;
      resource?: string;
      version?: string;
    }>;
  };
  volumeDataCheckOptions?: {
    failFast?: boolean;
    verifyFilesPercent?: string;
  };
}

/** A Vault passkey provider */
export type VaultPasskeyConfig = {
  /** The Vault auth mount path */
  authMountPath?: string;
  /** The Vault auth role */
  authRole: string;
  /** The Vault k8s service accound token path */
  k8sServiceAccountTokenPath: string;
  /** The Vault transit key name */
  transitKeyName: string;
  /** The Vault transit path */
  transitPath?: string;
};

/** Authorize data for authorizing with Veeam Vault */
export interface VeeamVaultAuthorizeForm {
  code: string;
  codeVerifier: string;
}

/** Temporary AWS credentials returned in the format expected by the AWS container-credentials provider (EKS pod identity). Field names are PascalCase as mandated by the AWS SDKs and MUST NOT be renamed to camelCase. */
export interface VeeamVaultAwsCredentials {
  /** @example "ASIA..." */
  AccessKeyId: string;
  /**
   * RFC3339 time after which the credentials are invalid; the SDK refreshes before this.
   * @format date-time
   * @example "2026-05-15T18:03:31Z"
   */
  Expiration: string;
  SecretAccessKey: string;
  /** AWS session token */
  Token: string;
}

/** Secrets required for PKCE/OAUTH workflow to register against Veeam Vault */
export interface VeeamVaultRegistrationSecrets {
  /** SHA256 digest of the `codeVerifier` */
  codeChallenge: string;
  /** Generated nonce for PKCE workflow */
  codeVerifier: string;
  /** Generated nonce for CSRF protection */
  state: string;
}

/** Current status for Veeam Vault Registration */
export interface VeeamVaultRegistrationStatus {
  ct?: {
    certThumbprint?: string;
    expiration?: string;
    hostName?: string;
  };
  error?: string;
  state: "registered" | "notRegistered" | "expired" | "failure";
  vault?: {
    certThumbprint?: string;
    expiration?: string;
  };
}

export interface VirtualMachineList {
  /** @format int64 */
  totalCount?: number;
  virtualMachines?: Array<{
    freezeOS: boolean;
    /** @format date-time */
    lastBackupTimestamp?: string;
    name?: string;
    namespace?: string;
    status?: string;
  }>;
}

export type VirtualMachineStatus = string;

/** A storage provider volume tracked by k10 */
export interface Volume {
  /** Specific block storage provider volume attributes */
  attributes?: Array<KeyValue>;
  /**
   * Availability zone
   * @example "us-west-2a"
   */
  az?: string;
  /** Time stamp when volume creation was initiated */
  creationTime?: TimeStamp;
  /** Volume is encrypted */
  encrypted?: boolean;
  /**
   * A unique identifier generated by the storage provider
   * @example "vol-037f858f2a3c5bb8d"
   */
  id?: string;
  /**
   * Volume IOPS, if specified for this volume
   * @format int64
   */
  iops?: number;
  /**
   * The size of the volume, in sizeUnit
   * @format int64
   */
  size?: number;
  /** The unit of size of the volume. The default size is GiB */
  sizeUnit?: string;
  tags?: Array<KeyValue>;
  /** Storage type for this volume */
  type?: StorageType;
  /** GCP specific, contains volume users list */
  users?: Array<string>;
  /** Volume type */
  volumeType?: string;
}

/** Optional predicates for joined prefixSearch */
export type PrefixSearchArtifactsPayload = Array<KeyValue>;

export type GetLatestRestorePointContentsPayload = Array<K8SObjectReference>;

export type GetLatestRestorePointsPayload = Array<K8SObjectReference>;

/**
 * K8s token used in login
 * @format string
 */
export type LoginPayload = string;

/** Message to queue */
export interface EnqueueMsgPayload {
  /** priority level of the message */
  priority?: string;
  queuedMsg?: QueuedMsg;
}

/** The name of the namespace to create */
export type CreateNamespacePayload = string;

/** @format binary */
export type PushAndAggregateMetricsPayload = Blob;

/** @format binary */
export type ReplaceAndAggregateMetricsPayload = Blob;

/**
 * Queued job identifier for a request
 * @format string
 */
export type DeleteQueuedJobPayload = string;

/**
 * Queued job identifier for a request
 * @format string
 */
export type CancelQueuedJobPayload = string;

/**
 * Queued job identifier for a request
 * @format string
 */
export type ResetQueuedJobPayload = string;

/** Metering items to record */
export type RecordMetricsPayload = Array<MeteringItem>;

/** URL to redirect to with temporary authentication */
export interface RequestRedirectPayload {
  token?: string;
  url?: string;
}

import axios, {
  type AxiosInstance,
  type AxiosRequestConfig,
  type AxiosResponse,
  type HeadersDefaults,
  type ResponseType,
} from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

// Error type isn't used anywhere. See the problem with inference related to it: https://github.com/microsoft/TypeScript/issues/40796
// In order to closure the type of error (which is E) we create non-existing "optional" field that will always be undefined.
export type ApiResponse<T = any, E = any> = AxiosResponse<T> & { error?: E };
export type RequestParams<
  Params extends FullRequestParams = FullRequestParams,
> = Omit<Params, "body" | "method" | "query" | "path">;
export type ParamsFromClient<Client> =
  Client extends HttpClient<infer R> ? R : never;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<
  Params extends FullRequestParams = FullRequestParams,
  SecurityDataType = unknown,
> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://127.0.0.1/v0",
      paramsSerializer: { indexes: null },
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public async request<T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: Params): Promise<ApiResponse<T, _E>> {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData
          ? { "Content-Type": type }
          : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  }
}

/**
 * @title k10
 * @version 0.1-alpha
 * @baseUrl http://127.0.0.1/v0
 * @contact <k10api@kasten.io>
 *
 * Combined k10 services APIs
 */
export class Api<
  SecurityDataType extends unknown,
  HTTPClientI extends HttpClient,
  HTTPClientParams extends ParamsFromClient<HTTPClientI>,
> {
  constructor(public http: HTTPClientI) {}

  actions = {
    /**
     * @description Gets data for displaying actions on dashboard page
     *
     * @name listActions
     * @summary Get a list of K10Actions
     * @request GET:/actions
     * @response `200` `DashboardActionList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listActions: (
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Used to filter return values. */
        filter?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DashboardActionList, ErrorDetail>({
        path: `/actions`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets details for a K10 action
     *
     * @name getActionDetails
     * @summary Get a single K10Action with details
     * @request GET:/actions/details
     * @response `200` `K10Action`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getActionDetails: (
      query: {
        /** Object to query */
        kind: string;
        /** Object to query */
        namespace?: string;
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K10Action, ErrorDetail>({
        path: `/actions/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get a summary of K10 actions in the system
     *
     * @name getActionsSummary
     * @summary Get a summary of actions in the system
     * @request GET:/actions/summary
     * @response `200` `ActionsListSummary`
     * @response `default` `ErrorDetail`
     */
    getActionsSummary: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ActionsListSummary, ErrorDetail>({
        path: `/actions/summary`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  appPolicies = {
    /**
     * @description Lists policies belonging to each app
     *
     * @name listAppPolicies
     * @request GET:/appPolicies
     * @response `200` `AppPolicies`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listAppPolicies: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<AppPolicies, ErrorDetail>({
        path: `/appPolicies`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  applications = {
    /**
     * @description Annotate K8s object with a blueprint name
     *
     * @name annotateApplicationResource
     * @summary Annotate K8s object with a blueprint name
     * @request POST:/applications/blueprint/annotate/resource
     * @response `200` `void` Blueprint Annotation added
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    annotateApplicationResource: (
      objectBPRef: AppResourceBlueprintRef,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/applications/blueprint/annotate/resource`,
        method: "POST",
        body: objectBPRef,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets details of an application
     *
     * @name getApplicationDetails
     * @summary Returns details of an application
     * @request GET:/applications/details/
     * @response `200` `Application`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getApplicationDetails: (
      query: {
        /** Application type */
        appType: string;
        /** Application name */
        appName: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Application, ErrorDetail>({
        path: `/applications/details/`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description This endpoint returns all the policies that select the passed namespace
     *
     * @name getPoliciesSelectingAnApp
     * @summary Returns all the policies that select a namespace
     * @request GET:/applications/selectedByPolicies
     * @response `200` `Array<PolicySelectingAnApp>`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getPoliciesSelectingAnApp: (
      query: {
        /** Application type */
        appType: string;
        /** Application name */
        appName: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Array<PolicySelectingAnApp>, ErrorDetail>({
        path: `/applications/selectedByPolicies`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  artifacts = {
    /**
     * @description Lists the artifacts that exist in the system, returning a paginated batch. Pagination order is over UUID byte order (effectively random for v4 UUIDs). Iterate until the continuation token in the response is empty. Do not infer iteration completion from len(items) < limit — limit is advisory and the server is permitted to return a short page with more data behind it. Omitting the limit parameter entirely (relying on the server-side default of int32-max) returns the full catalog in a single response from one server-side snapshot; an explicit limit of zero or less returns an empty page (SQL LIMIT 0 semantics).
     *
     * @name listArtifacts
     * @summary Lists the existing artifacts
     * @request GET:/artifacts
     * @response `200` `ArtifactListWithContinuation`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listArtifacts: (
      query?: {
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Client-specified point within result to continue query. */
        continue?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactListWithContinuation, ErrorDetail>({
        path: `/artifacts`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds an artifact to the system
     *
     * @name addArtifact
     * @summary Adds an artifact
     * @request POST:/artifacts
     * @response `201` `Artifact`
     * @response `400` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    addArtifact: (
      artifactItem: Artifact,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Artifact, ErrorDetail>({
        path: `/artifacts`,
        method: "POST",
        body: artifactItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Add batch of artifacts,
     *
     * @name batchAddArtifacts
     * @summary Add batch of artifacts,
     * @request PUT:/artifacts/batchAdd
     * @response `201` `ArtifactList`
     * @response `default` `ErrorDetail`
     */
    batchAddArtifacts: (
      artifacts: ArtifactList,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactList, ErrorDetail>({
        path: `/artifacts/batchAdd`,
        method: "PUT",
        body: artifacts,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Delete batch of artifacts, ignoring NotFound errors
     *
     * @name batchDeleteArtifacts
     * @summary Delete batch of artifacts, ignoring NotFound errors
     * @request PUT:/artifacts/batchDelete
     * @response `default` `ErrorDetail`
     */
    batchDeleteArtifacts: (
      ids: BatchIDs,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/artifacts/batchDelete`,
        method: "PUT",
        body: ids,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get batch of artifacts, optionally ignoring NotFound errors
     *
     * @name batchGetArtifacts
     * @summary Get batch of artifacts, optionally ignoring NotFound errors
     * @request GET:/artifacts/batchGet
     * @response `200` `ArtifactList`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    batchGetArtifacts: (
      ids: BatchIDs,
      query?: {
        /** Ignore IDs or keys that are not found */
        ignoreNotFound?: boolean;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactList, ErrorDetail>({
        path: `/artifacts/batchGet`,
        method: "GET",
        query: query,
        body: ids,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Update batch of artifacts,
     *
     * @name batchUpdateArtifacts
     * @summary Update batch of artifacts,
     * @request PUT:/artifacts/batchUpdate
     * @response `200` `ArtifactList`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    batchUpdateArtifacts: (
      artifacts: ArtifactList,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactList, ErrorDetail>({
        path: `/artifacts/batchUpdate`,
        method: "PUT",
        body: artifacts,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description returns a list of index values on k10 artifacts
     *
     * @name listArtifactsIndex
     * @summary Get Index Values on artifacts in the catalog
     * @request GET:/artifacts/index
     * @response `200` `IndexValueListWithContinuation`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listArtifactsIndex: (
      query?: {
        /** A predefined query key */
        key?: string;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Client-specified point within result to continue query. */
        continue?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<IndexValueListWithContinuation, ErrorDetail>({
        path: `/artifacts/index`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets the last used counter value used for ResourceVersion field
     *
     * @name getLastResourceVersion
     * @summary Gets the last used ResourceVersion
     * @request GET:/artifacts/lastResourceVersion
     * @response `200` `{
     *   \* $1* @format int64 *\
     *     resourceVersion: number,
     * }`
     * @response `default` `ErrorDetail`
     */
    getLastResourceVersion: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<
        {
          /** @format int64 */
          resourceVersion: number;
        },
        ErrorDetail
      >({
        path: `/artifacts/lastResourceVersion`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns artifacts that prefix match on the search criteria
     *
     * @name prefixSearchArtifacts
     * @summary Search for artifacts by prefix string
     * @request GET:/artifacts/prefixSearch
     * @response `200` `ArtifactListWithContinuation`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    prefixSearchArtifacts: (
      predicates: PrefixSearchArtifactsPayload,
      query?: {
        /** A predefined query key */
        key?: string;
        /** The query key value */
        value?: string;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /**
         * Client-specified reverse-order query results.
         * @default false
         */
        reverseOrder?: boolean;
        /** Client-specified point within result to continue query. */
        continue?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactListWithContinuation, ErrorDetail>({
        path: `/artifacts/prefixSearch`,
        method: "GET",
        query: query,
        body: predicates,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns artifacts based on the search criteria
     *
     * @name searchArtifacts
     * @summary Search for artifacts
     * @request GET:/artifacts/search
     * @response `200` `ArtifactList`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    searchArtifacts: (
      query?: {
        /** A predefined query key */
        key?: string;
        /** The query key value */
        value?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactList, ErrorDetail>({
        path: `/artifacts/search`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets the persistent identifier of the K10 artifact store (catalog)
     *
     * @name getCatalogInstance
     * @summary Gets catalog instance identifier
     * @request GET:/artifacts/storeInstance
     * @response `200` `ItemId`
     * @response `default` `ErrorDetail`
     */
    getCatalogInstance: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ItemId, ErrorDetail>({
        path: `/artifacts/storeInstance`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns up to artifacts events from starting from the offset resource version. If offset does not exist, this will return the next event. resource versions may not be consecutive.
     *
     * @name streamArtifacts
     * @summary Stream Artifact events
     * @request GET:/artifacts/stream
     * @response `200` `ArtifactEventList`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    streamArtifacts: (
      query?: {
        streamName?: string;
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactEventList, ErrorDetail>({
        path: `/artifacts/stream`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the definition of an individual artifact with the given id
     *
     * @name deleteArtifact
     * @summary Deletes an artifact
     * @request DELETE:/artifacts/{itemId}
     * @response `200` `Artifact`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteArtifact: (
      itemId: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Artifact, ErrorDetail>({
        path: `/artifacts/${itemId}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets the definition of an individual artifact with the given id
     *
     * @name getArtifact
     * @summary Gets info for an artifact
     * @request GET:/artifacts/{itemId}
     * @response `200` `Artifact`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getArtifact: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Artifact, ErrorDetail>({
        path: `/artifacts/${itemId}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing artifact
     *
     * @name updateArtifact
     * @summary Updates an existing artifact
     * @request PUT:/artifacts/{itemId}
     * @response `200` `Artifact`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateArtifact: (
      itemId: string,
      artifactItem: Artifact,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Artifact, ErrorDetail>({
        path: `/artifacts/${itemId}`,
        method: "PUT",
        body: artifactItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets the holds taken on the artifact with the given id and the value of DestructorNeeded..
     *
     * @name getArtifactHolds
     * @summary Gets holds for an artifact
     * @request GET:/artifacts/{itemId}/holds
     * @response `200` `HoldInfo`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getArtifactHolds: (
      itemId: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<HoldInfo, ErrorDetail>({
        path: `/artifacts/${itemId}/holds`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Atomically drops a hold on the artifact with itemID on behalf of holdID and sets DestructorNeeded when last hold is dropped. Caller should check returned HoldInfo to tell if hold taken.
     *
     * @name dropArtifactHold
     * @summary Drops a hold on an artifact
     * @request DELETE:/artifacts/{itemId}/holds/{holdId}
     * @response `200` `HoldInfo`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    dropArtifactHold: (
      itemId: string,
      holdId: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<HoldInfo, ErrorDetail>({
        path: `/artifacts/${itemId}/holds/${holdId}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Atomically takes a hold on the artifact with itemID on behalf of holdID as long as DestructorNeeded is not already set.  Returns success when hold taken and Conflict error when DestructorNeeded is already set. Caller should check error to distinguish Conflict from transient error that may have taken hold.
     *
     * @name takeArtifactHold
     * @summary Takes a hold on an artifact
     * @request PUT:/artifacts/{itemId}/holds/{holdId}
     * @response `200` `HoldInfo`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    takeArtifactHold: (
      itemId: string,
      holdId: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<HoldInfo, ErrorDetail>({
        path: `/artifacts/${itemId}/holds/${holdId}`,
        method: "PUT",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  artifactsBatchGetOrAdd = {
    /**
     * @description Gets batch of existing artifact or adds artifacts to the system
     *
     * @name batchGetOrAddArtifacts
     * @summary Gets an existing artifact or adds the artifact
     * @request POST:/artifacts:batchGetOrAdd
     * @response `201` `ArtifactList`
     * @response `400` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    batchGetOrAddArtifacts: (
      batchGetOrAdd: string,
      artifacts: ArtifactList,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ArtifactList, ErrorDetail>({
        path: `/artifacts${batchGetOrAdd}`,
        method: "POST",
        body: artifacts,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  artifactsGetOrAdd = {
    /**
     * @description Gets an existing artifact or adds the artifact to the system
     *
     * @name getOrAddArtifact
     * @summary Gets an existing artifact or adds the artifact
     * @request POST:/artifacts:getOrAdd
     * @response `201` `Artifact`
     * @response `400` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getOrAddArtifact: (
      getOrAdd: string,
      artifactItem: Artifact,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Artifact, ErrorDetail>({
        path: `/artifacts${getOrAdd}`,
        method: "POST",
        body: artifactItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  authstatus = {
    /**
     * @description Used for checking if the user's token has expired.
     *
     * @name getAuthStatus
     * @summary Status endpoint that is periodically queried by the frontend to check if the user's token is valid.
     * @request GET:/authstatus
     * @response `200` `any`
     * @response `401` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getAuthStatus: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<any, ErrorDetail>({
        path: `/authstatus`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  authtype = {
    /**
     * @description Get authentication type configured with K10
     *
     * @name getAuthType
     * @request GET:/authtype
     * @response `200` `string`
     * @response `default` `ErrorDetail`
     */
    getAuthType: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<string, ErrorDetail>({
        path: `/authtype`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  authuser = {
    /**
     * @description Get authenticated user as visible to auth-svc
     *
     * @name getAuthUser
     * @request GET:/authuser
     * @response `200` `AuthUser`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getAuthUser: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<AuthUser, ErrorDetail>({
        path: `/authuser`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  backupaction = {
    /**
     * @description Creates a backup action API object
     *
     * @name backupAction
     * @summary Creates a backup action
     * @request POST:/backupaction
     * @response `201` `BackupActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    backupAction: (
      action: BackupActionP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BackupActionP, ErrorDetail>({
        path: `/backupaction`,
        method: "POST",
        body: action,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  backupclusteraction = {
    /**
     * @description Creates a backup cluster action API object
     *
     * @name backupClusterAction
     * @summary Creates a backup cluster action
     * @request POST:/backupclusteraction
     * @response `201` `BackupClusterActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    backupClusterAction: (
      action: BackupClusterActionP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BackupClusterActionP, ErrorDetail>({
        path: `/backupclusteraction`,
        method: "POST",
        body: action,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  bff = {
    /**
     * @description Gets a latest restore point content API objects for apps in the specified date range. If the date range is omitted, gets the latest existing restore point content.
     *
     * @name getLatestRestorePointContents
     * @summary Get latest restore point contents for apps
     * @request POST:/bff/applications/latestRestorePointContents
     * @response `200` `RestorePointContentObjectPerAppList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getLatestRestorePointContents: (
      appRefs: GetLatestRestorePointContentsPayload,
      query?: {
        /**
         * Limits the resulting objects to be at least this date
         * @format date-time
         */
        dateFrom?: string;
        /**
         * Limits the resulting objects to be at most this date
         * @format date-time
         */
        dateTo?: string;
        /** Type of restorepoints. Snapshot, exported or imported. */
        types?: Array<string>;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointContentObjectPerAppList, ErrorDetail>({
        path: `/bff/applications/latestRestorePointContents`,
        method: "POST",
        query: query,
        body: appRefs,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets a latest restore point API objects for apps in the specified date range. If the date range is omitted, gets the latest existing restore point.
     *
     * @name getLatestRestorePoints
     * @summary Get latest restore points for apps
     * @request POST:/bff/applications/latestRestorePoints
     * @response `200` `RestorePointObjectPerAppList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getLatestRestorePoints: (
      appRefs: GetLatestRestorePointsPayload,
      query?: {
        /**
         * Limits the resulting objects to be at least this date
         * @format date-time
         */
        dateFrom?: string;
        /**
         * Limits the resulting objects to be at most this date
         * @format date-time
         */
        dateTo?: string;
        /** Type of restorepoints. Snapshot, exported or imported. */
        types?: Array<string>;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointObjectPerAppList, ErrorDetail>({
        path: `/bff/applications/latestRestorePoints`,
        method: "POST",
        query: query,
        body: appRefs,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listBlueprintBindings
     * @summary Lists blueprint binding CRs in a namespace
     * @request GET:/bff/blueprintbindings/{namespace}
     * @response `200` `BlueprintBindingList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listBlueprintBindings: (
      namespace: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BlueprintBindingList, ErrorDetail>({
        path: `/bff/blueprintbindings/${namespace}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteBlueprintBinding
     * @summary Deletes a blueprint binding
     * @request DELETE:/bff/blueprintbindings/{namespace}/{name}
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteBlueprintBinding: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/bff/blueprintbindings/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getBlueprintBinding
     * @summary Get detailed info about a specific blueprint binding
     * @request GET:/bff/blueprintbindings/{namespace}/{name}
     * @response `200` `BlueprintBinding`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getBlueprintBinding: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BlueprintBinding, ErrorDetail>({
        path: `/bff/blueprintbindings/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createBlueprintBinding
     * @summary Adds a new blueprint binding CR in a namespace
     * @request POST:/bff/blueprintbindings/{namespace}/{name}
     * @response `201` `BlueprintBinding`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createBlueprintBinding: (
      namespace: string,
      name: string,
      blueprintBindingSpec: BlueprintBindingSpec,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BlueprintBinding, string | ErrorDetail>({
        path: `/bff/blueprintbindings/${namespace}/${name}`,
        method: "POST",
        body: blueprintBindingSpec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name updateBlueprintBinding
     * @summary Updates an existing blueprint binding CR in a namespace
     * @request PUT:/bff/blueprintbindings/{namespace}/{name}
     * @response `200` `BlueprintBinding`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateBlueprintBinding: (
      namespace: string,
      name: string,
      blueprintBindingSpec: BlueprintBindingSpec,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BlueprintBinding, string | ErrorDetail>({
        path: `/bff/blueprintbindings/${namespace}/${name}`,
        method: "PUT",
        body: blueprintBindingSpec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all the clusterRoleBindings
     *
     * @name bffListClusterRoleBindings
     * @summary List all clusterRoleBindings
     * @request GET:/bff/clusterRoleBindings
     * @response `200` `ClusterRoleBindingList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListClusterRoleBindings: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ClusterRoleBindingList, ErrorDetail>({
        path: `/bff/clusterRoleBindings`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a new clusterRoleBinding
     *
     * @name bffAddClusterRoleBinding
     * @summary Adds a new clusterRoleBinding
     * @request POST:/bff/clusterRoleBindings
     * @response `200` `ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddClusterRoleBinding: (
      clusterRoleBindingForm: ClusterRoleBindingForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRoleBinding, ErrorDetail>({
        path: `/bff/clusterRoleBindings`,
        method: "POST",
        body: clusterRoleBindingForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the clusterRoleBinding referred to by name
     *
     * @name bffDeleteClusterRoleBinding
     * @summary Deletes a clusterRoleBinding
     * @request DELETE:/bff/clusterRoleBindings/{name}
     * @response `200` `ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeleteClusterRoleBinding: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRoleBinding, ErrorDetail>({
        path: `/bff/clusterRoleBindings/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets information for the ClusterRoleBinding referred to by name
     *
     * @name bffGetClusterRoleBinding
     * @summary Get detailed info about a specific ClusterRoleBinding
     * @request GET:/bff/clusterRoleBindings/{name}
     * @response `200` `ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetClusterRoleBinding: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRoleBinding, ErrorDetail>({
        path: `/bff/clusterRoleBindings/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing clusterRoleBinding
     *
     * @name bffUpdateClusterRoleBinding
     * @summary Updates an existing clusterRoleBinding
     * @request PUT:/bff/clusterRoleBindings/{name}
     * @response `200` `ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffUpdateClusterRoleBinding: (
      name: string,
      clusterRoleBindingForm: ClusterRoleBindingForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRoleBinding, ErrorDetail>({
        path: `/bff/clusterRoleBindings/${name}`,
        method: "PUT",
        body: clusterRoleBindingForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all the clusterRoles
     *
     * @name bffListClusterRoles
     * @summary List all clusterRoles
     * @request GET:/bff/clusterRoles
     * @response `200` `ClusterRoleList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListClusterRoles: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ClusterRoleList, ErrorDetail>({
        path: `/bff/clusterRoles`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a ClusterRole to the system
     *
     * @name bffAddClusterRole
     * @summary Adds a new clusterRole
     * @request POST:/bff/clusterRoles
     * @response `201` `ClusterRole`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddClusterRole: (
      clusterRoleForm: ClusterRoleForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRole, ErrorDetail>({
        path: `/bff/clusterRoles`,
        method: "POST",
        body: clusterRoleForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the clusterRole referred to by name
     *
     * @name bffDeleteClusterRole
     * @summary Deletes a clusterRole
     * @request DELETE:/bff/clusterRoles/{name}
     * @response `200` `ClusterRole`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeleteClusterRole: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRole, ErrorDetail>({
        path: `/bff/clusterRoles/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets information for the clusterRole referred to by name
     *
     * @name bffGetClusterRole
     * @summary Get detailed info about a specific clusterRole
     * @request GET:/bff/clusterRoles/{name}
     * @response `200` `ClusterRole`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetClusterRole: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRole, ErrorDetail>({
        path: `/bff/clusterRoles/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing clusterRole
     *
     * @name bffUpdateClusterRole
     * @summary Updates an existing clusterRole
     * @request PUT:/bff/clusterRoles/{name}
     * @response `200` `ClusterRole`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffUpdateClusterRole: (
      name: string,
      clusterRoleForm: ClusterRoleForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRole, ErrorDetail>({
        path: `/bff/clusterRoles/${name}`,
        method: "PUT",
        body: clusterRoleForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffDrDeleteOwnershipRestriction
     * @summary Delete cluster ownership configmap
     * @request DELETE:/bff/dr/ownershiprestriction
     * @response `204` `void` Cluster ownership established
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDrDeleteOwnershipRestriction: (
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/bff/dr/ownershiprestriction`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffDrRestore
     * @summary Runs DR restore using the specified restore point
     * @request POST:/bff/dr/restore
     * @response `201` `void` DR restore started.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDrRestore: (
      drRestoreInfo: DRRestoreInfo,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/bff/dr/restore`,
        method: "POST",
        body: drRestoreInfo,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffDrRestoreStatus
     * @summary Returns the DR restore result
     * @request GET:/bff/dr/restorestatus
     * @response `200` `DRRestoreStatus`
     * @response `400` `ErrorDetail`
     * @response `500` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDrRestoreStatus: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<DRRestoreStatus, ErrorDetail>({
        path: `/bff/dr/restorestatus`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffValidateDrInfo
     * @summary Initiates validation for source cluster information
     * @request POST:/bff/dr/validate
     * @response `201` `void` Validation in progress.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffValidateDrInfo: (
      sourceClusterInfo: SourceClusterInfo,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/bff/dr/validate`,
        method: "POST",
        body: sourceClusterInfo,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffDrValidationStatus
     * @summary Returns the DR validation result and available restorepoints if successful
     * @request GET:/bff/dr/validationstatus
     * @response `200` `DRValidationStatus`
     * @response `400` `ErrorDetail`
     * @response `500` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDrValidationStatus: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<DRValidationStatus, ErrorDetail>({
        path: `/bff/dr/validationstatus`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffGetDrSecret
     * @summary Get the DR secret object if already present
     * @request GET:/bff/drpassphrase
     * @response `200` `K8SObject`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetDrSecret: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<K8SObject, ErrorDetail>({
        path: `/bff/drpassphrase`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffCreateDrSecret
     * @summary Creates a K10 DR passphrase secret
     * @request POST:/bff/drpassphrase
     * @response `201` `K8SObject`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffCreateDrSecret: (
      spec: DRPassphraseForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K8SObject, ErrorDetail>({
        path: `/bff/drpassphrase`,
        method: "POST",
        body: spec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List events tracked by the Events service.
     *
     * @name bffListEvents
     * @request GET:/bff/events
     * @response `200` `EventList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListEvents: (
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Used to filter return values. */
        filter?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<EventList, ErrorDetail>({
        path: `/bff/events`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes an individual event with the given ID
     *
     * @name bffDeleteEvent
     * @summary Deletes an event
     * @request DELETE:/bff/events/{itemId}
     * @response `204` `void` Event deleted successfully.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeleteEvent: (
      itemId: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/bff/events/${itemId}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffGetImportDetails
     * @summary Gets the import details from the specified secret name
     * @request GET:/bff/importdetails/{namespace}/{name}
     * @response `200` `string`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetImportDetails: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<string, ErrorDetail>({
        path: `/bff/importdetails/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffListPasskeys
     * @summary Lists passkeys in the catalog
     * @request GET:/bff/passkey
     * @response `200` `PasskeyList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListPasskeys: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PasskeyList, ErrorDetail>({
        path: `/bff/passkey`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffAddPasskey
     * @summary Adds a new passkey via BFF
     * @request POST:/bff/passkey
     * @response `201` `PasskeyP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddPasskey: (
      passkeyForm: PasskeyForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PasskeyP, ErrorDetail>({
        path: `/bff/passkey`,
        method: "POST",
        body: passkeyForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffDeletePasskey
     * @summary Deletes the specified passkey
     * @request DELETE:/bff/passkey/{name}
     * @response `200` `PasskeyP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeletePasskey: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PasskeyP, ErrorDetail>({
        path: `/bff/passkey/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffGetPasskey
     * @summary Gets a specific passkey from the catalog
     * @request GET:/bff/passkey/{name}
     * @response `200` `PasskeyP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetPasskey: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PasskeyP, ErrorDetail>({
        path: `/bff/passkey/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffGetPoliciesDetails
     * @summary Lists all the policies in a namespace with their details (preset and last run)
     * @request GET:/bff/policies/{namespace}
     * @response `200` `PoliciesDetailsList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetPoliciesDetails: (
      namespace: string,
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PoliciesDetailsList, ErrorDetail>({
        path: `/bff/policies/${namespace}`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns the Kopia upgrade status for all policies
     *
     * @name listPolicyUpgradeStatus
     * @summary List Kopia repository upgrade status for all policies
     * @request GET:/bff/policies/{namespace}/upgrade
     * @response `200` `Array<PolicyUpgradeStatus>`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listPolicyUpgradeStatus: (
      namespace: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Array<PolicyUpgradeStatus>, string | ErrorDetail>({
        path: `/bff/policies/${namespace}/upgrade`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Creates an upgrade action API object for specified policy
     *
     * @name upgradePolicy
     * @summary Upgrades a policy
     * @request POST:/bff/policies/{namespace}/{name}/upgrade
     * @response `201` `UpgradeActionP`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    upgradePolicy: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<UpgradeActionP, string | ErrorDetail>({
        path: `/bff/policies/${namespace}/${name}/upgrade`,
        method: "POST",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffListPolicyCRs
     * @summary Lists policy CRs in a namespace
     * @request GET:/bff/policycrs/{namespace}
     * @response `200` `PolicyCRList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListPolicyCRs: (
      namespace: string,
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyCRList, ErrorDetail>({
        path: `/bff/policycrs/${namespace}`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffAddPolicyCr
     * @summary Adds a policy CR in a namespace
     * @request POST:/bff/policycrs/{namespace}
     * @response `201` `PolicyCR`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddPolicyCr: (
      namespace: string,
      policy: PolicyCR,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyCR, string | ErrorDetail>({
        path: `/bff/policycrs/${namespace}`,
        method: "POST",
        body: policy,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing policy
     *
     * @name bffUpdatePolicyCr
     * @summary Updates an existing policy CR in a namespace
     * @request PUT:/bff/policycrs/{namespace}
     * @response `200` `PolicyCR`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffUpdatePolicyCr: (
      namespace: string,
      policy: PolicyCR,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyCR, string | ErrorDetail>({
        path: `/bff/policycrs/${namespace}`,
        method: "PUT",
        body: policy,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffDeletePolicyCr
     * @summary Deletes the specified policy CR
     * @request DELETE:/bff/policycrs/{namespace}/{name}
     * @response `200` `PolicyCR`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeletePolicyCr: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyCR, ErrorDetail>({
        path: `/bff/policycrs/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffGetPolicyCr
     * @summary Gets the specified specified policy CR
     * @request GET:/bff/policycrs/{namespace}/{name}
     * @response `200` `PolicyCR`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetPolicyCr: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyCR, ErrorDetail>({
        path: `/bff/policycrs/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listPolicyPresets
     * @summary Lists policy preset CRs in a namespace
     * @request GET:/bff/policypresets/{namespace}
     * @response `200` `PolicyPresetList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listPolicyPresets: (
      namespace: string,
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyPresetList, ErrorDetail>({
        path: `/bff/policypresets/${namespace}`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createPolicyPreset
     * @summary Adds a new policy preset CR in a namespace
     * @request POST:/bff/policypresets/{namespace}
     * @response `201` `PolicyPreset`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createPolicyPreset: (
      namespace: string,
      policyPreset: PolicyPresetCR,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyPreset, string | ErrorDetail>({
        path: `/bff/policypresets/${namespace}`,
        method: "POST",
        body: policyPreset,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deletePolicyPreset
     * @summary Deletes a policy preset
     * @request DELETE:/bff/policypresets/{namespace}/{name}
     * @response `200` `PolicyPreset`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deletePolicyPreset: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyPreset, ErrorDetail>({
        path: `/bff/policypresets/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getPolicyPreset
     * @summary Get detailed info about a specific policy preset
     * @request GET:/bff/policypresets/{namespace}/{name}
     * @response `200` `PolicyPreset`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getPolicyPreset: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyPreset, ErrorDetail>({
        path: `/bff/policypresets/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name updatePolicyPreset
     * @summary Updates an existing policy preset CR in a namespace
     * @request PUT:/bff/policypresets/{namespace}/{name}
     * @response `200` `PolicyPreset`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updatePolicyPreset: (
      namespace: string,
      name: string,
      policyPreset: PolicyPresetCR,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyPreset, string | ErrorDetail>({
        path: `/bff/policypresets/${namespace}/${name}`,
        method: "PUT",
        body: policyPreset,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all the profiles
     *
     * @name bffListProfilesCr
     * @summary List all profiles
     * @request GET:/bff/profilesCR/{namespace}
     * @response `200` `ProfileCRList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListProfilesCr: (
      namespace: string,
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCRList, ErrorDetail>({
        path: `/bff/profilesCR/${namespace}`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a Profile to the system
     *
     * @name bffAddProfileCr
     * @summary Adds a new profile
     * @request POST:/bff/profilesCR/{namespace}
     * @response `201` `ProfileCR`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddProfileCr: (
      namespace: string,
      profileForm: ProfileCRForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCR, string | ErrorDetail>({
        path: `/bff/profilesCR/${namespace}`,
        method: "POST",
        body: profileForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the profile referred to by name
     *
     * @name bffDeleteProfileCr
     * @summary Deletes a profile
     * @request DELETE:/bff/profilesCR/{namespace}/{name}
     * @response `200` `ProfileCR`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeleteProfileCr: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCR, ErrorDetail>({
        path: `/bff/profilesCR/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets information for the profile referred to by name
     *
     * @name bffGetProfileCr
     * @summary Get detailed info about a specific profile
     * @request GET:/bff/profilesCR/{namespace}/{name}
     * @response `200` `ProfileCR`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetProfileCr: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCR, ErrorDetail>({
        path: `/bff/profilesCR/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing profile
     *
     * @name bffUpdateProfileCr
     * @summary Updates an existing profile
     * @request PUT:/bff/profilesCR/{namespace}/{name}
     * @response `200` `ProfileCR`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffUpdateProfileCr: (
      namespace: string,
      name: string,
      profileForm: ProfileCRForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCR, string | ErrorDetail>({
        path: `/bff/profilesCR/${namespace}/${name}`,
        method: "PUT",
        body: profileForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Lists all the restore points from cluster to show them in RestorePoint catalog
     *
     * @name listRestorePoints
     * @summary Get all the restore points from cluster
     * @request GET:/bff/restorepoints
     * @response `200` `RestorePointsList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listRestorePoints: (
      query?: {
        /** Type of restorepoints. Snapshot, exported or imported. */
        types?: Array<string>;
        /** A list of application references in string format. Expected that each string will conform to the K8sObjectReference schema */
        appRefs?: Array<string>;
        /** Application type (optional) */
        appType?: string;
        /** Whether to include the restore points for cluster scoped resources */
        includeClusterScoped?: boolean;
        /** Policy name parameter */
        policyNames?: Array<string>;
        /** Whether to include the restore points for manually run policies/actions */
        includeManualRunsOnly?: boolean;
        /** Profile name parameter */
        profileNames?: Array<string>;
        /** @format date-time */
        createdBefore?: string;
        /** @format date-time */
        createdAfter?: string;
        /** Whether to only return resources that have no expiration */
        noExpiration?: boolean;
        /** Whether to only return restore points that completed with exceptions */
        hasExceptions?: boolean;
        /** Which field should be used to sort the response */
        sortBy?: "createdAt" | "expiresAt";
        /** Whether the list should be sorted in ascending order. */
        sortDir?: "ASC" | "DESC";
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointsList, ErrorDetail>({
        path: `/bff/restorepoints`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all the roleBindings in all namespaces
     *
     * @name bffListAllRoleBindings
     * @summary List all roleBindings in all namespaces
     * @request GET:/bff/roleBindings
     * @response `200` `RoleBindingList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListAllRoleBindings: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<RoleBindingList, ErrorDetail>({
        path: `/bff/roleBindings`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a new roleBinding in 1 or more namespaces
     *
     * @name bffAddRoleBindings
     * @summary Adds a new roleBinding in 1 or more namespaces
     * @request POST:/bff/roleBindings
     * @response `200` `RoleBindingList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddRoleBindings: (
      roleBindingForNamespacesForm: RoleBindingForNamespacesForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleBindingList, ErrorDetail>({
        path: `/bff/roleBindings`,
        method: "POST",
        body: roleBindingForNamespacesForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all roleBindings in the given namespace
     *
     * @name bffListRoleBindings
     * @summary List all roleBindings in a namespace
     * @request GET:/bff/roleBindings/{namespace}
     * @response `200` `RoleBindingList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListRoleBindings: (
      namespace: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleBindingList, ErrorDetail>({
        path: `/bff/roleBindings/${namespace}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the roleBinding referred to by name in the namespace
     *
     * @name bffDeleteRoleBinding
     * @summary Deletes a specific roleBinding
     * @request DELETE:/bff/roleBindings/{namespace}/{name}
     * @response `200` `RoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeleteRoleBinding: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleBinding, ErrorDetail>({
        path: `/bff/roleBindings/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets information for the roleBinding referred to by name in the namespace
     *
     * @name bffGetRoleBinding
     * @summary Get detailed info about a specific roleBinding
     * @request GET:/bff/roleBindings/{namespace}/{name}
     * @response `200` `RoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetRoleBinding: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleBinding, ErrorDetail>({
        path: `/bff/roleBindings/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing roleBinding referred to by name in the namespace
     *
     * @name bffUpdateRoleBinding
     * @summary Updates an existing roleBinding
     * @request PUT:/bff/roleBindings/{namespace}/{name}
     * @response `200` `RoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffUpdateRoleBinding: (
      namespace: string,
      name: string,
      roleBindingForm: RoleBindingForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleBinding, ErrorDetail>({
        path: `/bff/roleBindings/${namespace}/${name}`,
        method: "PUT",
        body: roleBindingForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all the roles in all namespaces
     *
     * @name bffListRolesAllNamespaces
     * @summary List all roles in all namespaces
     * @request GET:/bff/roles
     * @response `200` `RoleList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListRolesAllNamespaces: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<RoleList, ErrorDetail>({
        path: `/bff/roles`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a Role to the system in given namespaces
     *
     * @name bffAddRoles
     * @summary Adds a new role in given namespaces
     * @request POST:/bff/roles
     * @response `201` `RoleList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffAddRoles: (
      roleForNamespacesForm: RoleForNamespacesForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleList, ErrorDetail>({
        path: `/bff/roles`,
        method: "POST",
        body: roleForNamespacesForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description List all the roles in a namespace
     *
     * @name bffListRolesInNamespace
     * @summary List all roles in a namespace
     * @request GET:/bff/roles/{namespace}
     * @response `200` `RoleList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffListRolesInNamespace: (
      namespace: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RoleList, ErrorDetail>({
        path: `/bff/roles/${namespace}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the role referred to by name
     *
     * @name bffDeleteRole
     * @summary Deletes a role
     * @request DELETE:/bff/roles/{namespace}/{name}
     * @response `200` `Role`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffDeleteRole: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Role, ErrorDetail>({
        path: `/bff/roles/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets information for the role referred to by name
     *
     * @name bffGetRole
     * @summary Get detailed info about a specific role
     * @request GET:/bff/roles/{namespace}/{name}
     * @response `200` `Role`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffGetRole: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Role, ErrorDetail>({
        path: `/bff/roles/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an existing role
     *
     * @name bffUpdateRole
     * @summary Updates an existing prole
     * @request PUT:/bff/roles/{namespace}/{name}
     * @response `200` `Role`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffUpdateRole: (
      namespace: string,
      name: string,
      roleForm: RoleForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Role, ErrorDetail>({
        path: `/bff/roles/${namespace}/${name}`,
        method: "PUT",
        body: roleForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listTransformSets
     * @summary List all transformSets
     * @request GET:/bff/transformsets/{namespace}
     * @response `200` `{
     *   \* $1* List of custom transformSets *\
     *     customTransformSets?: TransformSetList,
     *   \* $1* List of transformSet examples *\
     *     exampleTransformSets?: TransformSetList,
     * }`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listTransformSets: (
      namespace: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<
        {
          /** List of custom transformSets */
          customTransformSets?: TransformSetList;
          /** List of transformSet examples */
          exampleTransformSets?: TransformSetList;
        },
        ErrorDetail
      >({
        path: `/bff/transformsets/${namespace}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteTransformSet
     * @summary Delete a transformSet
     * @request DELETE:/bff/transformsets/{namespace}/{name}
     * @response `204` `void` TransformSet has been deleted successfully
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteTransformSet: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/bff/transformsets/${namespace}/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getTransformSet
     * @summary Get a single transformSet
     * @request GET:/bff/transformsets/{namespace}/{name}
     * @response `200` `TransformSet`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getTransformSet: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<TransformSet, ErrorDetail>({
        path: `/bff/transformsets/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createTransformSet
     * @summary Create a new transformSet
     * @request POST:/bff/transformsets/{namespace}/{name}
     * @response `201` `TransformSet`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createTransformSet: (
      namespace: string,
      name: string,
      spec: TransformSetSpec,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<TransformSet, string | ErrorDetail>({
        path: `/bff/transformsets/${namespace}/${name}`,
        method: "POST",
        body: spec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name updateTransformSet
     * @summary Update a transformSet
     * @request PUT:/bff/transformsets/{namespace}/{name}
     * @response `200` `TransformSet`
     * @response `400` `string`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateTransformSet: (
      namespace: string,
      name: string,
      spec: TransformSetSpec,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<TransformSet, string | ErrorDetail>({
        path: `/bff/transformsets/${namespace}/${name}`,
        method: "PUT",
        body: spec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getUserPermissionFlagForResource
     * @request GET:/bff/userPermissionFlagForResource
     * @response `200` `UserPermissionFlag`
     * @response `default` `ErrorDetail`
     */
    getUserPermissionFlagForResource: (
      query: {
        /** An access right verb */
        verb: "create" | "delete" | "get" | "list" | "update";
        /** An access right subject */
        subject:
          | "policies"
          | "profiles"
          | "policypresets"
          | "transformsets"
          | "blueprintbindings"
          | "storagesecuritycontexts"
          | "storagesecuritycontextbindings"
          | "backupactions"
          | "restoreactions"
          | "stageactions"
          | "validateactions"
          | "exportactions"
          | "importactions"
          | "applications"
          | "restorepointcontents"
          | "namespaces"
          | "configmaps"
          | "secretsMC"
          | "bootstrapsMC"
          | "clustersMC";
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<UserPermissionFlag, ErrorDetail>({
        path: `/bff/userPermissionFlagForResource`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffValidatePolicyCr
     * @summary Validates a policy CR
     * @request POST:/bff/validate/policycr
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffValidatePolicyCr: (
      policy: PolicyCR,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/bff/validate/policycr`,
        method: "POST",
        body: policy,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name bffCheckBucketForImmutability
     * @summary Determines if a bucket will enable immutable backups for a policy
     * @request POST:/bff/validate/profilecr/immutability
     * @response `200` `BucketProperties`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    bffCheckBucketForImmutability: (
      profileForm: ProfileCRForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BucketProperties, ErrorDetail>({
        path: `/bff/validate/profilecr/immutability`,
        method: "POST",
        body: profileForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get the list of assigned Veeam vaults
     *
     * @name listAssignedVeeamVaults
     * @summary Get the list of assigned Veeam vaults
     * @request GET:/bff/veeamVault/assignedVaults
     * @response `200` `Array<AssignedVeeamVault>`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listAssignedVeeamVaults: (
      query?: {
        provider?: "AWS" | "Azure";
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Array<AssignedVeeamVault>, ErrorDetail>({
        path: `/bff/veeamVault/assignedVaults`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Send the authorize code
     *
     * @name veeamVaultAuthorize
     * @summary Send the authorize code
     * @request POST:/bff/veeamVault/authorize
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    veeamVaultAuthorize: (
      veeamVaultAuthorizeCode: VeeamVaultAuthorizeForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/bff/veeamVault/authorize`,
        method: "POST",
        body: veeamVaultAuthorizeCode,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get Veeam Vault registration information"
     *
     * @name getVeeamVaultRegistration
     * @summary Get Veeam Vault registration information
     * @request GET:/bff/veeamVault/registration
     * @response `200` `VeeamVaultRegistrationStatus`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getVeeamVaultRegistration: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<VeeamVaultRegistrationStatus, ErrorDetail>({
        path: `/bff/veeamVault/registration`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get PKCE values data required for VV registration
     *
     * @name getVeeamVaultRegistrationSecrets
     * @summary Get PKCE values data required for VV registration
     * @request GET:/bff/veeamVault/registrationSecrets
     * @response `200` `VeeamVaultRegistrationSecrets`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getVeeamVaultRegistrationSecrets: (
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<VeeamVaultRegistrationSecrets, ErrorDetail>({
        path: `/bff/veeamVault/registrationSecrets`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  blueprints = {
    /**
     * No description
     *
     * @name listBlueprints
     * @summary List blueprint names
     * @request GET:/blueprints
     * @response `200` `BlueprintList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listBlueprints: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<BlueprintList, ErrorDetail>({
        path: `/blueprints`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createBlueprint
     * @summary Create a blueprint resource
     * @request POST:/blueprints
     * @response `201` `BlueprintCreate`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createBlueprint: (
      blueprint: Blueprint,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BlueprintCreate, ErrorDetail>({
        path: `/blueprints`,
        method: "POST",
        body: blueprint,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name updateBlueprint
     * @summary Update a blueprint resource
     * @request PUT:/blueprints
     * @response `200` `void` Blueprint was updated successfully
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateBlueprint: (
      blueprint: Blueprint,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/blueprints`,
        method: "PUT",
        body: blueprint,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  cancelaction = {
    /**
     * @description Creates a cancel action API object. Used to initiate cancel of K10 Action.
     *
     * @name cancelAction
     * @summary Creates a cancel action
     * @request POST:/cancelaction
     * @response `201` `CancelActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `string`
     */
    cancelAction: (
      action: CancelActionP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<CancelActionP, ErrorDetail | string>({
        path: `/cancelaction`,
        method: "POST",
        body: action,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  certs = {
    /**
     * @description Get public keys used to sign auth token
     *
     * @name getAuthCerts
     * @request GET:/certs
     * @response `200` `Blob`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getAuthCerts: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Blob, ErrorDetail>({
        path: `/certs`,
        method: "GET",
        format: "blob",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  cluster = {
    /**
     * No description
     *
     * @name listClusterResourcesDetails
     * @summary List cluster-scope resources with instances
     * @request GET:/cluster/details
     * @response `200` `K8SObjectListWithContinuation`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listClusterResourcesDetails: (
      query?: {
        /** Client-specified point within result to continue query. */
        continue?: string;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K8SObjectListWithContinuation, ErrorDetail>({
        path: `/cluster/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Used for checking if the cluster has keyless authentication.
     *
     * @name getKeylessAuth
     * @summary Status endpoint that is periodically queried by the frontend to check if the cluster has keyless authentication.
     * @request GET:/cluster/keylessAuth
     * @response `200` `KeylessAuth`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getKeylessAuth: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<KeylessAuth, ErrorDetail>({
        path: `/cluster/keylessAuth`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  clusterrestorepoint = {
    /**
     * @description Retires the specified cluster restore point object from catalog
     *
     * @name deleteClusterRestorePoint
     * @summary Retires a cluster restore point object
     * @request DELETE:/clusterrestorepoint
     * @response `200` `void` Cluster Restore Point retired
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteClusterRestorePoint: (
      query: {
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/clusterrestorepoint`,
        method: "DELETE",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets a list of the cluster restore point API objects for cluster-scope resources in the specified date range. It's allowed to set only the beginning or only the end of the date range. If the date range is omitted, gets all the restore points.
     *
     * @name getClusterRestorePointObjects
     * @summary Get cluster restore point objects
     * @request GET:/clusterrestorepoint
     * @response `200` `ClusterRestorePointObjectList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getClusterRestorePointObjects: (
      query?: {
        /**
         * Limits the resulting objects to be at least this date
         * @format date-time
         */
        dateFrom?: string;
        /**
         * Limits the resulting objects to be at most this date
         * @format date-time
         */
        dateTo?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRestorePointObjectList, ErrorDetail>({
        path: `/clusterrestorepoint`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns detailed information on a cluster restore point
     *
     * @name getClusterRestorePointDetails
     * @summary Get cluster restore point API details
     * @request GET:/clusterrestorepoint/details
     * @response `200` `ClusterRestorePointAPI`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getClusterRestorePointDetails: (
      query: {
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterRestorePointAPI, ErrorDetail>({
        path: `/clusterrestorepoint/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  compatibleprofilesCr = {
    /**
     * @description Get list of profiles compatible with the given migration string
     *
     * @name getCompatibleProfilesCr
     * @summary Get list of profiles compatible with the given migration string
     * @request GET:/compatibleprofilesCR/{namespace}
     * @response `200` `ProfileCRList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getCompatibleProfilesCr: (
      namespace: string,
      query: {
        /** Base64 encoded migration string */
        encodedString: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCRList, ErrorDetail>({
        path: `/compatibleprofilesCR/${namespace}`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  compliance = {
    /**
     * @description Gets compliance information for a k10 protected object
     *
     * @name getCompliance
     * @summary Gets compliance information for a k10 protected object
     * @request GET:/compliance/{itemId}
     * @response `200` `Compliance`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getCompliance: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Compliance, ErrorDetail>({
        path: `/compliance/${itemId}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  compliancedata = {
    /**
     * @description Gets dashboard data for populating compliance stats.
     *
     * @name getComplianceData
     * @summary Dashboard compliance data
     * @request GET:/compliancedata
     * @response `200` `DashboardComplianceData`
     * @response `default` `ErrorDetail`
     */
    getComplianceData: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<DashboardComplianceData, ErrorDetail>({
        path: `/compliancedata`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  configmap = {
    /**
     * No description
     *
     * @name getConfigMap
     * @summary Get detailed info about a specific config map
     * @request GET:/configmap/{namespace}/{name}
     * @response `200` `ConfigMap`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getConfigMap: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ConfigMap, ErrorDetail>({
        path: `/configmap/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  decryptdata = {
    /**
     * No description
     *
     * @name decryptData
     * @summary Decrypt the given encrypted data
     * @request POST:/decryptdata
     * @response `200` `DecryptedData`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    decryptData: (
      encryptedData: EncryptedData,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DecryptedData, ErrorDetail>({
        path: `/decryptdata`,
        method: "POST",
        body: encryptedData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  decryptdatawithpurpose = {
    /**
     * No description
     *
     * @name decryptDataWithPurpose
     * @summary Decrypt the given encrypted data with a key derived from a purpose
     * @request POST:/decryptdatawithpurpose
     * @response `200` `DecryptedData`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    decryptDataWithPurpose: (
      encryptedDataWithKeyDetails: EncryptedDataWithKeyDetails,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DecryptedData, ErrorDetail>({
        path: `/decryptdatawithpurpose`,
        method: "POST",
        body: encryptedDataWithKeyDetails,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  derivekey = {
    /**
     * No description
     *
     * @name deriveKey
     * @summary Derives a new encryption key from the K10 master key for the specified purpose
     * @request POST:/derivekey
     * @response `200` `DerivedKey`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deriveKey: (
      spec: DeriveKeySpec,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DerivedKey, ErrorDetail>({
        path: `/derivekey`,
        method: "POST",
        body: spec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  encryptdata = {
    /**
     * No description
     *
     * @name encryptData
     * @summary Encrypt the given data
     * @request POST:/encryptdata
     * @response `200` `EncryptedData`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    encryptData: (
      decryptedData: DecryptedData,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<EncryptedData, ErrorDetail>({
        path: `/encryptdata`,
        method: "POST",
        body: decryptedData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  encryptdatawithrandompurpose = {
    /**
     * No description
     *
     * @name encryptDataWithRandomPurpose
     * @summary Encrypt the given data with a key derived from a random purpose
     * @request POST:/encryptdatawithrandompurpose
     * @response `200` `EncryptedDataWithKeyDetails`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    encryptDataWithRandomPurpose: (
      decryptedData: DecryptedData,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<EncryptedDataWithKeyDetails, ErrorDetail>({
        path: `/encryptdatawithrandompurpose`,
        method: "POST",
        body: decryptedData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  eula = {
    /**
     * @description Gets the EULA text
     *
     * @name getEula
     * @summary Gets the EULA text
     * @request GET:/eula
     * @response `200` `EULAText`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getEula: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<EULAText, ErrorDetail>({
        path: `/eula`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Accepts the EULA and sets the user/company
     *
     * @name updateEula
     * @summary Accepts the EULA and sets the user/company
     * @request PUT:/eula
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateEula: (
      userInfo: UserEULAInfo,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/eula`,
        method: "PUT",
        body: userInfo,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  events = {
    /**
     * @description Deletes an event specified by Action and Source
     *
     * @name deleteEventByGroupName
     * @summary Deletes a K10 event
     * @request DELETE:/events
     * @response `204` `void` Event deleted successfully.
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteEventByGroupName: (
      query?: {
        /** Action field for identifying an event */
        action?: string;
        /** Source field for identifying an event */
        source?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/events`,
        method: "DELETE",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets a list of outstanding events flagged by K10
     *
     * @name listEvents
     * @summary Get a list of K10Events
     * @request GET:/events
     * @response `200` `EventList`
     * @response `default` `ErrorDetail`
     */
    listEvents: (
      query?: {
        /** Action field for identifying an event */
        action?: string;
        /** Source field for identifying an event */
        source?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<EventList, ErrorDetail>({
        path: `/events`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds an event to the system
     *
     * @name addEvent
     * @summary Adds an Event
     * @request POST:/events
     * @response `201` `EventGroup`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    addEvent: (eventItem: Event, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<EventGroup, ErrorDetail>({
        path: `/events`,
        method: "POST",
        body: eventItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes an individual event with the given ID
     *
     * @name deleteEvent
     * @summary Deletes an event
     * @request DELETE:/events/{itemId}
     * @response `204` `void` Event deleted successfully.
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteEvent: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<void, ErrorDetail>({
        path: `/events/${itemId}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets event with the given ID
     *
     * @name getEvent
     * @summary Gets an event
     * @request GET:/events/{itemId}
     * @response `200` `EventGroup`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getEvent: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<EventGroup, ErrorDetail>({
        path: `/events/${itemId}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Updates an event in the system
     *
     * @name updateEvent
     * @summary Updates an existing event
     * @request PUT:/events/{itemId}
     * @response `200` `EventGroup`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateEvent: (
      itemId: string,
      eventItem: Event,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<EventGroup, ErrorDetail>({
        path: `/events/${itemId}`,
        method: "PUT",
        body: eventItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  exportaction = {
    /**
     * @description Creates an export action API object
     *
     * @name exportAction
     * @summary Creates an export action
     * @request POST:/exportaction
     * @response `201` `ExportActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    exportAction: (
      spec: MigrateSpec,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ExportActionP, ErrorDetail>({
        path: `/exportaction`,
        method: "POST",
        body: spec,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  healthz = {
    /**
     * @description Checks if the service is running
     *
     * @name healthz
     * @summary Service liveness check
     * @request GET:/healthz
     * @response `200` `ServiceInfo`
     * @response `default` `ErrorDetail`
     */
    healthz: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ServiceInfo, ErrorDetail>({
        path: `/healthz`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  jobs = {
    /**
     * @description Lists the jobs that exist in the system
     *
     * @name listJobs
     * @summary Lists existing jobs
     * @request GET:/jobs
     * @response `200` `JobList`
     * @response `default` `ErrorDetail`
     */
    listJobs: (
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<JobList, ErrorDetail>({
        path: `/jobs`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a job to the system
     *
     * @name addJob
     * @summary Adds a job
     * @request POST:/jobs
     * @response `201` `Job`
     * @response `400` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    addJob: (jobItem: Job, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Job, ErrorDetail>({
        path: `/jobs`,
        method: "POST",
        body: jobItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns jobs based on the search criteria
     *
     * @name searchJobs
     * @summary Search for jobs
     * @request GET:/jobs/search
     * @response `200` `JobList`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    searchJobs: (
      query?: {
        /** A predefined query key */
        key?: string;
        /** The query key value */
        value?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<JobList, ErrorDetail>({
        path: `/jobs/search`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the definition of an individual job with the given id
     *
     * @name deleteJob
     * @summary Deletes a job
     * @request DELETE:/jobs/{itemId}
     * @response `200` `Job`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteJob: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Job, ErrorDetail>({
        path: `/jobs/${itemId}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets the definition of an individual job with the given id
     *
     * @name getJob
     * @summary Gets info for a job
     * @request GET:/jobs/{itemId}
     * @response `200` `Job`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getJob: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Job, ErrorDetail>({
        path: `/jobs/${itemId}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a job to the system
     *
     * @name updateJob
     * @summary Updates an existing job
     * @request PUT:/jobs/{itemId}
     * @response `200` `Job`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateJob: (
      itemId: string,
      jobItem: Job,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Job, ErrorDetail>({
        path: `/jobs/${itemId}`,
        method: "PUT",
        body: jobItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  jobsGetOrAdd = {
    /**
     * @description Gets an existing job or the job to the system
     *
     * @name getOrAddJob
     * @summary Gets and existing job or adds the job
     * @request POST:/jobs:getOrAdd
     * @response `201` `Job`
     * @response `400` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getOrAddJob: (
      getOrAdd: string,
      jobItem: Job,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Job, ErrorDetail>({
        path: `/jobs${getOrAdd}`,
        method: "POST",
        body: jobItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  k10HealthCheck = {
    /**
     * No description
     *
     * @name k10HealthCheck
     * @request GET:/k10HealthCheck
     * @response `200` `K10HealthCheck`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    k10HealthCheck: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<K10HealthCheck, ErrorDetail>({
        path: `/k10HealthCheck`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  license = {
    /**
     * @description Creates a license with the passed license body (as xml or base64 encoded string)
     *
     * @name createLicense
     * @summary Creates a license
     * @request POST:/license
     * @response `201` `LicenseResponse`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createLicense: (
      licenseData: LicenseData,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<LicenseResponse, ErrorDetail>({
        path: `/license`,
        method: "POST",
        body: licenseData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Deletes the license with passes licenseID
     *
     * @name deleteLicense
     * @summary Deletes the license
     * @request DELETE:/license/{licenseid}
     * @response `200` `DeleteLicense`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteLicense: (
      licenseid: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DeleteLicense, ErrorDetail>({
        path: `/license/${licenseid}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get a license by license ID
     *
     * @name getLicense
     * @summary Get a license
     * @request GET:/license/{licenseid}
     * @response `200` `License`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getLicense: (licenseid: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<License, ErrorDetail>({
        path: `/license/${licenseid}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Update a license
     *
     * @name updateLicense
     * @summary Update a license
     * @request PUT:/license/{licenseid}
     * @response `200` `LicenseResponse`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateLicense: (
      licenseid: string,
      licenseData: LicenseData,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<LicenseResponse, ErrorDetail>({
        path: `/license/${licenseid}`,
        method: "PUT",
        body: licenseData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  licenseStatus = {
    /**
     * @description Returns the current licensing status
     *
     * @name getLicenseStatus
     * @summary Returns the current licensing status
     * @request GET:/licenseStatus
     * @response `200` `LicenseStatus`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getLicenseStatus: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<LicenseStatus, ErrorDetail>({
        path: `/licenseStatus`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  licenses = {
    /**
     * @description Returns all the licenses with all the details
     *
     * @name listLicenses
     * @summary Returns all the licenses (valid/invalid) with details
     * @request GET:/licenses
     * @response `200` `ListLicenses`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listLicenses: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ListLicenses, ErrorDetail>({
        path: `/licenses`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  limiter = {
    /**
     * @description Return rate limiter tokens previously gotten for limited operation
     *
     * @name returnLimiterTokens
     * @summary Return tokens for limited operation
     * @request DELETE:/limiter/{operation}
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    returnLimiterTokens: (
      operation: string,
      tags: LimiterTagsP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/limiter/${operation}`,
        method: "DELETE",
        body: tags,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get rate limiter tokens for limited operation
     *
     * @name getLimiterTokens
     * @summary Get tokens for limited operation
     * @request POST:/limiter/{operation}
     * @response `201` `LimiterResponse`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getLimiterTokens: (
      operation: string,
      query: {
        /** Count of tokens to acquire */
        count: number;
      },
      tags: LimiterTagsP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<LimiterResponse, ErrorDetail>({
        path: `/limiter/${operation}`,
        method: "POST",
        query: query,
        body: tags,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  listScrapeTargets = {
    /**
     * @description Get the list of scrape targets
     *
     * @name listScrapeTargets
     * @summary Get the list of scrape targets
     * @request GET:/listScrapeTargets
     * @response `200` `PrometheusScrapeTargets`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listScrapeTargets: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PrometheusScrapeTargets, ErrorDetail>({
        path: `/listScrapeTargets`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  log = {
    /**
     * @description Record a log message from the frontend
     *
     * @name logMessage
     * @summary Records a log message
     * @request POST:/log
     * @response `201` `void` Message was logged
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    logMessage: (
      logEntry: LogMessage,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/log`,
        method: "POST",
        body: logEntry,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  login = {
    /**
     * @description Creates a cookie that wraps Bearer token
     *
     * @name login
     * @summary Login using K8s token
     * @request POST:/login
     * @response `200` `any`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    login: (token: LoginPayload, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<any, ErrorDetail>({
        path: `/login`,
        method: "POST",
        body: token,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  logout = {
    /**
     * @description Invalidates cookies/headers set by login
     *
     * @name logout
     * @summary Logout of K10
     * @request POST:/logout
     * @response `200` `any`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    logout: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<any, ErrorDetail>({
        path: `/logout`,
        method: "POST",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  mc = {
    /**
     * No description
     *
     * @name listBootstraps
     * @summary Returns a list of bootstrap objects
     * @request GET:/mc/bootstraps
     * @response `200` `BootstrapList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listBootstraps: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<BootstrapList, ErrorDetail>({
        path: `/mc/bootstraps`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createBootstrap
     * @summary Creates a new bootstrap
     * @request POST:/mc/bootstraps
     * @response `200` `Bootstrap`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createBootstrap: (
      Bootstrap: Bootstrap,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Bootstrap, ErrorDetail>({
        path: `/mc/bootstraps`,
        method: "POST",
        body: Bootstrap,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createBootstrapWithSecret
     * @summary Creates a new bootstrap and secret
     * @request POST:/mc/bootstraps/create-with-secret
     * @response `200` `Bootstrap`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createBootstrapWithSecret: (
      BootstrapWithSecret: BootstrapWithSecretParams,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Bootstrap, ErrorDetail>({
        path: `/mc/bootstraps/create-with-secret`,
        method: "POST",
        body: BootstrapWithSecret,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteBootstrap
     * @summary Delete the specified bootstrap
     * @request DELETE:/mc/bootstraps/{name}
     * @response `200` `Bootstrap`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteBootstrap: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Bootstrap, ErrorDetail>({
        path: `/mc/bootstraps/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getBootstrap
     * @summary Get the specified bootstrap
     * @request GET:/mc/bootstraps/{name}
     * @response `200` `Bootstrap`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getBootstrap: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Bootstrap, ErrorDetail>({
        path: `/mc/bootstraps/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Lists the clusters in the system
     *
     * @name listClusters
     * @summary Returns list of clusters
     * @request GET:/mc/clusters
     * @response `200` `ClusterList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listClusters: (
      labelSelector: LabelSelectorList,
      query?: {
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ClusterList, ErrorDetail>({
        path: `/mc/clusters`,
        method: "GET",
        query: query,
        body: labelSelector,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteCluster
     * @summary Delete the specified cluster
     * @request DELETE:/mc/clusters/{name}
     * @response `204` `void` Cluster deleted successfully.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteCluster: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/clusters/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name mcConnectionHealth
     * @request GET:/mc/connectionHealth
     * @response `200` `K10HealthCheckEntry`
     * @response `default` `ErrorDetail`
     */
    mcConnectionHealth: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<K10HealthCheckEntry, ErrorDetail>({
        path: `/mc/connectionHealth`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name mcConnectionLastActive
     * @request GET:/mc/connectionLastActive
     * @response `200` `TimeStamp`
     * @response `default` `ErrorDetail`
     */
    mcConnectionLastActive: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<TimeStamp, ErrorDetail>({
        path: `/mc/connectionLastActive`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listDistributions
     * @summary Returns a list of distribution specifications
     * @request GET:/mc/distributions
     * @response `200` `DistributionList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listDistributions: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<DistributionList, ErrorDetail>({
        path: `/mc/distributions`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createDistribution
     * @summary Creates a new distribution
     * @request POST:/mc/distributions
     * @response `200` `Distribution`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createDistribution: (
      Distribution: Distribution,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Distribution, ErrorDetail>({
        path: `/mc/distributions`,
        method: "POST",
        body: Distribution,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteDistribution
     * @summary Delete the specified distribution
     * @request DELETE:/mc/distributions/{name}
     * @response `200` `Distribution`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteDistribution: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Distribution, ErrorDetail>({
        path: `/mc/distributions/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getDistribution
     * @summary Get the specified distribution
     * @request GET:/mc/distributions/{name}
     * @response `200` `Distribution`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getDistribution: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Distribution, ErrorDetail>({
        path: `/mc/distributions/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name updateDistribution
     * @summary Update the specified distribution
     * @request PUT:/mc/distributions/{name}
     * @response `200` `Distribution`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateDistribution: (
      name: string,
      Distribution: Distribution,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Distribution, ErrorDetail>({
        path: `/mc/distributions/${name}`,
        method: "PUT",
        body: Distribution,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name enqueueMsg
     * @summary Enqueue a message to be sent to the primary cluster
     * @request POST:/mc/enqueueMsg
     * @response `200` `void` Message added to queue
     * @response `503` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    enqueueMsg: (
      interClusterMsg: EnqueueMsgPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/enqueueMsg`,
        method: "POST",
        body: interClusterMsg,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name extClusterMsg
     * @summary Message from the primary cluster
     * @request POST:/mc/extClusterMsg
     * @response `200` `void` Message received
     * @response `400` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    extClusterMsg: (
      interClusterMsg: QueuedMsg,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/extClusterMsg`,
        method: "POST",
        body: interClusterMsg,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getMcInfo
     * @summary Get status and cluster info
     * @request GET:/mc/info
     * @response `200` `MCInfo`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getMcInfo: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<MCInfo, ErrorDetail>({
        path: `/mc/info`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteJoinConfig
     * @summary Delete the join config
     * @request DELETE:/mc/join
     * @response `200` `void` JoinConfig deleted
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteJoinConfig: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/join`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name joinCluster
     * @summary Join the cluster
     * @request POST:/mc/join
     * @response `201` `void` The request to join the cluster was successfully submitted.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    joinCluster: (
      JoinConfig: JoinConfig,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/join`,
        method: "POST",
        body: JoinConfig,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listJoinTokens
     * @summary Returns a list of joinToken objects
     * @request GET:/mc/joinTokens
     * @response `200` `JoinTokenList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listJoinTokens: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<JoinTokenList, ErrorDetail>({
        path: `/mc/joinTokens`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createJoinToken
     * @summary Creates a new joinToken
     * @request POST:/mc/joinTokens
     * @response `200` `JoinTokenInfo`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createJoinToken: (
      query: {
        /** Join token name */
        joinTokenName: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<JoinTokenInfo, ErrorDetail>({
        path: `/mc/joinTokens`,
        method: "POST",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteJoinToken
     * @summary Delete the specified joinToken
     * @request DELETE:/mc/joinTokens/{name}
     * @response `200` `void` JoinToken deleted
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteJoinToken: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/joinTokens/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listK10ClusterRoleBindings
     * @summary Returns a list of k10ClusterRoleBindings
     * @request GET:/mc/k10ClusterRoleBindings
     * @response `200` `K10ClusterRoleBindingList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listK10ClusterRoleBindings: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<K10ClusterRoleBindingList, ErrorDetail>({
        path: `/mc/k10ClusterRoleBindings`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createK10ClusterRoleBinding
     * @summary Creates a new k10ClusterRoleBinding
     * @request POST:/mc/k10ClusterRoleBindings
     * @response `200` `K10ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createK10ClusterRoleBinding: (
      K10ClusterRoleBinding: K10ClusterRoleBinding,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K10ClusterRoleBinding, ErrorDetail>({
        path: `/mc/k10ClusterRoleBindings`,
        method: "POST",
        body: K10ClusterRoleBinding,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteK10ClusterRoleBinding
     * @summary Delete the specified k10ClusterRoleBinding
     * @request DELETE:/mc/k10ClusterRoleBindings/{name}
     * @response `200` `K10ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteK10ClusterRoleBinding: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K10ClusterRoleBinding, ErrorDetail>({
        path: `/mc/k10ClusterRoleBindings/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getK10ClusterRoleBinding
     * @summary Get the specified k10ClusterRoleBinding
     * @request GET:/mc/k10ClusterRoleBindings/{name}
     * @response `200` `K10ClusterRoleBinding`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getK10ClusterRoleBinding: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K10ClusterRoleBinding, ErrorDetail>({
        path: `/mc/k10ClusterRoleBindings/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name updateK10ClusterRoleBinding
     * @summary Update the specified k10ClusterRoleBinding
     * @request PUT:/mc/k10ClusterRoleBindings/{name}
     * @response `200` `K10ClusterRoleBinding`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    updateK10ClusterRoleBinding: (
      name: string,
      K10ClusterRoleBinding: K10ClusterRoleBinding,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K10ClusterRoleBinding, ErrorDetail>({
        path: `/mc/k10ClusterRoleBindings/${name}`,
        method: "PUT",
        body: K10ClusterRoleBinding,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listK10ClusterRoles
     * @summary Returns a list of k10ClusterRoles
     * @request GET:/mc/k10ClusterRoles
     * @response `200` `K10ClusterRoleList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listK10ClusterRoles: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<K10ClusterRoleList, ErrorDetail>({
        path: `/mc/k10ClusterRoles`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getK10ClusterRole
     * @summary Get the specified k10ClusterRole
     * @request GET:/mc/k10ClusterRoles/{name}
     * @response `200` `K10ClusterRole`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getK10ClusterRole: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K10ClusterRole, ErrorDetail>({
        path: `/mc/k10ClusterRoles/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns multi cluster license usage information
     *
     * @name mcLicenseUsage
     * @summary Multi-cluster license usage
     * @request GET:/mc/licenseUsage
     * @response `200` `MCLicenseUsage`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    mcLicenseUsage: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<MCLicenseUsage, ErrorDetail>({
        path: `/mc/licenseUsage`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns multi cluster metrics
     *
     * @name mcMetrics
     * @summary Multi-cluster metrics
     * @request GET:/mc/metrics
     * @response `200` `MCMetrics`
     * @response `400` `ErrorDetail`
     * @response `500` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    mcMetrics: (
      query: {
        duration: "1h" | "1d" | "1w";
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<MCMetrics, ErrorDetail>({
        path: `/mc/metrics`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listPrimaryBootstrapInfo
     * @summary Returns a list of bootstrap objects
     * @request GET:/mc/primaryBootstrapInfo
     * @response `200` `BootstrapInfoList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listPrimaryBootstrapInfo: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<BootstrapInfoList, ErrorDetail>({
        path: `/mc/primaryBootstrapInfo`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name setupPrimary
     * @summary Make cluster primary
     * @request POST:/mc/setupPrimary
     * @response `201` `void` The request to make the cluster primary was successfully submitted.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    setupPrimary: (
      SetupPrimary: SetupPrimaryConfig,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/mc/setupPrimary`,
        method: "POST",
        body: SetupPrimary,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  metering = {
    /**
     * @description Get stats tracked by the metering service
     *
     * @name getMeteringStats
     * @summary Get stats tracked by the metering service
     * @request GET:/metering/stats
     * @response `200` `MeteringStats`
     * @response `default` `ErrorDetail`
     */
    getMeteringStats: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<MeteringStats, ErrorDetail>({
        path: `/metering/stats`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  monitoringSummary = {
    /**
     * @description Gets a summary of repositories being monitored by the repositories-svc
     *
     * @name monitoringSummary
     * @summary Get a summary of repositories being monitored
     * @request GET:/monitoringSummary
     * @response `200` `MonitoringSummary`
     * @response `default` `ErrorDetail`
     */
    monitoringSummary: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<MonitoringSummary, ErrorDetail>({
        path: `/monitoringSummary`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  namespaces = {
    /**
     * No description
     *
     * @name listNamespaces
     * @summary Lists namespaces that can be protected by K10
     * @request GET:/namespaces
     * @response `200` `NamespaceListResponseData`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listNamespaces: (
      query?: {
        /** When specified, indicates only live namespaces should be listed */
        live?: boolean;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<NamespaceListResponseData, ErrorDetail>({
        path: `/namespaces`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name createNamespace
     * @summary Creates a new namespace
     * @request POST:/namespaces
     * @response `201` `NamespaceInfo`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createNamespace: (
      name: CreateNamespacePayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<NamespaceInfo, ErrorDetail>({
        path: `/namespaces`,
        method: "POST",
        body: name,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Lists the namespaces that exist in the system
     *
     * @name listAllNamespaces
     * @summary Lists all namespaces
     * @request GET:/namespaces/all
     * @response `200` `NamespaceInfoList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listAllNamespaces: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<NamespaceInfoList, ErrorDetail>({
        path: `/namespaces/all`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  nodeExcludedViolation = {
    /**
     * @description Get the count of excluded nodes that have a workload PVC mounted
     *
     * @name getNodeExcludedViolation
     * @request GET:/nodeExcludedViolation
     * @response `200` `number`
     * @response `default` `ErrorDetail`
     */
    getNodeExcludedViolation: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<number, ErrorDetail>({
        path: `/nodeExcludedViolation`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  nodeUsageHistory = {
    /**
     * No description
     *
     * @name nodeUsageHistory
     * @request GET:/nodeUsageHistory
     * @response `200` `NodeUsageHistory`
     * @response `default` `ErrorDetail`
     */
    nodeUsageHistory: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<NodeUsageHistory, ErrorDetail>({
        path: `/nodeUsageHistory`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  objects = {
    /**
     * @description Returns all k10 objects wrappers containing platform objects that we can protect.
     *
     * @name listObjects
     * @summary Lists the k10 Objects
     * @request GET:/objects
     * @response `200` `ProtectedObjectList`
     * @response `default` `ErrorDetail`
     */
    listObjects: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ProtectedObjectList, ErrorDetail>({
        path: `/objects`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description returns a list of index values on k10 Objects
     *
     * @name listObjectsIndex
     * @summary Get Index Values on k10 objects
     * @request GET:/objects/index
     * @response `200` `IndexValueListWithContinuation`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listObjectsIndex: (
      query?: {
        /** A predefined query key */
        key?: string;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Client-specified point within result to continue query. */
        continue?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<IndexValueListWithContinuation, ErrorDetail>({
        path: `/objects/index`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns k10 objects based on the search criteria
     *
     * @name searchObjects
     * @summary Search for k10 objects
     * @request GET:/objects/search
     * @response `200` `ProtectedObjectList`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    searchObjects: (
      query?: {
        /** A predefined query key */
        key?: string;
        /** The query key value */
        value?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProtectedObjectList, ErrorDetail>({
        path: `/objects/search`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns k10 objects that match the selectors
     *
     * @name selectObjects
     * @summary Select k10 Objects
     * @request GET:/objects/select
     * @response `200` `ProtectedObjectList`
     * @response `501` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    selectObjects: (
      selector: Selector,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProtectedObjectList, ErrorDetail>({
        path: `/objects/select`,
        method: "GET",
        body: selector,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets the definition of an individual protected object with the given id.
     *
     * @name getObject
     * @summary Gets info for an protected object
     * @request GET:/objects/{itemId}
     * @response `200` `ProtectedObject`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getObject: (itemId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ProtectedObject, ErrorDetail>({
        path: `/objects/${itemId}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  oidc = {
    /**
     * @description Creates a cookie that wraps the OIDC bearer token
     *
     * @name oidcRedirect
     * @summary Redirect endpoint used by OIDC provider during login
     * @request GET:/oidc/redirect
     * @response `302` `any`
     * @response `401` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    oidcRedirect: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<any, ErrorDetail>({
        path: `/oidc/redirect`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  passkey = {
    /**
     * No description
     *
     * @name listPasskeys
     * @summary Lists passkeys in the catalog
     * @request GET:/passkey
     * @response `200` `PasskeyList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listPasskeys: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PasskeyList, ErrorDetail>({
        path: `/passkey`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name addPasskey
     * @summary Adds a passkey
     * @request POST:/passkey
     * @response `201` `PasskeyP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `409` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    addPasskey: (passkey: PasskeyP, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PasskeyP, ErrorDetail>({
        path: `/passkey`,
        method: "POST",
        body: passkey,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deletePasskey
     * @summary Deletes the specified passkey
     * @request DELETE:/passkey/{name}
     * @response `200` `PasskeyP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deletePasskey: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PasskeyP, ErrorDetail>({
        path: `/passkey/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getPasskey
     * @summary Gets a specific passkey from the catalog
     * @request GET:/passkey/{name}
     * @response `200` `PasskeyP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getPasskey: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<PasskeyP, ErrorDetail>({
        path: `/passkey/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  prevalidateProfile = {
    /**
     * @description Check if this profile might be saved
     *
     * @name prevalidateProfile
     * @summary Prevalidate profile
     * @request POST:/prevalidateProfile/{namespace}
     * @response `200` `Error`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    prevalidateProfile: (
      namespace: string,
      profileForm: ProfileCRForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Error, ErrorDetail>({
        path: `/prevalidateProfile/${namespace}`,
        method: "POST",
        body: profileForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  pushMetricAgg = {
    /**
     * @description Get aggregated metrics from sidecar
     *
     * @name getPushedAggMetrics
     * @summary Get aggregated metrics from sidecar
     * @request GET:/push-metric-agg/metrics
     * @response `200` `Blob` OK
     */
    getPushedAggMetrics: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Blob, any>({
        path: `/push-metric-agg/metrics`,
        method: "GET",
        format: "blob",
        ...params,
        headers: {
          Accept: "text/plain",
          ...params?.headers,
        },
      }),

    /**
     * @description Save and aggregate metrics
     *
     * @name pushAndAggregateMetrics
     * @summary Save and aggregate metrics
     * @request POST:/push-metric-agg/metrics/job/{jobId}/podName/{podName}
     * @response `200` `void` OK
     */
    pushAndAggregateMetrics: (
      jobId: string,
      podName: string,
      metrics: PushAndAggregateMetricsPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, any>({
        path: `/push-metric-agg/metrics/job/${jobId}/podName/${podName}`,
        method: "POST",
        body: metrics,
        type: ContentType.UrlEncoded,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Save and aggregate metrics
     *
     * @name replaceAndAggregateMetrics
     * @summary Save and aggregate metrics
     * @request PUT:/push-metric-agg/metrics/job/{jobId}/podName/{podName}
     * @response `200` `void` OK
     */
    replaceAndAggregateMetrics: (
      jobId: string,
      podName: string,
      metrics: ReplaceAndAggregateMetricsPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, any>({
        path: `/push-metric-agg/metrics/job/${jobId}/podName/${podName}`,
        method: "PUT",
        body: metrics,
        type: ContentType.UrlEncoded,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get raw(not aggregated) metrics
     *
     * @name getPushedMetrics
     * @summary Get raw metrics
     * @request GET:/push-metric-agg/raw-metrics
     * @response `200` `Array<PushedMetricFamily>`
     */
    getPushedMetrics: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Array<PushedMetricFamily>, any>({
        path: `/push-metric-agg/raw-metrics`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  queuedjobs = {
    /**
     * @description Deletes the specified job from the job queue
     *
     * @name deleteQueuedJob
     * @summary Deletes a queued job
     * @request DELETE:/queuedjobs
     * @response `200` `void` Queued job was deleted
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteQueuedJob: (
      itemId: DeleteQueuedJobPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/queuedjobs`,
        method: "DELETE",
        body: itemId,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets a job ID from the job queue
     *
     * @name getQueuedJob
     * @summary Gets a queued job
     * @request GET:/queuedjobs
     * @response `200` `QueuedJob`
     * @response `default` `ErrorDetail`
     */
    getQueuedJob: (
      query?: {
        /**
         * "Client-specified visibility timeout to apply to each queued job returned"
         * @format int64
         */
        visibilityTimeout?: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<QueuedJob, ErrorDetail>({
        path: `/queuedjobs`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Adds a job to the job queue
     *
     * @name addQueuedJob
     * @summary Adds a job to the job queue
     * @request POST:/queuedjobs
     * @response `201` `void` Job was queued
     * @response `409` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    addQueuedJob: (
      QueuedJobItem: QueuedJob,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/queuedjobs`,
        method: "POST",
        body: QueuedJobItem,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description "Sets CancelRequested in a queued job"
     *
     * @name cancelQueuedJob
     * @summary Request cancellation of a Queued Job
     * @request POST:/queuedjobs/cancel
     * @response `200` `void` Cancellation was successfully requested
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    cancelQueuedJob: (
      itemId: CancelQueuedJobPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/queuedjobs/cancel`,
        method: "POST",
        body: itemId,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description "Resets a queued jobs visibility timeout"
     *
     * @name resetQueuedJob
     * @summary Reset a Queued Job's Timeout
     * @request POST:/queuedjobs/reset
     * @response `200` `QueuedJob`
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    resetQueuedJob: (
      query: {
        /**
         * Client-specified visibility timeout to apply to each queued job returned.
         * The value is in nanoseconds, as this is the level of granularity that
         * time.Duration supports. The actual visibility timeout applied is
         * queue-implementation dependent, and likely to be rounded down to seconds
         * resolution.
         * @format int64
         */
        visibilityTimeout: number;
      },
      itemId: ResetQueuedJobPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<QueuedJob, ErrorDetail>({
        path: `/queuedjobs/reset`,
        method: "POST",
        query: query,
        body: itemId,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  recordMetrics = {
    /**
     * No description
     *
     * @name recordMetrics
     * @summary Record metric items for metering
     * @request POST:/recordMetrics
     * @response `201` `void` Metering items were recorded
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    recordMetrics: (
      meteringItems: RecordMetricsPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/recordMetrics`,
        method: "POST",
        body: meteringItems,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  redirect = {
    /**
     * @description Logs in and redirects to an URL
     *
     * @name redirect
     * @summary Login using temporary token and redirect
     * @request GET:/redirect
     * @response `302` `any`
     * @response `401` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    redirect: (
      query: {
        /** Temporary token with info on login and redirect */
        token: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<any, ErrorDetail>({
        path: `/redirect`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  regionList = {
    /**
     * @description Get the list of regions for a given storage type
     *
     * @name regionList
     * @summary Get the list of regions
     * @request GET:/regionList
     * @response `200` `Array<string>`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    regionList: (
      query: {
        storageType: "AD" | "EBS" | "GPD";
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Array<string>, ErrorDetail>({
        path: `/regionList`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  repoOps = {
    /**
     * @description Run the specified procedure against a repository. If ItemId param is provided, name and namespace are ignored. If no params are provided, operation will run on all known repositories.
     *
     * @name repoOperation
     * @summary Run a repository operation
     * @request POST:/repoOps/{repoProcedureType}
     * @response `204` `void` Operation request received successfully.
     * @response `400` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    repoOperation: (
      repoProcedureType: string,
      query?: {
        /**
         * Item uuid for a request
         * @format uuid
         */
        itemId?: string;
        /** Namespace to query */
        namespace?: string;
        /** Name to query */
        name?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/repoOps/${repoProcedureType}`,
        method: "POST",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  reportaction = {
    /**
     * @description Creates a report action API object
     *
     * @name reportAction
     * @summary Creates a report action
     * @request POST:/reportaction
     * @response `201` `ReportActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    reportAction: (
      action: ReportActionP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ReportActionP, ErrorDetail>({
        path: `/reportaction`,
        method: "POST",
        body: action,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  reports = {
    /**
     * @description List K10 reports including full detailed results.
     *
     * @name listReports
     * @summary List K10 reports.
     * @request GET:/reports
     * @response `200` `Array<Report>`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listReports: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Array<Report>, ErrorDetail>({
        path: `/reports`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name deleteReport
     * @summary Delete a K10 report.
     * @request DELETE:/reports/{name}
     * @response `204` `void` No content to return.
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteReport: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<void, ErrorDetail>({
        path: `/reports/${name}`,
        method: "DELETE",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getReport
     * @summary Get a single K10 Report.
     * @request GET:/reports/{name}
     * @response `200` `Report`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getReport: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Report, ErrorDetail>({
        path: `/reports/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  requestRedirect = {
    /**
     * @description Creates an URL with temporary token for redirect without explicit authorization
     *
     * @name requestRedirect
     * @summary Creates a request with temporary authentication
     * @request POST:/requestRedirect
     * @response `200` `string`
     * @response `401` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    requestRedirect: (
      RequestRedirectURL: RequestRedirectPayload,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<string, ErrorDetail>({
        path: `/requestRedirect`,
        method: "POST",
        body: RequestRedirectURL,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  resources = {
    /**
     * No description
     *
     * @name listResources
     * @summary List application resource types
     * @request GET:/resources
     * @response `200` `GroupVersionResourceList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listResources: (
      query?: {
        /** If set, return cluster-scope resources (defaults to namespaced) */
        clusterScope?: boolean;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<GroupVersionResourceList, ErrorDetail>({
        path: `/resources`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  restoreaction = {
    /**
     * @description Creates a restore action API object
     *
     * @name restoreAction
     * @summary Creates a restore action
     * @request POST:/restoreaction
     * @response `201` `K8SObject`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    restoreAction: (
      restoreData: RestoreForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K8SObject, ErrorDetail>({
        path: `/restoreaction`,
        method: "POST",
        body: restoreData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Creates a batch restore action API object
     *
     * @name batchRestoreAction
     * @summary Creates a batch restore action
     * @request POST:/restoreaction/batch
     * @response `201` `BatchRestoreActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    batchRestoreAction: (
      restoreParams: BatchRestoreParameters,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<BatchRestoreActionP, ErrorDetail>({
        path: `/restoreaction/batch`,
        method: "POST",
        body: restoreParams,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get actions subordinate to a BatchRestoreAction
     *
     * @name listBatchRestoreSubordinateActions
     * @summary Get actions subordinate to a BatchRestoreAction
     * @request GET:/restoreaction/batch/subordinates
     * @response `200` `DashboardActionList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listBatchRestoreSubordinateActions: (
      query: {
        /** Object to query */
        name: string;
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Used to filter return values. */
        filter?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DashboardActionList, ErrorDetail>({
        path: `/restoreaction/batch/subordinates`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Dry run with filters for restore action and returns restore point content details that describe artifacts that would be restored if the restore action is created.
     *
     * @name restoreActionDryRun
     * @summary Dry run restore action to determine what will be restored if the restore action is created.
     * @request POST:/restoreaction/dryRun
     * @response `200` `RestorePointContentAPI`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    restoreActionDryRun: (
      restoreData: RestoreForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointContentAPI, ErrorDetail>({
        path: `/restoreaction/dryRun`,
        method: "POST",
        body: restoreData,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  restoreclusteraction = {
    /**
     * @description Creates a restore cluster action API object
     *
     * @name restoreClusterAction
     * @summary Creates a restore cluster action
     * @request POST:/restoreclusteraction
     * @response `201` `RestoreClusterActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    restoreClusterAction: (
      action: RestoreClusterActionP,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestoreClusterActionP, ErrorDetail>({
        path: `/restoreclusteraction`,
        method: "POST",
        body: action,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  restorepoint = {
    /**
     * @description Gets a list of the possible restore point API objects for an app in the specified date range. It's allowed to set only the beginning or only the end of the date range. If the date range is omitted, gets all the restore points.
     *
     * @name getRestorePointObjects
     * @summary Get restore points for app
     * @request GET:/restorepoint
     * @response `200` `RestorePointObjectList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getRestorePointObjects: (
      query: {
        /** Application name */
        appName: string;
        /** Application type (optional) */
        appType?: string;
        /** Object to query */
        namespace: string;
        /**
         * Limits the resulting objects to be at least this date
         * @format date-time
         */
        dateFrom?: string;
        /**
         * Limits the resulting objects to be at most this date
         * @format date-time
         */
        dateTo?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointObjectList, ErrorDetail>({
        path: `/restorepoint`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Creates RestorePoints from given RestorePointContentList in the given namespace
     *
     * @name createRestorePoints
     * @summary Creates Restore Points
     * @request POST:/restorepoint
     * @response `201` `RestorePointObjectList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    createRestorePoints: (
      restorePointCreateForm: RestorePointCreateForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointObjectList, ErrorDetail>({
        path: `/restorepoint`,
        method: "POST",
        body: restorePointCreateForm,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns detailed information on a restore point
     *
     * @name getRestorePointDetails
     * @summary Get restore point API details
     * @request GET:/restorepoint/details
     * @response `200` `(RestorePointAPI & {
     *   \* $1* Warning message about potential restore point issues. Empty if no issues are detected. *\
     *     warning?: string,
     * })`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getRestorePointDetails: (
      query: {
        /** Object to query */
        namespace: string;
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<
        RestorePointAPI & {
          /** Warning message about potential restore point issues. Empty if no issues are detected. */
          warning?: string;
        },
        ErrorDetail
      >({
        path: `/restorepoint/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  restorepointcontent = {
    /**
     * @description Retires the specified restore point content object from catalog
     *
     * @name deleteRestorePointContent
     * @summary Retires a restore point content object
     * @request DELETE:/restorepointcontent
     * @response `200` `void` Restore Point Content retired
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    deleteRestorePointContent: (
      query: {
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<void, ErrorDetail>({
        path: `/restorepointcontent`,
        method: "DELETE",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets a list of the restore point content API objects for an app in the specified date range. It's allowed to set only the beginning or only the end of the date range. If the date range is omitted, gets all the restore point content objects.
     *
     * @name getRestorePointContentObjects
     * @summary Get restore point content objects for app
     * @request GET:/restorepointcontent
     * @response `200` `RestorePointContentObjectList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getRestorePointContentObjects: (
      query: {
        /** Application name */
        appName: string;
        /** Application type (optional) */
        appType?: string;
        /** Object to query */
        namespace: string;
        /**
         * Limits the resulting objects to be at least this date
         * @format date-time
         */
        dateFrom?: string;
        /**
         * Limits the resulting objects to be at most this date
         * @format date-time
         */
        dateTo?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RestorePointContentObjectList, ErrorDetail>({
        path: `/restorepointcontent`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Returns detailed information on a restore point
     *
     * @name getRestorePointContentDetails
     * @summary Get restore point content API details
     * @request GET:/restorepointcontent/details
     * @response `200` `(RestorePointContentAPI & {
     *   \* $1* Warning message about potential restore point issues. Empty if no issues are detected. *\
     *     warning?: string,
     * })`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getRestorePointContentDetails: (
      query: {
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<
        RestorePointContentAPI & {
          /** Warning message about potential restore point issues. Empty if no issues are detected. */
          warning?: string;
        },
        ErrorDetail
      >({
        path: `/restorepointcontent/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  run = {
    /**
     * @description Runs BLM on all repositories
     *
     * @name runBlm
     * @summary Run BLM on all repositories
     * @request POST:/run
     * @response `204` `void` BLM ran successfully.
     * @response `default` `ErrorDetail`
     */
    runBlm: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<void, ErrorDetail>({
        path: `/run`,
        method: "POST",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  runaction = {
    /**
     * @description Creates a policy run action API object. Used for 'Run Now'.
     *
     * @name runAction
     * @summary Creates a run action
     * @request POST:/runaction
     * @response `201` `RunActionP`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    runAction: (action: RunActionP, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<RunActionP, ErrorDetail>({
        path: `/runaction`,
        method: "POST",
        body: action,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  runactions = {
    /**
     * @description Gets details for a K10 runaction
     *
     * @name getRunActionDetails
     * @summary Get details for a K10 runaction
     * @request GET:/runactions/details
     * @response `200` `RunAction`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getRunActionDetails: (
      query: {
        /** Object to query */
        name: string;
        /** Object to query */
        namespace: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<RunAction, ErrorDetail>({
        path: `/runactions/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get actions subordinate to a RunAction
     *
     * @name listSubordinateActions
     * @summary Get actions subordinate to a RunAction
     * @request GET:/runactions/subordinates
     * @response `200` `DashboardActionList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listSubordinateActions: (
      query: {
        /** Object to query */
        name: string;
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Used to filter return values. */
        filter?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<DashboardActionList, ErrorDetail>({
        path: `/runactions/subordinates`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  selectors = {
    /**
     * @description List all selectors
     *
     * @name listSelectors
     * @summary List all selectors
     * @request GET:/selectors
     * @response `200` `SelectorList`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listSelectors: (
      query?: {
        /** Namespace to query */
        namespace?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<SelectorList, ErrorDetail>({
        path: `/selectors`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  size = {
    /**
     * No description
     *
     * @name catalogFileSize
     * @request GET:/size
     * @response `200` `CatalogFileSize`
     * @response `default` `ErrorDetail`
     */
    catalogFileSize: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<CatalogFileSize, ErrorDetail>({
        path: `/size`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  snapshot = {
    /**
     * @description Get the snapshot storage usage in the system
     *
     * @name snapshotStorageUsage
     * @summary Get the snapshot storage usage in the system
     * @request GET:/snapshot/storage/usage
     * @response `200` `SnapshotStorageUsage`
     * @response `default` `ErrorDetail`
     */
    snapshotStorageUsage: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<SnapshotStorageUsage, ErrorDetail>({
        path: `/snapshot/storage/usage`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  snapshots = {
    /**
     * @description Get stats of snapshots in the system
     *
     * @name summarizeArtifacts
     * @summary Get stats of snapshots in the system
     * @request GET:/snapshots/stats
     * @response `200` `Stats`
     * @response `default` `ErrorDetail`
     */
    summarizeArtifacts: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Stats, ErrorDetail>({
        path: `/snapshots/stats`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get a summary of snapshots in the system
     *
     * @name getSnapshotsSummary
     * @summary Get a summary of snapshots in the system
     * @request GET:/snapshots/summary
     * @response `200` `SnapshotsSummary`
     * @response `default` `ErrorDetail`
     */
    getSnapshotsSummary: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<SnapshotsSummary, ErrorDetail>({
        path: `/snapshots/summary`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  stageaction = {
    /**
     * @description Creates a stage action API object
     *
     * @name stageAction
     * @summary Creates a stage action
     * @request POST:/stageaction
     * @response `201` `K8SObject`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    stageAction: (
      stageRestorePoint: StageForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K8SObject, ErrorDetail>({
        path: `/stageaction`,
        method: "POST",
        body: stageRestorePoint,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  storage = {
    /**
     * @description Get a summary of object storage sizes in the system
     *
     * @name getObjectStorageStats
     * @summary Get the usage metrics of object storage in the system
     * @request GET:/storage/objects/size
     * @response `200` `PromRangeQueryResponse`
     * @response `400` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getObjectStorageStats: (
      query: {
        /** Start timestamp in RFC 3339 format */
        start: string;
        /** End timestamp in RFC 3339 format */
        end: string;
        /** Query resolution step width in seconds */
        step: number;
        /** If set to true, split metrics per application in the response */
        perApplication?: boolean;
        /** Metrics type used to filter snapshot metrics */
        type: "logical" | "physical";
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PromRangeQueryResponse, ErrorDetail>({
        path: `/storage/objects/size`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get a summary of live PVC sizes in the system
     *
     * @name getPvcStats
     * @summary Get the usage metrics of live PVCs in the system
     * @request GET:/storage/pvcs/size
     * @response `200` `PromRangeQueryResponse`
     * @response `400` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getPvcStats: (
      query: {
        /** Start timestamp in RFC 3339 format */
        start: string;
        /** End timestamp in RFC 3339 format */
        end: string;
        /** Query resolution step width in seconds */
        step: number;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PromRangeQueryResponse, ErrorDetail>({
        path: `/storage/pvcs/size`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get a summary of snapshot storage in the system
     *
     * @name getSnapshotStats
     * @summary Get the usage metrics of snapshot storage in the system
     * @request GET:/storage/snapshots/size
     * @response `200` `PromRangeQueryResponse`
     * @response `400` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getSnapshotStats: (
      query: {
        /** Start timestamp in RFC 3339 format */
        start: string;
        /** End timestamp in RFC 3339 format */
        end: string;
        /** Query resolution step width in seconds */
        step: number;
        /** Metrics type used to filter snapshot metrics */
        type: "logical" | "physical";
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PromRangeQueryResponse, ErrorDetail>({
        path: `/storage/snapshots/size`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get a summary of storage in the system
     *
     * @name getStorageSummary
     * @summary Get a summary of storage in the system
     * @request GET:/storage/summary
     * @response `200` `StorageSummary`
     * @response `default` `ErrorDetail`
     */
    getStorageSummary: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<StorageSummary, ErrorDetail>({
        path: `/storage/summary`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  storageClass = {
    /**
     * @description Get the specified storage class
     *
     * @name storageClass
     * @summary Get the specified storage class
     * @request GET:/storageClass/{name}
     * @response `200` `StorageClass`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    storageClass: (name: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<StorageClass, ErrorDetail>({
        path: `/storageClass/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  storageClasses = {
    /**
     * @description Get the list of storage classes
     *
     * @name storageClasses
     * @summary Get the list of storage classes
     * @request GET:/storageClasses
     * @response `200` `StorageClassList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    storageClasses: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<StorageClassList, ErrorDetail>({
        path: `/storageClasses`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  storagerepositories = {
    /**
     * @description Gets a list of K10 backend storage repositories
     *
     * @name getStorageRepositories
     * @summary Get a list of storage repositories
     * @request GET:/storagerepositories
     * @response `200` `StorageRepositoryList`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getStorageRepositories: (
      query: {
        /** Object to query */
        namespace: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<StorageRepositoryList, ErrorDetail>({
        path: `/storagerepositories`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Gets details for a K10 storage repository
     *
     * @name getStorageRepositoryDetails
     * @summary Get storage repository API details
     * @request GET:/storagerepositories/details
     * @response `200` `StorageRepositoryAPI`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getStorageRepositoryDetails: (
      query: {
        /** Object to query */
        namespace: string;
        /** Object to query */
        name: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<StorageRepositoryAPI, ErrorDetail>({
        path: `/storagerepositories/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  supportLogs = {
    /**
     * No description
     *
     * @name triggerSupportLogs
     * @request GET:/supportLogs
     * @response `200` `string` Trigger support logs prep
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    triggerSupportLogs: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<string, ErrorDetail>({
        path: `/supportLogs`,
        method: "GET",
        format: "json",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name getSupportLogs
     * @request GET:/supportLogs/{runId}
     * @response `200` `Blob` Download support logs
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getSupportLogs: (runId: string, params?: RequestParams<HTTPClientParams>) =>
      this.http.request<Blob, ErrorDetail>({
        path: `/supportLogs/${runId}`,
        method: "GET",
        format: "blob",
        ...params,
        headers: {
          Accept: "application/octet-stream",
          ...params?.headers,
        },
      }),
  };
  systemInfo = {
    /**
     * No description
     *
     * @name systemInfo
     * @request GET:/systemInfo
     * @response `200` `SystemInfo`
     * @response `default` `ErrorDetail`
     */
    systemInfo: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<SystemInfo, ErrorDetail>({
        path: `/systemInfo`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  transform = {
    /**
     * @description Applies the specified transformation to the input spec
     *
     * @name applyTransform
     * @summary Applies the specified transformation to the input spec
     * @request POST:/transform/apply
     * @response `200` `JSONObject`
     * @response `400` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    applyTransform: (
      data: TransformParam,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<JSONObject, ErrorDetail>({
        path: `/transform/apply`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  upgradeInfo = {
    /**
     * No description
     *
     * @name upgradeInfo
     * @request GET:/upgradeInfo
     * @response `200` `UpgradeInfo`
     * @response `default` `ErrorDetail`
     */
    upgradeInfo: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<UpgradeInfo, ErrorDetail>({
        path: `/upgradeInfo`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  usage = {
    /**
     * @description Get stats on object store repository storage usage
     *
     * @name getReposUsage
     * @summary repository usage stats
     * @request GET:/usage/repos
     * @response `200` `ReposUsage`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getReposUsage: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<ReposUsage, ErrorDetail>({
        path: `/usage/repos`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  userInfo = {
    /**
     * No description
     *
     * @name userInfo
     * @request GET:/userInfo
     * @response `200` `UserInfo`
     * @response `default` `ErrorDetail`
     */
    userInfo: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<UserInfo, ErrorDetail>({
        path: `/userInfo`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  validateExistingPolicy = {
    /**
     * @description Validates an existing policy
     *
     * @name validateExistingPolicy
     * @summary Validate existing policy
     * @request GET:/validateExistingPolicy/{namespace}/{name}
     * @response `200` `PolicyCR`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    validateExistingPolicy: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyCR, ErrorDetail>({
        path: `/validateExistingPolicy/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  validatePolicyPreset = {
    /**
     * @description Validates an existing policy preset
     *
     * @name validatePolicyPreset
     * @summary Validate existing policy preset
     * @request GET:/validatePolicyPreset/{namespace}/{name}
     * @response `200` `PolicyPreset`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    validatePolicyPreset: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<PolicyPreset, ErrorDetail>({
        path: `/validatePolicyPreset/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  validateProfile = {
    /**
     * @description Validates an existing profile
     *
     * @name validateProfile
     * @summary Validate profile
     * @request GET:/validateProfile/{namespace}/{name}
     * @response `200` `ProfileCR`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    validateProfile: (
      namespace: string,
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<ProfileCR, ErrorDetail>({
        path: `/validateProfile/${namespace}/${name}`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  validateStorageClass = {
    /**
     * @description Triggers validation of the specified storage class
     *
     * @name validateStorageClass
     * @summary Triggers validation of the specified storage class
     * @request POST:/validateStorageClass/{name}
     * @response `200` `StorageClass`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    validateStorageClass: (
      name: string,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<StorageClass, ErrorDetail>({
        path: `/validateStorageClass/${name}`,
        method: "POST",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  validateaction = {
    /**
     * @description Creates a validate action API object
     *
     * @name validateAction
     * @summary Creates a validate action
     * @request POST:/validateaction
     * @response `201` `K8SObject`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `422` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    validateAction: (
      validateRestorePoint: ValidateForm,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<K8SObject, ErrorDetail>({
        path: `/validateaction`,
        method: "POST",
        body: validateRestorePoint,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  veeamVault = {
    /**
     * @description Implements the AWS container-credentials provider protocol (the target of AWS_CONTAINER_CREDENTIALS_FULL_URI), called directly by the kanister-tools worker pod's SDK on the auth-svc ClusterIP. The caller presents the action-lifecycle JWT in the Authorization header (raw token, no "Bearer" prefix). The endpoint verifies the token, performs the Entra ID -> AWS STS exchange, and returns temporary credentials in the EKS pod-identity response format. The SDK re-requests automatically as credentials approach expiry.
     *
     * @name getVeeamVaultAwsCredentials
     * @summary Vend temporary AWS credentials for a Veeam Vault AWS federated profile
     * @request GET:/veeamVault/aws/credentials
     * @response `200` `VeeamVaultAwsCredentials`
     * @response `401` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getVeeamVaultAwsCredentials: (params?: RequestParams<HTTPClientParams>) =>
      this.http.request<VeeamVaultAwsCredentials, ErrorDetail>({
        path: `/veeamVault/aws/credentials`,
        method: "GET",
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
  virtualmachines = {
    /**
     * No description
     *
     * @name listVirtualMachines
     * @summary Lists all the virtual machines in the cluster
     * @request GET:/virtualmachines
     * @response `200` `VirtualMachineList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listVirtualMachines: (
      query?: {
        /** Which field should be used to sort the VM response */
        sortBy?:
          | "name"
          | "namespace"
          | "status"
          | "freezeOS"
          | "lastBackupTimestamp";
        /** Whether the list should be sorted in ascending order. */
        sortDir?: "ASC" | "DESC";
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Used to filter virtual machines. Expected as JSON string conforming to VMFilter schema. Filtering is applied before pagination and sorting. */
        filter?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<VirtualMachineList, ErrorDetail>({
        path: `/virtualmachines`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name annotateVMs
     * @summary Annotates VirtualMachines with passed annotations
     * @request POST:/virtualmachines/annotate
     * @response `200` `Array<VMToAnnotateResponse>`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    annotateVMs: (
      VMsToAnnotate: VMsToAnnotate,
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<Array<VMToAnnotateResponse>, ErrorDetail>({
        path: `/virtualmachines/annotate`,
        method: "POST",
        body: VMsToAnnotate,
        type: ContentType.Json,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * @description Get details of a virtual machine
     *
     * @name getVmDetails
     * @summary Returns the related resources/details of a virtual machine
     * @request GET:/virtualmachines/details
     * @response `200` `VMDetails`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `404` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    getVmDetails: (
      query: {
        /** Name of the VM */
        name: string;
        /** Namespace of the VM, defaults to default if not provided */
        namespace: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<VMDetails, ErrorDetail>({
        path: `/virtualmachines/details`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),

    /**
     * No description
     *
     * @name listVirtualMachinesInNamespace
     * @summary Lists all the virtual machines in a namespace
     * @request GET:/virtualmachines/{namespace}
     * @response `200` `VirtualMachineList`
     * @response `400` `ErrorDetail`
     * @response `401` `ErrorDetail`
     * @response `403` `ErrorDetail`
     * @response `default` `ErrorDetail`
     */
    listVirtualMachinesInNamespace: (
      namespace: string,
      query?: {
        /** Which field should be used to sort the VM response */
        sortBy?:
          | "name"
          | "namespace"
          | "status"
          | "freezeOS"
          | "lastBackupTimestamp";
        /** Whether the list should be sorted in ascending order. */
        sortDir?: "ASC" | "DESC";
        /**
         * Number of items to skip in paginated responses
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * Client-specified maximum number of results to return in multi-item responses. This is an advisory parameter, the service implementation may return fewer results.
         * @format int32
         * @default 2147483647
         */
        limit?: number;
        /** Used to filter virtual machines. Expected as JSON string conforming to VMFilter schema. Filtering is applied before pagination and sorting. */
        filter?: string;
      },
      params?: RequestParams<HTTPClientParams>,
    ) =>
      this.http.request<VirtualMachineList, ErrorDetail>({
        path: `/virtualmachines/${namespace}`,
        method: "GET",
        query: query,
        ...params,
        headers: {
          Accept: "application/json",
          ...params?.headers,
        },
      }),
  };
}
